const translations = {
	validation: {
		required: "Este campo é obrigatório",
		invalidEmail: "Por favor, insira um endereço de e-mail válido",
		formErrors: "Por favor, corrija os seguintes erros:",
		minLength: "Deve ter pelo menos {{min}} caracteres",
		maxLength: "Deve ter no máximo {{max}} caracteres",
		invalidFormat: "Formato inválido",
		invalidDate: "Por favor, insira uma data válida",
		invalidNumber: "Por favor, insira um número válido",
		invalidPhone: "Por favor, insira um número de telefone válido",
		invalidPostalCode: "Por favor, insira um CEP válido",
		invalidBrazilianPostalCode: "Por favor, insira um CEP válido",
		passwordMismatch: "As senhas não coincidem",
		invalidIdNumber: "Por favor, insira um número de documento válido",
		invalidCPF: "Por favor, insira um CPF válido",
		futureDateOfBirth: "A data de nascimento não pode ser no futuro",
		idNumberRequired:
			"Número do documento é obrigatório quando o tipo de documento é selecionado",
	},
	common: {
		appName: "Pilates Time",
		loading: "Carregando...",
		viewAll: "Ver todos",
		error: "Ocorreu um erro",
		save: "Salvar",
		status: "Status",
		important: "Importante",
		createdAt: "Criado em",
		saving: "Salvando...",
		saveChanges: "Salvar Alterações",
		cancel: "Cancelar",
		delete: "Excluir",
		deleteSuccess: "Excluído com sucesso!",
		deleteError: "Falha ao excluir. Por favor, tente novamente.",
		edit: "Editar",
		create: "Criar",
		switch: "Trocar",
		createSuccess: "Criado com sucesso!",
		createError: "Falha ao criar. Por favor, tente novamente.",
		creating: "Criando...",
		update: "Atualizar",
		updateSuccess: "Atualizado com sucesso!",
		updateError: "Falha ao atualizar. Por favor, tente novamente.",
		updating: "Atualizando...",
		adding: "Adicionando...",
		assigning: "Atribuindo...",
		search: "Buscar",
		details: "Detalhes",
		noEnrollments: "Sem matrículas",
		language: "Idioma",
		minutes: "minutos",
		month: "mês",
		actions: "Ações",
		view_enrollment: "Ver Matrícula",
		open: "Aberto",
		closed: "Fechado",
		close: "Fechar",
		on: "LIGADO",
		off: "DESLIGADO",
		view: "Visualizar",
		previous: "Anterior",
		next: "Próximo",
		showing: "Exibindo",
		of: "de",
		entries: "entradas",
		page: "Página",
		noSearchResults: "Nenhum resultado encontrado para sua busca",
		deleting: "Excluindo...",
		back: "Voltar",
		typeToConfirm: "Digite '{{word}}' para confirmar:",
		typeWord: "Digite '{{word}}'",
		plan: "Plano",
		editEnrollment: "Editar Matrícula",
		payEnrollment: "Pagar Matrícula",
		statusFiltersApplied: "Filtros de Status Aplicados",
		upcomingBirthdays: "Próximos Aniversários",
		clear: "Limpar",
		filter: "Filtrar",
		show: "Mostrar",
		add: "Adicionar",
		hide: "Ocultar",
		continue: "Continuar",
		goHome: "Ir para Início",
		filters: "Filtros",
		apply: "Aplicar",
		reset: "Redefinir",
		signIn: "Entrar",
		signUp: "Criar Conta",
		dontHaveAccount: "Não tem uma conta?",
		total: "Total",
		signInRequired: "Você precisa estar logado para visualizar esta página",
		signInRequiredDescription: "Por favor, faça login para continuar",
		learnMore: "Saiba mais",
		comingSoon: "Em breve",
		underDevelopment: "Em Desenvolvimento",
		underDevelopmentDescription:
			"Esta funcionalidade está sendo desenvolvida. Volte em breve!",
		name: "Nome",
		description: "Descrição",
		quantity: "Qtd",
		address: "Endereço",
		phone: "Telefone",
		email: "Email",
		removing: "Removendo...",
		sending: "Enviando...",
		leaving: "Saindo...",
		revoking: "Revogando...",
		retry: "Tentar novamente",
		pleaseSpecify: "Por favor, especifique...",
		profileInformation: "Informações do Perfil",
		accountInformation: "Informações da Conta",
		viewYourAccountDetails: "Visualize suas informações de conta",
		updateYourPersonalInformation: "Atualize suas informações pessoais",
		userId: "ID do Usuário",
		memberSince: "Membro desde",
		lastSignIn: "Último login",
		never: "Nunca",
		select: "Selecionar",
		optional: "Opcional",
		yes: "Sim",
		no: "Não",
		emailCannotBeChanged: "O email não pode ser alterado",
		all: "Todos",
		selectAll: "Selecionar Todos",
		deselectAll: "Desmarcar Todos",
		sortByName: "Ordenar por Nome",
		sortByPrice: "Ordenar por Preço",
		sortBySessions: "Ordenar por Sessões",
		showingResults: "Mostrando {{count}} de {{total}} resultados",
		showMore: "Mostrar Mais",
		remaining: "restantes",
		remove: "Remover",
		createSchedule: "Novo Horário",
		selectSchedules: "Selecione os Horários",
		selectSchedulesEnrollmentDescription:
			"Selecione um ou mais horários para esta matrícula",
		existingSchedules: "Horários Existentes",
		noSchedules: "Nenhum horário encontrado",
		noSchedulesDescription: "Nenhum horário encontrado. Crie um novo?",
		establishment: "Unidade",
		customer: "Cliente",
		group: "Grupo",
		current: "Atual",
		individual: "Individual",
		time: "Horário",
		renewals: "Renovações",
		enrollments: "Matrículas",
		schedule: "Horário",
		schedules: "Horários",
		weeklySessionsLimit: "Limite de Sessões Semanais",
		price: "Preço",
		monthlyAverage: "Média Mensal",
		billingCycle: "Ciclo de Pagamento",
		features: "Recursos",
		type: "Tipo",
		period: "Período",
		to: "para",
		monday: "Segunda-feira",
		tuesday: "Terça-feira",
		wednesday: "Quarta-feira",
		thursday: "Quinta-feira",
		friday: "Sexta-feira",
		saturday: "Sábado",
		sunday: "Domingo",
		daysOfWeekShort: {
			monday: "Seg",
			tuesday: "Ter",
			wednesday: "Qua",
			thursday: "Qui",
			friday: "Sex",
			saturday: "Sáb",
			sunday: "Dom",
		},
		starter: "Iniciante",
		professional: "Profissional",
		enterprise: "Empresarial",
		planLimitExceeded:
			"Você atingiu o limite do seu plano atual. Por favor, faça upgrade do seu plano para continuar.",
		template: "Modelo",
		variables: "Variáveis",
		noData: "Sem resultados",
		dismiss: "Dispensar",
		selected: "Selecionado",
		filled: "Preenchido",

		// Toast messages
		toasts: {
			creating: "Criando...",
			createSuccess: "Criado com sucesso!",
			createError: "Falha ao criar. Tente novamente.",
			updating: "Atualizando...",
			updateSuccess: "Atualizado com sucesso!",
			updateError: "Falha ao atualizar. Tente novamente.",
			deleting: "Excluindo...",
			deleteSuccess: "Excluído com sucesso!",
			deleteError: "Falha ao excluir. Tente novamente.",
			inviting: "Enviando convite...",
			inviteSuccess: "Convite enviado com sucesso!",
			inviteError: "Falha ao enviar convite. Tente novamente.",
			accepting: "Aceitando convite...",
			acceptSuccess: "Convite aceito com sucesso!",
			acceptError: "Falha ao aceitar convite. Tente novamente.",
			revoking: "Revogando convite...",
			revokeSuccess: "Convite revogado com sucesso!",
			revokeError: "Falha ao revogar convite. Tente novamente.",
			establishmentDeleting: "Excluindo unidade...",
			establishmentDeleted: "Unidade excluída com sucesso!",
			establishmentDeleteError: "Falha ao excluir unidade. Tente novamente.",
			establishmentCreating: "Criando unidade...",
			establishmentCreated: "Unidade criado com sucesso!",
			establishmentCreateError: "Falha ao criar unidade. Tente novamente.",
			establishmentUpdating: "Atualizando unidade...",
			establishmentUpdated: "Unidade atualizado com sucesso!",
			establishmentUpdateError: "Falha ao atualizar unidade. Tente novamente.",
		},
		errors: {
			generic: "Ocorreu um erro inesperado. Tente novamente.",
			network: "Erro de rede. Verifique sua conexão.",
			unauthorized: "Você não está autorizado a realizar esta ação.",
			forbidden: "Acesso negado.",
			notFound: "O recurso solicitado não foi encontrado.",
			validation: "Verifique suas informações e tente novamente.",
		},
	},

	errors: {
		generic: {
			title: "Algo deu errado",
			message:
				"Ocorreu um erro inesperado. Tente novamente ou entre em contato com o suporte se o problema persistir.",
		},
		network: {
			title: "Problema de Conexão",
			message:
				"Não foi possível conectar ao servidor. Verifique sua conexão com a internet e tente novamente.",
		},
		notFound: {
			title: "Página Não Encontrada",
			message:
				"A página que você está procurando não existe ou você não tem permissão para visualizá-la.",
		},
		forbidden: {
			title: "Acesso Negado",
			message:
				"Você não tem permissão para acessar este recurso. Entre em contato com seu administrador se acredita que isso é um erro.",
		},
		serverError: {
			title: "Erro do Servidor",
			message:
				"O servidor encontrou um erro ao processar sua solicitação. Tente novamente mais tarde.",
		},

		// Staff and permissions
		emailRequired: "Email é obrigatório",
		nameRequired: "Nome é obrigatório",
		inviteSent: "Convite enviado com sucesso!",
		inviteError: "Erro ao enviar convite. Por favor, tente novamente.",
		noStaffMembers: "Nenhum membro da equipe encontrado.",
		roleCreated: "Papel criado com sucesso!",
		roleDeleted: "Papel excluído com sucesso!",
		createRoleError: "Erro ao criar papel. Por favor, tente novamente.",
		deleteRoleError: "Erro ao excluir papel. Por favor, tente novamente.",
		send: "Enviar",
		createdAt: "Criado em",
		updatedAt: "Atualizado em",
		expiresAt: "Expira em",

		days: {
			monday: "Segunda-feira",
			tuesday: "Terça-feira",
			wednesday: "Quarta-feira",
			thursday: "Quinta-feira",
			friday: "Sexta-feira",
			saturday: "Sábado",
			sunday: "Domingo",
		},
	},

	// Pagination
	pagination: {
		noItems: "Nenhum item para exibir",
		showingItems: "Mostrando {{start}} a {{end}} de {{total}} itens",
		itemsPerPage: "Itens por página",
		pageOfTotal: "Página {{page}} de {{total}}",
		firstPage: "Ir para primeira página",
		previousPage: "Ir para página anterior",
		nextPage: "Ir para próxima página",
		lastPage: "Ir para última página",
	},

	organization: {
		loading: "Carregando organizações...",
		select: "Selecionar Organização",
		selectTitle: "Selecione uma Organização",
		selectDescription: "Escolha uma organização para continuar",
		switchOrganization: "Trocar Organização",
		viewDashboard: "Ver painel",
		create: "Criar Organização",
		description: "Descrição",
		descriptionPlaceholder: "Digite uma descrição para sua organização",
		noDescription: "Sem descrição",
		createNew: "Criar Nova Organização",
		createDescription: "Digite um nome para sua nova organização",
		createSuccess: "Organização criada com sucesso!",
		basicInformation: "Informações Básicas",
		updateTitle: "Atualizar Organização",
		updateDescription: "Atualize o nome da sua organização",
		updateSuccess: "Organização atualizada com sucesso!",
		autoCreatedDescription:
			"Organização criada automaticamente para novo usuário",
		notFound: "Organização Não Encontrada",
		notFoundDescription:
			"A organização que você está procurando não existe ou você não tem acesso a ela.",
		createdOn: "Criada em {{date}}",
		yourRole: "Sua Função",
		yourRoleDescription: "Sua função nesta organização",
		members: "Membros",
		membersDescription: "Total de membros da organização",
		totalMembers: "total de membros",
		establishments: "Unidades",
		establishmentsDescription: "Unidades da organização",
		totalEstablishments: "total de unidades",
		quickActions: "Ações Rápidas",
		updateError: "Falha ao atualizar organização. Por favor, tente novamente.",
		clickToEdit: "Clique para editar a organização",
		name: "Nome da Organização",
		namePlaceholder: "Minha Organização",
		nameRequired: "O nome da organização é obrigatório",
		createError: "Falha ao criar organização. Por favor, tente novamente.",
		managementDescription: "Gerencie suas organizações e crie novas.",
		noOrganizations:
			"Você ainda não tem nenhuma organização. Crie uma para começar.",
		noOrganizationsDescription:
			"Crie sua primeira organização para começar a gerenciar seu estúdio de Pilates.",
		createFirst: "Criar Sua Primeira Organização",
		current: "Atual",
		toasts: {
			creating: "Criando organização...",
			createSuccess: "Organização criada com sucesso!",
			createError: "Falha ao criar organização. Por favor, tente novamente.",
			updating: "Atualizando organização...",
			updateSuccess: "Organização atualizada com sucesso!",
			updateError:
				"Falha ao atualizar organização. Por favor, tente novamente.",
			deleting: "Excluindo organização...",
			deleteSuccess: "Organização excluída com sucesso!",
			deleteError: "Falha ao excluir organização. Por favor, tente novamente.",
		},
		// Leave organization functionality
		leave: "Sair",
		leaveOrganization: "Sair da Organização",
		leaveConfirmation:
			"Tem certeza de que deseja sair de {{name}}? Esta ação não pode ser desfeita.",
		ownerLeaveWarning:
			"Como proprietário, você não pode sair se for o único proprietário. Por favor, transfira a propriedade para outro membro primeiro.",
		confirmNameToLeave: "Digite o nome da organização para confirmar",
		typeOrgNameToConfirm:
			"Digite o nome exato da organização acima para confirmar a saída",
		inactive: {
			title: "Organização Inativa",
			description:
				"Esta organização não possui uma assinatura ativa. Para continuar usando todos os recursos, por favor ative ou renove sua assinatura.",
			noSubscription: {
				title: "Escolha Seu Plano",
				description:
					"Escolha o plano que melhor atende às suas necessidades e comece a gerenciar seu estúdio hoje.",
			},
			pastDue: {
				title: "Pagamento Atrasado",
				description:
					"O pagamento da sua assinatura está atrasado. Por favor, atualize seu método de pagamento para continuar usando a plataforma.",
			},
			paused: {
				title: "Assinatura Pausada",
				description:
					"Sua assinatura está pausada no momento. Retome sua assinatura para continuar usando todos os recursos.",
			},
			canceled: {
				title: "Assinatura Cancelada",
				description:
					"Sua assinatura foi cancelada. Reative sua assinatura para continuar usando a plataforma.",
			},
			manageBilling: "Gerenciar Assinatura",
			contactSupport: "Contatar Suporte",
			backToOrganizationSelection: "Voltar para seleção de organização",
		},
	},
	renewSubscription: {
		title: "Renovar Assinatura",
		choosePlanDescription:
			"Escolha o plano que melhor atende às suas necessidades.",
	},
	onboarding: {
		stepOf: "Passo {{current}} de {{total}}",
		choosePlan: "Escolher Plano",
		welcome: {
			title: "Parabéns! 🎉",
			created: "foi criada com sucesso!",
			description:
				"Você está a poucos passos de gerenciar seu estúdio de Pilates como um profissional. Vamos começar!",
		},
		features: {
			title: "Tudo o que Você Precisa",
			description:
				"Ferramentas poderosas para gerenciar todos os aspectos do seu estúdio",
			items: {
				customers: {
					title: "Gerenciar Clientes",
					description: "Acompanhe perfis, planos e histórico",
				},
				schedules: {
					title: "Grade de Aulas",
					description: "Crie e gerencie horários de aulas",
				},
				enrollments: {
					title: "Matrículas",
					description: "Matricule alunos nas aulas facilmente",
				},
				attendance: {
					title: "Frequência",
					description: "Controle check-ins e presença nas aulas",
				},
				staff: {
					title: "Gestão de Equipe",
					description: "Convide e gerencie sua equipe",
				},
				dashboard: {
					title: "Painel",
					description: "Monitore seu estúdio em um relance",
				},
			},
		},
		plan: {
			title: "Quase Lá!",
			description:
				"Vamos agora levá-lo à página de seleção de planos onde você pode escolher o melhor plano para seu estúdio.",
			trialTitle: "Teste Grátis Incluídos",
			trialDescription:
				"Você pode experimentar nosso teste gratuito. Você pode cancelar a qualquer momento durante o período de teste e não será cobrado.",
		},
	},
	theme: {
		select: "Selecionar Tema",
	},
	auth: {
		signIn: "Entrar",
		signOut: "Sair",
		signUp: "Cadastrar",
		firstName: "Nome",
		lastName: "Sobrenome",
		signInRequired: "Você precisa estar logado para visualizar esta página",
	},
	navigation: {
		home: "Início",
		about: "Sobre",
		pricing: "Preços",
		privacyPolicy: "Política de Privacidade",
		customers: "Clientes",
		schedule: "Horários",
		schedules: "Agendas",
		enrollment: "Matrícula",
		attendance: "Agenda",
		payments: "Pagamentos",
		medicalRecords: "Prontuários",
		registrations: "Cadastros",
		events: "Eventos",
		birthdayEvents: "Aniversários",
		enrollmentExpiryEvents: "Vencimento de Matrícula",
		paymentReminderEvents: "Lembretes de Pagamento",
		dashboard: "Painel",
		billing: "Vendas",
		orgManagement: "Gestão da Organização",
		settings: "Configurações da Organização",
		startNow: "Começar agora",
		accessApp: "Acessar App",
		help: "Ajuda",
	},
	home: {
		welcome: "Bem-vindo ao {{appName}}",
		version: "Versão",
	},
	pricing: {
		badge: "Planos Personalizados",
		title: "Planos Sob Medida para seu Estúdio",
		subtitle:
			"Acreditamos que cada estúdio de Pilates é único. Por isso, criamos planos personalizados que se encaixam nas suas necessidades específicas e orçamento.",
		benefitsTitle: "O Que Você Recebe",
		benefits: [
			"Gestão completa do estúdio",
			"Alunos e matrículas ilimitados",
			"Agendamento e controle de presença",
			"Relatórios financeiros e análises",
			"Equipe de suporte dedicada",
			"Atualizações regulares e novos recursos",
		],
		contactTitle: "Fale com Nossa Equipe",
		contactDescription:
			"Receba uma proposta personalizada para o seu estúdio. Nossa equipe vai entender suas necessidades e propor a melhor solução.",
		emailSales: "Email Comercial",
		whatsappSales: "Falar no WhatsApp",
		responseTime: "Normalmente respondemos em até 24 horas",
		faqTitle: "Tem Dúvidas?",
		faqDescription:
			"Nossa equipe está pronta para responder qualquer pergunta sobre recursos, preços ou implementação.",
		contactUs: "Entre em contato",
		getStarted: "Começar Agora",
	},
	privacy: {
		title: "Política de Privacidade",
		lastUpdated: "Última atualização",
		sections: {
			introduction: {
				title: "Introdução",
				content:
					"No Pilates Time, estamos comprometidos em proteger sua privacidade e garantir a segurança de suas informações pessoais. Esta Política de Privacidade explica como coletamos, usamos, divulgamos e protegemos suas informações quando você usa nossa plataforma de gerenciamento de estúdios de Pilates. Ao usar nossos serviços, você consente com as práticas descritas nesta política.",
			},
			legalBasis: {
				title: "Base Legal para Processamento",
				content:
					"Processamos seus dados pessoais com base nos seguintes fundamentos legais:",
				bases: [
					"Execução de contrato: Gerenciamento de sua associação e serviços do estúdio",
					"Interesse legítimo: Melhoria de nossos serviços e segurança da plataforma",
					"Consentimento explícito: Processamento de informações de saúde e médicas",
					"Obrigação legal: Cumprimento de obrigações fiscais e regulamentares",
				],
			},
			dataCollection: {
				title: "Informações que Coletamos",
				content:
					"Coletamos vários tipos de informações para fornecer e melhorar nossos serviços:",
				personalData: {
					title: "Informações Pessoais",
					items: [
						"Nome, endereço de e-mail e número de telefone",
						"Informações de assinatura e pagamento",
						"Informações de perfil e preferências",
						"Preferências e histórico de comunicação",
						"Credenciais de conta e dados de autenticação",
					],
				},
				healthData: {
					title: "Informações de Saúde e Médicas (Dados de Categoria Especial)",
					items: [
						"Histórico médico e condições de saúde",
						"Limitações físicas e lesões",
						"Objetivos e preferências de fitness",
						"Formulários de anamnese e avaliações de saúde",
						"Acompanhamento de progresso e notas de sessão",
					],
					specialProtections: {
						title: "Proteções Aprimoradas para Dados de Saúde",
						content:
							"Informações de saúde recebem proteção especial sob as leis de proteção de dados:",
						protections: [
							"Processamos dados de saúde apenas com seu consentimento explícito",
							"Dados de saúde são usados exclusivamente para avaliação física e personalização de programas",
							"Você pode retirar o consentimento para processamento de dados de saúde a qualquer momento",
							"Dados de saúde estão sujeitos a medidas de segurança e controles de acesso aprimorados",
							"Não usamos dados de saúde para marketing ou propósitos não relacionados à saúde",
							"Dados de saúde são criptografados tanto em trânsito quanto em repouso",
							"Acesso a dados de saúde é limitado apenas a pessoal autorizado",
						],
					},
				},
				usageData: {
					title: "Dados de Uso e Técnicos",
					items: [
						"Informações do dispositivo e endereço IP",
						"Tipo de navegador e sistema operacional",
						"Padrões de uso e interações com recursos",
						"Dados de sessão e registros de presença",
						"Métricas de desempenho e análises",
					],
				},
			},
			dataUse: {
				title: "Como Usamos Suas Informações",
				content:
					"Usamos as informações coletadas para os seguintes propósitos:",
				purposes: [
					"Fornecer e manter nossos serviços de gerenciamento de estúdio de Pilates",
					"Processar pagamentos e gerenciar cobrança",
					"Agendar aulas e gerenciar compromissos",
					"Acompanhar presença e progresso",
					"Comunicar com você sobre sua conta e serviços",
					"Enviar atualizações importantes e notificações",
					"Melhorar nossa plataforma e desenvolver novos recursos",
					"Garantir a segurança da plataforma e prevenir fraudes",
					"Cumprir obrigações legais e regulamentações",
				],
			},
			dataSharing: {
				title: "Compartilhamento e Divulgação de Informações",
				content:
					"Não vendemos, negociamos ou alugamos suas informações pessoais para terceiros. Podemos compartilhar suas informações apenas nas seguintes circunstâncias:",
				cases: [
					"Com seu consentimento explícito",
					"Com processadores de pagamento para lidar com transações com segurança",
					"Com provedores de serviços que auxiliam nas operações da plataforma",
					"Quando exigido por lei ou processo legal",
					"Para proteger nossos direitos, propriedade ou segurança",
					"Em conexão com uma transferência ou aquisição de negócios",
				],
			},
			dataSecurity: {
				title: "Segurança de Dados",
				content:
					"Implementamos medidas de segurança padrão da indústria para proteger suas informações:",
				measures: [
					"Criptografia de dados em trânsito e em repouso",
					"Autenticação segura e controles de acesso",
					"Auditorias de segurança regulares e monitoramento",
					"Centros de dados e infraestrutura seguros",
					"Treinamento de funcionários sobre proteção de dados",
					"Procedimentos de resposta a incidentes e notificação de violações",
				],
			},
			userRights: {
				title: "Seus Direitos e Escolhas",
				content:
					"Você tem os seguintes direitos em relação às suas informações pessoais:",
				rights: [
					"Acessar e revisar seus dados pessoais",
					"Solicitar correção de informações imprecisas",
					"Solicitar exclusão de seus dados (sujeito a requisitos legais)",
					"Optar por não receber comunicações de marketing",
					"Solicitar portabilidade de dados",
					"Retirar consentimento quando aplicável",
					"Registrar reclamações com autoridades relevantes",
				],
				gdprRights: {
					title: "Direitos do GDPR (Residentes da UE)",
					rights: [
						"Direito de acesso aos seus dados pessoais e informações de processamento",
						"Direito de retificação de dados imprecisas ou incompletas",
						"Direito ao apagamento ('direito de ser esquecido') em certas circunstâncias",
						"Direito de restringir o processamento em situações específicas",
						"Direito à portabilidade de dados em formato legível por máquina",
						"Direito de objeção ao processamento baseado em interesses legítimos",
						"Direito de retirar o consentimento a qualquer momento",
						"Direito de não estar sujeito à tomada de decisão automatizada",
						"Direito de registrar reclamações com autoridades supervisoras",
					],
				},
				lgpdRights: {
					title: "Direitos da LGPD (Residentes do Brasil)",
					rights: [
						"Direito à confirmação da existência de processamento de dados pessoais",
						"Direito de acesso aos seus dados pessoais",
						"Direito à correção de dados incompletos, imprecisas ou desatualizados",
						"Direito à anonimização, bloqueio ou eliminação de dados",
						"Direito à portabilidade de dados para outro provedor de serviços",
						"Direito à informação sobre compartilhamento de dados com terceiros",
						"Direito de retirar o consentimento e ser informado das consequências",
						"Direito de revisar decisões automatizadas que o afetam",
					],
				},
				ccpaRights: {
					title: "Direitos da CCPA (Residentes da Califórnia)",
					rights: [
						"Direito de saber quais informações pessoais são coletadas sobre você",
						"Direito de saber se informações pessoais são vendidas ou divulgadas",
						"Direito de dizer não à venda de informações pessoais",
						"Direito de acessar suas informações pessoais",
						"Direito a serviço e preço iguais, mesmo se exercer direitos de privacidade",
						"Direito de excluir informações pessoais",
					],
				},
				exercisingRights: {
					title: "Como Exercer Seus Direitos",
					content: "Para exercer qualquer um desses direitos:",
					steps: [
						"Entre em contato conosco usando as informações fornecidas nesta política",
						"Forneça informações suficientes para verificar sua identidade",
						"Especifique qual direito você deseja exercer",
						"Responderemos dentro do prazo legalmente exigido",
						"Você pode recorrer de nossa decisão se discordar de nossa resposta",
					],
				},
			},
			dataRetention: {
				title: "Retenção e Exclusão de Dados",
				content:
					"Mantemos seus dados pessoais apenas pelo tempo necessário para os propósitos descritos nesta política:",
				periods: [
					"Informações da conta: Mantidas enquanto a conta estiver ativa mais 3 anos",
					"Registros de saúde: Mantidos por 7 anos após a última sessão (requisito regulatório)",
					"Dados de pagamento: Mantidos por 7 anos para fins de conformidade fiscal",
					"Dados de marketing: Mantidos até que o consentimento seja retirado",
					"Logs técnicos: Mantidos por 12 meses para fins de segurança",
					"Gravações de sessão (se houver): Mantidas por 30 dias, a menos que salvas pelo usuário",
				],
				criteria: {
					title: "Critérios de Exclusão",
					content: "Os dados são automaticamente excluídos quando:",
					conditions: [
						"Requisitos legais e regulamentares",
						"Necessidades comerciais legítimas",
						"Propósitos para os quais os dados foram coletados",
						"Sensibilidade dos dados pessoais",
						"Riscos de manter os dados por mais tempo",
					],
				},
			},
			internationalTransfers: {
				title: "Transferências Internacionais de Dados",
				content:
					"Seus dados podem ser processados fora do seu país de residência:",
				details: [
					"Os dados podem ser processados no Brasil, Estados Unidos e União Europeia",
					"Usamos Cláusulas Contratuais Padrão (SCCs) para transferências da UE",
					"Provedores de nuvem cumprem com estruturas de proteção de dados aplicáveis",
					"Garantimos nível adequado de proteção para todas as transferências internacionais",
					"Avaliações de impacto de transferência conduzidas para jurisdições de alto risco",
				],
				safeguards: {
					title: "Salvaguardas de Transferência",
					measures: [
						"Decisões de adequação quando disponíveis",
						"Cláusulas Contratuais Padrão (SCCs)",
						"Regras Corporativas Vinculantes para empresas do grupo",
						"Esquemas de certificação e códigos de conduta",
						"Medidas técnicas e organizacionais adicionais",
					],
				},
			},

			childrensPrivacy: {
				title: "Privacidade de Crianças",
				content: "Estamos comprometidos em proteger a privacidade de crianças:",
				policies: [
					"Nossos serviços não são destinados a crianças menores de 16 anos",
					"Não coletamos conscientemente dados pessoais de crianças menores de 16 anos",
					"Consentimento parental é necessário para usuários de 13-16 anos em jurisdições aplicáveis",
					"Pais podem solicitar acesso ou exclusão dos dados de seus filhos",
					"Proteções especiais se aplicam a informações de saúde de menores",
					"Excluiremos dados de qualquer criança se soubermos que foram coletados sem consentimento adequado",
				],
				parentalRights: {
					title: "Direitos dos Pais",
					rights: [
						"Revisar quaisquer dados pessoais que coletamos de seu filho",
						"Solicitar exclusão dos dados pessoais de seu filho",
						"Recusar permitir coleta adicional dos dados de seu filho",
						"Solicitar que paremos de usar os dados de seu filho",
					],
				},
			},
			automatedDecisionMaking: {
				title: "Tomada de Decisão Automatizada e Criação de Perfis",
				content:
					"Informações sobre processamento automatizado em nossos serviços:",
				details: [
					"Podemos usar sistemas automatizados para otimização de agendamento e recomendações",
					"Nenhuma decisão puramente automatizada é tomada que o afete significativamente",
					"Você tem o direito à revisão humana de qualquer decisão automatizada",
					"Recursos de IA são usados apenas para melhorar a experiência do usuário, não substituir o julgamento humano",
					"Você pode optar por não participar do processamento automatizado quando tecnicamente viável",
				],
				profiling: {
					title: "Atividades de Criação de Perfis",
					activities: [
						"Acompanhamento do progresso físico e recomendações de metas",
						"Otimização de agendamento de aulas baseada em preferências",
						"Sugestões de exercícios personalizadas baseadas em dados de saúde",
						"Avaliação de risco para prevenção de lesões",
					],
				},
			},
			consentManagement: {
				title: "Gerenciamento de Consentimento",
				content: "Como obtemos e gerenciamos seu consentimento:",
				principles: [
					"O consentimento é dado livremente, específico, informado e inequívoco",
					"Você pode retirar o consentimento a qualquer momento através das configurações da conta",
					"A retirada não afeta a legalidade do processamento anterior",
					"Alguns serviços podem ficar indisponíveis se o consentimento for retirado",
					"Consentimento separado é necessário para comunicações de marketing",
					"Mantemos registros de quando e como o consentimento foi obtido",
				],
				withdrawal: {
					title: "Como Retirar o Consentimento",
					methods: [
						"Através das configurações da sua conta e preferências de privacidade",
						"Entrando em contato diretamente com nossa equipe de proteção de dados",
						"Usando links de cancelamento de inscrição em comunicações de marketing",
						"Através das configurações de privacidade do nosso aplicativo móvel",
					],
				},
			},
			breachNotification: {
				title: "Notificação de Violação de Dados",
				content:
					"Nossos procedimentos para lidar com incidentes de segurança de dados:",
				procedures: [
					"Violações de alto risco: Usuários notificados dentro de 72 horas da descoberta",
					"Notificação inclui natureza da violação, dados envolvidos e medidas tomadas",
					"Autoridades supervisoras notificadas dentro de 72 horas quando exigido por lei",
					"Avaliações regulares de segurança e testes de resposta a incidentes",
					"Contenção imediata e investigação de qualquer violação suspeita",
				],
				userNotification: {
					title: "O Que Informamos a Você",
					information: [
						"Descrição do que aconteceu e quando descobrimos",
						"Tipos de dados pessoais que foram envolvidos",
						"Medidas que tomamos para abordar a violação",
						"Recomendações para se proteger",
						"Como entrar em contato conosco para mais informações",
					],
				},
			},
			cookies: {
				title: "Cookies e Tecnologias de Rastreamento",
				content:
					"Usamos cookies e tecnologias similares para melhorar sua experiência, analisar padrões de uso e melhorar nossos serviços. Você pode controlar as preferências de cookies através das configurações do seu navegador, embora alguns recursos possam não funcionar adequadamente se os cookies estiverem desabilitados.",
			},
			contact: {
				title: "Contatos de Proteção de Dados",
				content:
					"Para questões e solicitações relacionadas à privacidade, entre em contato: suporte@pilatestime.com.br",
			},
			updates: {
				title: "Atualizações da Política",
				content:
					"Podemos atualizar esta Política de Privacidade periodicamente para refletir mudanças em nossas práticas ou requisitos legais. Notificaremos você sobre mudanças significativas através da plataforma ou por e-mail. Seu uso continuado de nossos serviços após tais modificações constitui aceitação da política atualizada.",
			},
		},
	},
	customers: {
		searchPlaceholder: "Buscar cliente",
		title: "Clientes",
		addCustomer: "Adicionar Cliente",
		addCustomerDescription:
			"Insira os detalhes do cliente para criar um novo registro",
		editCustomer: "Editar Cliente",
		editCustomerDescription: "Atualizar informações do cliente",
		importCustomers: "Importar Clientes",
		management: {
			title: "Clientes",
			description: "Gerencie os clientes da sua organização",
			noCustomers: "Nenhum Cliente",
			noCustomersDescription: "Você ainda não criou nenhum cliente",
			noCustomersSearchDescription: "Nenhum cliente encontrado para sua busca",
			createFirst: "Criar Seu Primeiro Cliente",
		},
		cepLookupError: "Não foi possível encontrar o endereço para este CEP",
		table: {
			customer: "Cliente",
			name: "Nome",
			idType: "Tipo de Documento",
			idNumber: "Número do Documento",
			email: "Email",
			phone: "Telefone",
			createdAt: "Criado em",
			actions: "Ações",
		},

		sections: {
			personalInfo: "Informações Pessoais",
			personalInfoDescription:
				"Informações básicas e dados pessoais do cliente",
			contactInfo: "Informações de Contato",
			contactInfoDescription: "Endereço e informações de contato do cliente",
			emergencyContact: "Contato de Emergência",
			emergencyContactDescription: "Informações de contato para emergências",
			additionalInfo: "Informações Adicionais",
			additionalInfoDescription: "Observações e informações complementares",
			identification: "Identificação",
			contactDetails: "Detalhes de Contato",
			address: "Endereço",
			professionalAndNotes: "Profissional & Observações",
		},
		fields: {
			fullName: "Nome Completo",
			firstName: "Nome",
			lastName: "Sobrenome",
			dateOfBirth: "Data de Nascimento",
			gender: "Gênero",
			country: "País",
			idType: "Tipo de Documento",
			idNumber: "Número do Documento",
			email: "Email",
			phone: "Telefone",
			address: "Endereço",
			number: "Número",
			apartment: "Apartamento/Complemento",
			neighborhood: "Bairro",
			city: "Cidade",
			state: "Estado",
			zipCode: "CEP",
			postalCode: "CEP",
			profession: "Profissão",
			emergencyContactName: "Nome do Contato de Emergência",
			emergencyContactPhone: "Telefone do Contato de Emergência",
			notes: "Observações",
			isWhatsapp: "WhatsApp",
			date: "Data",
			recordType: "Tipo de Registro",
			title: "Título",
			description: "Descrição",
			status: "Status",
		},
		placeholders: {
			selectGender: "Selecione o gênero",
			selectCountry: "Selecione o país",
			selectIdType: "Selecione o tipo de documento",
			selectRecordType: "Selecione o tipo de registro",
		},
		genders: {
			male: "Masculino",
			female: "Feminino",
			other: "Outro",
			preferNotToSay: "Prefiro não informar",
		},
		idTypes: {
			US: {
				ssn: "Número de Seguro Social",
				driversLicense: "Carteira de Motorista",
				passport: "Passaporte",
				stateId: "ID Estadual",
			},
			BR: {
				cpf: "CPF",
				rg: "RG",
				passport: "Passaporte",
				cnh: "Carteira Nacional de Habilitação",
			},
			IN: {
				aadhaar: "Aadhaar",
				pan: "PAN",
				passport: "Passaporte",
				voterID: "Título de Eleitor",
				drivingLicense: "Carteira de Motorista",
			},
			default: {
				nationalID: "Documento Nacional",
				passport: "Passaporte",
				drivingLicense: "Carteira de Motorista",
			},
		},
		status: "Status",
		noCustomersFound: "Nenhum cliente encontrado",
		allStatuses: "Todos os Status",
		statuses: {
			active: "Ativo",
			inactive: "Inativo",
			pending: "Pendente",
			deleted: "Excluído",
			purged: "Removido",
		},
		createCustomer: "Criar Cliente",
		createAndEnroll: "Criar e Matricular",
		deleteCustomer: "Excluir Cliente",
		deleteConfirmation: "Tem certeza que deseja excluir este cliente?",
		createSuccess: "Cliente criado com sucesso!",
		updateSuccess: "Cliente atualizado com sucesso!",
		deleteSuccess: "Cliente excluído com sucesso!",
		createError: "Falha ao criar cliente. Por favor, tente novamente.",
		updateError: "Falha ao atualizar cliente. Por favor, tente novamente.",
		deleteError: "Falha ao excluir cliente. Por favor, tente novamente.",
		toasts: {
			creating: "Criando cliente...",
			createSuccess: "Cliente criado com sucesso!",
			createError: "Falha ao criar cliente. Por favor, tente novamente.",
			updating: "Atualizando cliente...",
			updateSuccess: "Cliente atualizado com sucesso!",
			updateError: "Falha ao atualizar cliente. Por favor, tente novamente.",
			deleting: "Excluindo cliente...",
			deleteSuccess: "Cliente excluído com sucesso!",
			deleteError: "Falha ao excluir cliente. Por favor, tente novamente.",
		},
		addressLookup: {
			lookupSuccess: "Endereço encontrado e preenchido automaticamente",
			lookupError: "Não foi possível encontrar informações para este CEP",
			lookupInProgress: "Buscando informações de endereço...",
			enterValidPostalCode:
				"Digite um CEP válido para buscar informações de endereço",
		},

		// Customer details page
		profileInformation: "Informações do Perfil",
		customerNotFound: "Cliente não encontrado",
		customerDetails: "Detalhes do Cliente",
		accessDenied: "Você não tem permissão para acessar a página de clientes.",
		noNotes: "Nenhuma observação disponível",
		tabs: {
			profile: "Perfil",
			registration: "Cadastro",
			medicalRecords: "Prontuário",
			enrollments: "Matrículas",
			payments: "Pagamentos",
			sessions: "Sessões",
		},
		sessions: {
			title: "Sessões do Cliente",
			description: "Visualize todas as sessões futuras deste cliente",
			empty: {
				title: "Nenhuma Sessão Futura",
				description: "Este cliente não possui sessões futuras agendadas.",
			},
			table: {
				sessionName: "Nome da Sessão",
				date: "Data",
				startTime: "Início",
				endTime: "Término",
				staffMember: "Instrutor",
				actions: "Ações",
			},
			viewSession: "Ver Sessão",
		},

		// Overview
		overview: {
			title: "Visão Geral",
			customerInformation: "Informações do Cliente",
			customerInformationDescription:
				"Detalhes básicos e informações de contato do cliente",
			basicInformation: "Informações Básicas",
			contactInformation: "Informações de Contato",
			statusAndStats: "Status e Estatísticas",
			totalEnrollments: "Total de Matrículas",
			activeEnrollments: "Matrículas Ativas",
			pendingEnrollmentPayment: "Pagamentos de Matrículas Pendentes",
			medicalRecords: "Prontuários",
			recentMedicalRecords: "Prontuários Recentes",
			recentMedicalRecordsDescription:
				"Últimos prontuários e informações de saúde",
			activeEnrollmentsTitle: "Matrículas Ativas",
			activeEnrollmentsDescription:
				"Matrículas e assinaturas atualmente ativas",
			noActiveEnrollments: "Nenhuma matrícula ativa",
			importantAlerts: "Alertas Importantes",
			pendingInvoices: "Faturas Pendentes",
			pendingPayments: "Pagamentos Pendentes",
			noOutstandingPayments: "Nenhum pagamento pendente",
			dueDate: "Vencimento",
			pay: "Pagar",
			enrollmentsSummary: "Resumo das Matrículas",
			noEnrollments: "Nenhuma matrícula ainda",
			active: "Ativas",
			pendingPayment: "Aguardando Pagamento",
			other: "Outras",
			quickActions: {
				newEnrollment: "Nova Matrícula",
				createInvoice: "Nova Venda",
				scheduleSingleSession: "Agendar Sessão Avulsa",
				addMedicalRecord: "Adicionar Prontuário",
			},
		},

		// Single Session Modal (Trial, Reposition, One Time Session)
		singleSession: {
			title: "Agendar Sessão Avulsa",
			description: "Agendar uma sessão avulsa para {{customerName}}",
			defaultName: "Sessão Avulsa",
			fields: {
				name: "Nome da Sessão",
				establishment: "Unidade",
				staffMember: "Profissional",
				sessionDate: "Data da Sessão",
				startTime: "Horário de Início",
				endTime: "Horário de Término",
				sessionType: "Tipo de Sessão",
				notes: "Observações",
			},
			sessionTypes: {
				trial: "Aula Experimental",
				reposition: "Reposição",
				oneTimeSession: "Sessão Avulsa",
			},
			selectEstablishment: "Selecione uma unidade",
			selectStaffMember: "Selecione um profissional",
			selectSessionType: "Selecione o tipo de sessão",
			notesPlaceholder: "Adicione observações sobre esta sessão...",
			schedule: "Agendar Sessão",
			scheduling: "Agendando...",
			toasts: {
				scheduling: "Agendando sessão...",
				success: "Sessão agendada com sucesso",
				error: "Falha ao agendar sessão",
			},
		},

		// Navigation
		navigation: {
			title: "Detalhes do Cliente",
			description: "Gerenciar informações e registros do cliente",
			editDescription: "Editar perfil e informações pessoais do cliente",
			medicalRecordsDescription:
				"Visualizar e gerenciar prontuários e informações de saúde",
			enrollmentsDescription:
				"Visualizar e gerenciar matrículas e assinaturas do cliente",
			unknownCustomer: "Cliente Desconhecido",
			customerdata: "Dados do Cliente",
		},

		// Medical records
		medicalRecords: {
			title: "Prontuários",
			description: "Visualizar e gerenciar prontuários para este cliente",
			addRecord: "Adicionar Registro",
			noRecords: "Nenhum prontuário encontrado",
			noRecordsDescription:
				"Comece a construir um histórico médico abrangente adicionando o primeiro registro para este cliente.",
		},
		recordTypes: {
			evaluation: "Avaliação",
			progress: "Progresso",
			treatment: "Tratamento",
			other: "Outro",
		},

		// Customer enrollments
		customerEnrollments: "Matrículas do Cliente",
		noEnrollments: "Nenhuma matrícula encontrada",
		noEnrollmentsDescription:
			"Este cliente ainda não está matriculado em nenhuma agenda.",
		enrollmentDetails: "Detalhes da Matrícula",

		// Customer payments
		customerPayments: "Pagamentos do Cliente",
		noPayments: "Nenhum pagamento encontrado",
		noPaymentsDescription: "Este cliente ainda não possui pagamentos.",
		paymentHistory: "Histórico de Pagamentos",
	},
	schedules: {
		navigation: {
			unknownInstructor: "Instrutor Desconhecido",
		},
		type: {
			group: "Grupo",
			individual: "Individual",
		},
		noDaysSelected: "Nenhum dia selecionado",
		everyDay: "Todos os dias",
		capacity: "Capacidade",
		instructor: "Instrutor",
		management: {
			title: "Gerenciamento de Horários",
			description: "Gerencie seus horários de aulas e sessões",
			createNew: "Criar Novo Horário",
			createNewShort: "Novo",
			createFirst: "Criar Seu Primeiro Horário",
			list: {
				title: "Horários",
				description: "Visualize e gerencie todos os seus horários",
			},
			empty: {
				title: "Nenhum horário ainda",
				description:
					"Crie seu primeiro horário para começar a gerenciar suas aulas e sessões.",
			},
			table: {
				name: "Nome",
				type: "Tipo",
				establishment: "Unidade",
				staffMember: "Membro da Equipe",
				time: "Horário",
				recurrency: "Recorrência",
				capacity: "Capacidade",
				status: "Status",
				actions: "Ações",
				people: "pessoas",
				person: "pessoa",
				individual: "Individual",
				active: "Ativo",
				inactive: "Inativo",
				edit: "Editar",
				delete: "Excluir",
			},
			deleteConfirmation: {
				title: "Excluir Horário",
				message:
					"Tem certeza de que deseja excluir este horário? Esta ação não pode ser desfeita.",
				confirm: "Excluir",
				deleting: "Excluindo...",
				cancel: "Cancelar",
			},
			deletion: {
				title: "Excluir Horário",
				descriptionNoEnrollments:
					"Tem certeza de que deseja excluir este horário? Esta ação não pode ser desfeita.",
				descriptionWithEnrollments:
					"Este horário possui clientes matriculados. Por favor, escolha como proceder.",
				scheduleInfo: "Informações do Horário",
				enrollmentsWarning: "Aviso de Clientes Matriculados",
				enrollmentsCount:
					"Este horário possui {{count}} cliente(s) matriculado(s). Se você excluir este horário, todas as matrículas associadas terão seus horários removidos. Por favor, atualize as matrículas dos clientes para outros horários antes de excluir este horário.",
				enrolledCustomers: "Clientes matriculados",
				andMore: "e mais {{count}}...",
				deleteAnyway: "Excluir Mesmo Assim",
				deleting: "Excluindo horário...",
				errorLoadingEnrollments:
					"Falha ao carregar informações de matrícula. Por favor, tente novamente.",
			},
			filters: {
				searchPlaceholder: "Buscar por nome, instrutor ou estabelecimento...",
				filterByType: "Tipo",
				filterByStatus: "Status",
				filterByStaff: "Instrutor",
				allTypes: "Todos os tipos",
				allStatuses: "Todos os status",
				allStaff: "Todos os instrutores",
				group: "Grupo",
				individual: "Individual",
				active: "Ativo",
				inactive: "Inativo",
				activeAndInactive: "Ativo & Inativo",
				selectedCount: "{{count}} selecionado(s)",
				enrollments: "Matrículas",
			},
		},
		details: {
			title: "Detalhes do Horário",
			description: "Visualize e gerencie informações do horário",
			tabs: {
				edit: "Editar",
				sessions: "Sessões",
				enrollments: "Matrículas",
			},
		},
		form: {
			create: {
				title: "Criar Novo Horário",
				description: "Configure um novo horário de aula ou sessão",
			},
			edit: {
				title: "Editar Horário",
				description: "Atualize os detalhes e configurações do horário",
			},
			details: {
				title: "Detalhes do Horário",
				description: "Configure as informações básicas do seu horário",
			},
			sections: {
				basicInfo: "Informações Básicas",
				basicInfoDescription: "Configure os detalhes básicos do seu horário",
				locationStaff: "Local e Equipe",
				locationStaffDescription:
					"Selecione a unidade e membro da equipe para este horário",
				scheduleSettings: "Configurações do Horário",
				scheduleSettingsDescription:
					"Configure horários, capacidade e configurações de data",
				recurrencyConfig: "Recorrência e Configuração",
				recurrencyConfigDescription:
					"Configure o padrão de recorrência e notas adicionais",
				classDetails: "Detalhes da Aula",
				classDetailsDescription: "Nome, tipo, local, equipe e capacidade",
				timeAndRecurrence: "Horário e Recorrência",
				timeAndRecurrenceDescription: "Horários, padrão de recorrência e datas",
			},
			fields: {
				name: "Nome do Horário",
				description: "Descrição",
				type: "Tipo de Horário",
				typeEditDisabled:
					"O tipo de horário não pode ser alterado após a criação",
				establishment: "Unidade",
				establishmentEditDisabled:
					"A unidade não pode ser alterada após a criação do horário",
				staffMember: "Membro da Equipe",
				capacity: "Capacidade",
				startTime: "Hora de Início",
				endTime: "Hora de Término",
				duration: "Duração",
				startDate: "Data de Início",
				startDateEditDisabled:
					"A data de início não pode ser alterada após a criação do horário",
				endDate: "Data de Término",
				recurrencyType: "Tipo de Recorrência",
				recurrencyTypeEditDisabled:
					"O tipo de recorrência não pode ser alterado após a criação do horário",
				daysOfWeek: "Dias da Semana",
				notes: "Observações",
			},
			placeholders: {
				name: "Digite o nome do horário",
				description: "Digite a descrição do horário",
				type: "Selecione o tipo de horário",
				establishment: "Selecione a unidade",
				staffMember: "Selecione o membro da equipe",
				capacity: "Digite a capacidade máxima",
				recurrencyType: "Selecione o tipo de recorrência",
				notes: "Digite observações adicionais",
			},
			options: {
				type: {
					group: "Sessão em Grupo",
					individual: "Sessão Individual",
				},
				recurrency: {
					single: "Sessão Única",
					weekly: "Semanal",
					monthly: "Mensal",
				},
				recurrencyType: {
					single: "Sessão Única",
					recurring: "Recorrente",
				},
				days: {
					monday: "Segunda-feira",
					tuesday: "Terça-feira",
					wednesday: "Quarta-feira",
					thursday: "Quinta-feira",
					friday: "Sexta-feira",
					saturday: "Sábado",
					sunday: "Domingo",
					mondayShort: "Seg",
					tuesdayShort: "Ter",
					wednesdayShort: "Qua",
					thursdayShort: "Qui",
					fridayShort: "Sex",
					saturdayShort: "Sáb",
					sundayShort: "Dom",
				},
			},
			validation: {
				nameRequired: "Nome do horário é obrigatório",
				establishmentRequired: "Unidade é obrigatório",
				staffMemberRequired: "Membro da equipe é obrigatório",
				startTimeRequired: "Hora de início é obrigatória",
				endTimeRequired: "Hora de término é obrigatória",
				invalidStartTime: "Por favor, digite uma hora de início válida",
				invalidEndTime: "Por favor, digite uma hora de término válida",
				endTimeAfterStart: "Hora de término deve ser após a hora de início",
				startDateRequired: "Data de início é obrigatória",
				invalidStartDate: "Por favor, digite uma data de início válida",
				endDateRequired:
					"Data de término é obrigatória para horários recorrentes",
				endDateAfterStart: "Data de término deve ser após a data de início",
				capacityRequired: "Capacidade é obrigatória para horários em grupo",
				daysOfWeekRequired:
					"Dias da semana são obrigatórios para horários recorrentes",
				dayCountMustBePreserved:
					"Número de dias deve permanecer {{originalCount}} para preservar limites de matrícula",
			},
			actions: {
				create: "Criar Horário",
				creating: "Criando...",
				update: "Atualizar Horário",
				updating: "Atualizando...",
				cancel: "Cancelar",
			},
			summary: {
				noName: "Horário sem Nome",
			},
		},
		toasts: {
			creating: "Criando horário...",
			createSuccess: "Horário criado com sucesso!",
			createError: "Falha ao criar horário. Tente novamente.",
			updating: "Atualizando horário...",
			updateSuccess: "Horário atualizado com sucesso!",
			updateError: "Falha ao atualizar horário. Tente novamente.",
			deleting: "Excluindo horário...",
			deleteSuccess: "Horário excluído com sucesso!",
			deleteError: "Falha ao excluir horário. Tente novamente.",
		},
		errors: {
			staffConflict:
				'Membro da equipe possui horários conflitantes: Horário "{{scheduleName}}" conflita com o novo horário. Horário: {{timeRange}}',
		},
		sessions: {
			title: "Sessões do Horário",
			description: "Visualize todas as sessões deste horário",
			table: {
				date: "Data e Hora",
				name: "Nome da Sessão",
				type: "Tipo",
				status: "Status",
				attendance: "Frequência",
			},
			status: {
				active: "Ativo",
				inactive: "Inativo",
				canceled: "Cancelado",
			},
			actions: {
				attendance: "Frequência",
				viewAttendance: "Ver frequência da sessão",
			},
			empty: {
				title: "Nenhuma sessão encontrada",
				description: "Este horário ainda não possui sessões.",
			},
		},
		endDateConfirmation: {
			title: "Confirmar Alteração da Data Final",
			subtitle: "Esta ação afetará as sessões existentes do horário",
			scheduleInfo: "Informações do Horário",
			scheduleName: "Nome do Horário",
			currentEndDate: "Data Final Atual",
			newEndDate: "Nova Data Final",
			warningTitle: "Aviso Importante",
			warningMessage:
				"Reduzir a data final excluirá permanentemente algumas sessões do horário:",
			warningPoint1: "Sessões agendadas após a nova data final serão excluídas",
			warningPoint2:
				"Todos os registros de frequência das sessões excluídas serão perdidos",
			confirm: "Confirmar Alterações",
			updating: "Atualizando...",
		},
		timeChangeConfirmation: {
			title: "Confirmar Alteração de Horário",
			subtitle: "Esta ação pode afetar clientes matriculados",
			scheduleInfo: "Informações do Horário",
			scheduleName: "Nome do Horário",
			currentTime: "Horário Atual",
			newTime: "Novo Horário",
			currentDays: "Dias Atuais",
			newDays: "Novos Dias",
			enrolledCustomers: "Clientes Matriculados",
			warningTitle: "Aviso de Impacto aos Clientes",
			warningMessage:
				"Alterar o horário ou dias pode afetar clientes já matriculados:",
			warningPoint1:
				"O novo horário pode sobrepor com outros horários em que os clientes estão matriculados",
			warningPoint2:
				"Isso pode criar conflitos de horário para clientes matriculados",
			warningPoint3:
				"Os clientes podem precisar ser notificados sobre as mudanças no horário",
			confirm: "Confirmar Alteração de Horário",
			updating: "Atualizando...",
		},
		changeConfirmation: {
			title: "Confirmar Alterações do Horário",
			subtitle:
				"Por favor, revise todas as alterações e avisos antes de prosseguir",
			scheduleInfo: "Informações do Horário",
			scheduleName: "Nome do Horário",
			currentEndDate: "Data Final Atual",
			newEndDate: "Nova Data Final",
			currentTime: "Horário Atual",
			newTime: "Novo Horário",
			currentDays: "Dias Atuais",
			newDays: "Novos Dias",
			enrolledCustomers: "Clientes Matriculados",
			endDateWarning: {
				title: "Aviso de Alteração da Data Final",
				message:
					"Reduzir a data final excluirá permanentemente algumas sessões do horário:",
				point1: "Sessões agendadas após a nova data final serão excluídas",
				point2:
					"Todos os registros de frequência das sessões excluídas serão perdidos",
			},
			timeWarning: {
				title: "Aviso de Alteração de Horário/Dias",
				message:
					"Alterar o horário ou dias pode afetar clientes já matriculados:",
				point1:
					"O novo horário pode sobrepor com outros horários em que os clientes estão matriculados",
				point2:
					"Isso pode criar conflitos de horário para clientes matriculados",
				point3:
					"Os clientes podem precisar ser notificados sobre as mudanças no horário",
			},
			confirm: "Confirmar Todas as Alterações",
			updating: "Atualizando...",
		},
		enrollments: {
			title: "Matrículas do Horário",
			description: "Visualize todos os clientes matriculados neste horário",
			empty: {
				title: "Nenhuma matrícula ainda",
				description:
					"Nenhum cliente está matriculado neste horário no momento.",
			},
		},
	},
	footer: {
		copyright: "© {{year}} Pilates Time. Todos os direitos reservados.",
		subscribe: "Inscrever-se",
		getUpdates: "Receba as últimas atualizações e notícias.",
		yourEmail: "Seu email",
		privacyPolicy: "Política de Privacidade",
		termsOfService: "Termos de Serviço",
	},
	establishments: {
		searchPlaceholder: "Buscar unidade",
		selector: {
			title: "Selecionar Unidade",
			description: "Escolha a unidade com o qual deseja trabalhar",
			select: "Selecionar",
			noAccess: "Sem Acesso",
			noAccessDescription: "Você não tem acesso a nenhuma unidade",
			contactAdmin: "Entre em contato com seu administrador para obter acesso",
			errorLoading: "Erro ao carregar unidades",
		},
		management: {
			title: "Unidades",
			description: "Gerencie as unidades da sua organização",
			createNew: "Criar Novo Unidade",
			noEstablishments: "Nenhuma Unidade",
			noEstablishmentsDescription: "Você ainda não criou nenhuma unidade",
			createFirst: "Criar Seu Primeiro Unidade",
			filterByEstablishment: "Filtrar por Unidade",
			table: {
				name: "Nome",
				description: "Descrição",
				address: "Endereço",
				phone: "Telefone",
				email: "Email",
				createdAt: "Criado em",
				actions: "Ações",
			},
			form: {
				sections: {
					basicInfo: "Informações Básicas",
					location: "Localização",
					contact: "Informações de Contato",
				},
				name: "Nome",
				namePlaceholder: "Digite o nome da unidade",
				description: "Descrição",
				descriptionPlaceholder: "Digite a descrição da unidade (opcional)",
				address: "Endereço",
				addressPlaceholder: "Digite o endereço da unidade (opcional)",
				phone: "Telefone",
				phonePlaceholder: "Digite o número de telefone (opcional)",
				email: "Email",
				emailPlaceholder: "Digite o endereço de email (opcional)",
				create: "Criar Unidade",
				update: "Atualizar Unidade",
				cancel: "Cancelar",
				creating: "Criando...",
				updating: "Atualizando...",
			},
			actions: {
				edit: "Editar",
				delete: "Excluir",
				confirmDelete: "Tem certeza de que deseja excluir esta unidade?",
				confirmDeleteDescription:
					"Esta ação não pode ser desfeita. Todos os dados associados a esta unidade serão permanentemente excluídos.",
				confirmDeleteWarning:
					"Atenção: Todos os horários associados a esta unidade também serão excluídos.",
				confirmDeletePhrase: "confirmar e excluir",
			},
			messages: {
				createSuccess: "Unidade criado com sucesso",
				createError: "Falha ao criar unidade. Tente novamente.",
				updateSuccess: "Unidade atualizado com sucesso",
				updateError: "Falha ao atualizar unidade. Tente novamente.",
				deleteSuccess: "Unidade excluído com sucesso",
				deleteError: "Falha ao excluir unidade. Tente novamente.",
				loadError: "Falha ao carregar unidades. Tente novamente.",
			},
			toasts: {
				creating: "Criando unidade...",
				createSuccess: "Unidade criado com sucesso!",
				createError: "Falha ao criar unidade. Tente novamente.",
				updating: "Atualizando unidade...",
				updateSuccess: "Unidade atualizado com sucesso!",
				updateError: "Falha ao atualizar unidade. Tente novamente.",
				deleting: "Excluindo unidade...",
				deleteSuccess: "Unidade excluído com sucesso!",
				deleteError: "Falha ao excluir unidade. Tente novamente.",
			},
		},
	},
	staff: {
		searchPlaceholder: "Buscar membros da equipe e convites...",
		noStaffFound: "Nenhum membro da equipe encontrado",
		management: {
			title: "Gerenciamento de Equipe",
			description:
				"Gerencie os membros da equipe da sua organização e suas funções",
			inviteNew: "Convidar Membro da Equipe",
			inviteDescription:
				"Envie um convite para um novo membro da equipe se juntar à sua organização",
			noStaff: "Ainda não há membros da equipe",
			noStaffDescription:
				"Comece convidando seu primeiro membro da equipe para se juntar à sua organização.",
			noStaffSearchDescription:
				"Nenhum membro da equipe ou convite encontrado que corresponda aos seus critérios de busca.",
			filterByStaff: "Filtrar por Instrutor",
		},
		navigation: {
			title: "Detalhes do Membro da Equipe",
			description: "Visualizar e gerenciar informações do membro da equipe",
			unknownStaff: "Membro da Equipe Desconhecido",
			overview: "Visão Geral",
			staffData: "Dados da Equipe",
			permissions: "Função e Permissões",
		},
		overview: {
			totalSchedules: "Total de Horários",
			personalInformation: "Informações Pessoais",
			organizationInformation: "Informações da Organização",
			role: "Função",
			joinedAt: "Ingressou em",
			quickActions: {
				removeStaffMember: "Remover Membro da Equipe",
				revokeInvitation: "Revogar Convite",
				migrateSchedules: "Migrar Horários",
			},
			revokeInvitation: {
				title: "Revogar Convite",
				description:
					"Tem certeza de que deseja revogar o convite para {{name}}?",
			},
			invitationInfo: {
				title: "Detalhes do Convite",
				email: "Email",
				role: "Função",
				expiresAt: "Expira em",
			},
		},
		edit: {
			title: "Editar Membro da Equipe",
			description: "Editar informações e permissões de {{name}}",
		},
		schedules: {
			title: "Horários Atribuídos",
			description: "Ver todos os horários atribuídos a este membro da equipe",
			noSchedules: "Nenhum horário atribuído",
			noSchedulesDescription:
				"Este membro da equipe não está atualmente atribuído a nenhum horário.",
		},
		permissions: {
			title: "Função e Permissões",
			description: "Gerenciar função e acesso as unidades do membro da equipe",
		},
		table: {
			member: "Membro da Equipe",
			role: "Função",
			status: "Status",
			joinedAt: "Ingressou",
			actions: "Ações",
		},
		form: {
			sections: {
				contact: "Informações de Contato",
				permissions: "Função e Permissões",
				information: {
					title: "Informações da Equipe",
					description: "Informações básicas sobre o membro da equipe",
					editMode: "Editar seu nome",
					firstName: "Primeiro Nome",
					lastName: "Sobrenome",
					firstNamePlaceholder: "Digite o primeiro nome",
					lastNamePlaceholder: "Digite o sobrenome",
					color: "Cor",
					colorDescription:
						"Esta cor será usada para identificar este membro da equipe nos horários e calendários",
					saveChanges: "Salvar Alterações",
					cancel: "Cancelar",
					updateSuccess: "Nome atualizado com sucesso",
					updateError: "Falha ao atualizar o nome. Por favor, tente novamente.",
				},
				organizationRole: {
					title: "Função na Organização",
					description:
						"Defina a função e permissões organizacionais para este membro da equipe",
				},
				establishments: {
					title: "Acesso aos Unidades",
					description:
						"Atribua este membro da equipe as unidades para acesso aos dados",
				},
			},
			email: "Endereço de Email",
			emailPlaceholder: "Digite o endereço de email",
			name: "Nome (Opcional)",
			namePlaceholder: "Digite o nome completo",
			role: "Função",
			organizationRole: "Função na Organização",
			joinedAt: "Ingressou em {{date}}",
			organizationRoleDescription:
				"Esta função determina quais recursos o membro da equipe pode acessar em toda a organização",
			selectOrganizationRole: "Selecione uma função na organização",
			organizationRolesHeader: "Funções da Organização",
			assignEstablishment: "Atribuir ao Unidade",
			assignEstablishmentDescription:
				"Selecione uma unidade para dar acesso aos dados deste membro da equipe",
			assignEstablishments: "Atribuir aos Unidades",
			assignEstablishmentsDescription:
				"Selecione unidades para dar acesso aos dados deste membro da equipe",
			selectEstablishment: "Selecionar unidade",
			selectedEstablishments: "{{count}} unidade(s) selecionado(s)",
			currentAssignments: "Atualmente Atribuído a",
			availableEstablishments: "Unidades Disponíveis",
			assignedOn: "atribuído em {{date}}",
			removeAssignment: "Remover atribuição",
			allEstablishmentsAssigned:
				"Este membro da equipe já está atribuído a todos as unidades",
			updateRole: "Atualizar Função",
			assign: "Atribuir",
			assignSelected: "Atribuir Selecionados",
			viewPermissions: "Ver Permissões",
			permissionsMatrix: "Matriz de Permissões",
			rolePermissionsMatrix: "Matriz de Permissões de Funções",
			permissionsDescription:
				"Abaixo estão as permissões concedidas à função selecionada.",
			permissionsMatrixDescription:
				"Esta matriz mostra todas as permissões para cada função na organização.",
			permission: "Permissão",
			roleDescription: {
				title: "Permissões da Função:",
				administrator:
					"Pode gerenciar todos os aspectos da organização incluindo equipe, unidades e configurações.",
				viewer:
					"Pode visualizar dados da organização mas não pode fazer alterações ou gerenciar outros membros da equipe.",
			},
			roleDescriptions: {
				org_owner:
					"Acesso completo a todos os recursos e configurações da organização",
				org_administrator:
					"Gerenciar configurações da organização, equipe e todos os recursos",
				org_manager:
					"Gerenciar operações diárias, equipe e a maioria dos recursos",
				org_medical_professional:
					"Acesso a registros médicos e recursos relacionados",
				org_accountant:
					"Acesso a dados financeiros e gerenciamento de pagamentos",
				org_viewer: "Acesso somente leitura aos dados da organização",
				org_instructor_calendar_only:
					"Acesso somente leitura ao calendário de presença e sessões",
				org_no_access: "Suspenso — sem acesso a nenhum recurso da organização",
				viewer:
					"Pode visualizar dados da organização mas não pode fazer alterações ou gerenciar outros membros da equipe.",
			},
			sendInvite: "Enviar Convite",
		},
		editRole: {
			title: "Editar Função da Equipe",
			description: "Alterar a função para {{name}}",
			organizationRole: "Função na Organização",
			organizationRoleDescription:
				"Esta função se aplica a toda a organização e determina as permissões gerais.",
		},
		remove: {
			title: "Remover Membro da Equipe",
			description:
				"Tem certeza de que deseja remover {{name}} da organização? Esta ação não pode ser desfeita.",
			confirm: "Remover Membro da Equipe",
			loadingSchedules: "Carregando horários...",
			schedulesWarning:
				"Este membro da equipe tem {{count}} horário(s) com sessões futuras:",
			schedulesBlockedMessage:
				"Você deve reatribuir ou remover todos os horários com sessões futuras antes que este membro da equipe possa ser excluído.",
		},
		status: {
			active: "Ativo",
			pending: "Pendente",
		},
		invitation: {
			expires: "Expira",
			revokeSuccess: "Convite revogado com sucesso",
			revokeError: "Falha ao revogar convite. Tente novamente.",
			revoke: {
				title: "Revogar Convite",
				description:
					"Tem certeza de que deseja revogar o convite para {{name}}? Esta ação não pode ser desfeita.",
				confirm: "Revogar Convite",
			},
		},
		validation: {
			emailRequired: "Endereço de email é obrigatório",
		},
		inviteSuccess: "Convite da equipe enviado com sucesso",
		inviteError: "Falha ao enviar convite da equipe. Tente novamente.",
		roleUpdateSuccess: "Função do membro da equipe atualizada com sucesso",
		roleUpdateError:
			"Falha ao atualizar função do membro da equipe. Tente novamente.",
		removeSuccess: "Membro da equipe removido com sucesso",
		removeError: "Falha ao remover membro da equipe. Tente novamente.",
		toasts: {
			inviting: "Enviando convite da equipe...",
			inviteSuccess: "Convite da equipe enviado com sucesso!",
			inviteError: "Falha ao enviar convite da equipe. Tente novamente.",
			updating: "Atualizando função do membro da equipe...",
			updateSuccess: "Função do membro da equipe atualizada com sucesso!",
			updateError:
				"Falha ao atualizar função do membro da equipe. Tente novamente.",
			removing: "Removendo membro da equipe...",
			removeSuccess: "Membro da equipe removido com sucesso!",
			removeError: "Falha ao remover membro da equipe. Tente novamente.",
			revoking: "Revogando convite...",
			revokeSuccess: "Convite revogado com sucesso!",
			revokeError: "Falha ao revogar convite. Tente novamente.",
		},
		actions: {
			assignToEstablishment: "Atribuir ao Unidade",
		},
		migrateSchedules: {
			title: "Migrar Horários",
			description:
				"Selecione os horários para migrar e atribua-os aos membros da equipe destino.",
			warning:
				"Esta ação irá transferir os horários selecionados e suas sessões para os membros da equipe atribuídos. Esta operação não pode ser facilmente desfeita.",
			searchPlaceholder: "Buscar horários...",
			assignSelectedTo: "Atribuir selecionados para:",
			assignButton: "Atribuir",
			selectTargetPlaceholder: "Selecione um membro da equipe...",
			assignedCount: "{{count}} horário(s) atribuído(s) para migrar",
			noAssignments: "Nenhum horário atribuído ainda",
			continueButton: "Continuar",
			confirmationWarning:
				"Você está prestes a migrar {{count}} horário(s). Esta ação não pode ser facilmente desfeita.",
			confirmationDescription:
				"Todos os horários atribuídos e suas sessões serão transferidos para os membros da equipe selecionados.",
			assignmentSummary: "Resumo das Atribuições",
			schedulesCount_one: "horário",
			schedulesCount_other: "horários",
			confirmLabel: 'Digite "confirm" para prosseguir',
			confirmPlaceholder: "confirm",
			confirmButton: "Migrar Horários",
			toasts: {
				migrating: "Migrando horários...",
				migrateSuccess: "Horários migrados com sucesso!",
				migrateError: "Falha ao migrar horários. Tente novamente.",
			},
		},
		assignEstablishment: {
			title: "Atribuir ao Unidade",
			description: "Atribuir {{name}} a uma unidade com uma função específica",
			establishment: "Unidade",
			selectEstablishment: "Selecione uma unidade",
			role: "Função no Unidade",
			establishmentRole: "Função no Unidade",
			establishmentRoleDescription:
				"Esta função se aplica apenas a unidade selecionado e determina as permissões locais.",
			selectEstablishmentRole: "Selecione uma função na unidade",
			establishmentRolesHeader: "Funções no Nível do Unidade",
			confirm: "Atribuir ao Unidade",
			roleDescriptions: {
				establishment_manager:
					"Gerenciar todos os aspectos desta unidade específico",
				instructor: "Conduzir aulas e gerenciar horários nesta unidade",
				receptionist:
					"Lidar com operações de recepção e atendimento ao cliente",
				medical_staff:
					"Fornecer serviços médicos e gerenciar registros de saúde",
				assistant: "Apoiar operações diárias e auxiliar outros funcionários",
				viewer: "Visualizar informações da unidade sem fazer alterações",
			},
		},
	},
	establishmentStaff: {
		toasts: {
			assigning: "Atribuindo equipe a unidade...",
			assignSuccess: "Equipe atribuída a unidade com sucesso!",
			assignError: "Falha ao atribuir equipe a unidade. Tente novamente.",
			bulkAssigning: "Atribuindo equipe as unidades...",
			bulkAssignSuccess: "Equipe atribuída as unidades com sucesso!",
			bulkAssignError: "Falha ao atribuir equipe as unidades. Tente novamente.",
			updating: "Atualizando função da equipe da unidade...",
			updateSuccess: "Função da equipe da unidade atualizada com sucesso!",
			updateError:
				"Falha ao atualizar função da equipe da unidade. Tente novamente.",
			removing: "Removendo equipe da unidade...",
			removeSuccess: "Equipe removida da unidade com sucesso!",
			removeError: "Falha ao remover equipe da unidade. Tente novamente.",
		},
	},
	billing: {
		monthly: "Mensal",
		quarterly: "Trimestral",
		semi_annual: "Semestral",
		annually: "Anual",
		status: {
			DRAFT: "Rascunho",
			OPEN: "Aberta",
			PARTIALLY_PAID: "Parcialmente Paga",
			PAID: "Paga",
			OVERDUE: "Vencida",
			CANCELED: "Cancelada",
		},
		paymentStatus: {
			PENDING: "Pendente",
			PROCESSING: "Processando",
			SUCCEEDED: "Confirmado",
			PARTIALLY_REFUNDED: "Parcialmente Reembolsado",
			REFUNDED: "Reembolsado",
			CHARGEBACK_PENDING: "Contestação Pendente",
			CHARGEBACK_LOST: "Contestação Perdida",
			FAILED: "Falhou",
			CANCELED: "Cancelado",
		},
		navigation: {
			title: "Financeiro",
			invoices: "Vendas",
			payments: "Pagamentos",
		},
		invoices: {
			title: "Vendas",
			description: "Gerenciar vendas",
			noInvoices: "Nenhuma venda encontrada",
			createInvoice: "Nova Venda",
			invoiceNumber: "Venda #",
			customer: "Cliente",
			enrollment: "Matrícula",
			amount: "Valor",
			amountDue: "Valor a Pagar",
			amountPaid: "Valor Pago",
			payments: "Pagamentos",
			dueDate: "Vencimento",
			issueDate: "Data de Emissão",
			status: "Status",
			lineItems: "Itens",
			periodStart: "Início do Período",
			periodEnd: "Fim do Período",
			notes: "Observações",
			actions: {
				create: "Nova Venda",
				view: "Ver Venda",
				edit: "Editar Venda",
				issue: "Emitir Venda",
				cancel: "Cancelar Venda",
				recordPayment: "Registrar Pagamento",
			},
			statuses: {
				DRAFT: "Rascunho",
				OPEN: "Aberta",
				PARTIALLY_PAID: "Parcialmente Paga",
				PAID: "Paga",
				OVERDUE: "Vencida",
				CANCELED: "Cancelada",
			},
			toasts: {
				creating: "Criando Venda...",
				createSuccess: "Venda criada com sucesso!",
				createError: "Falha ao criar Venda. Por favor, tente novamente.",
				updating: "Atualizando Venda...",
				updateSuccess: "Venda atualizada com sucesso!",
				updateError: "Falha ao atualizar Venda. Por favor, tente novamente.",
				issuing: "Emitindo Venda...",
				issueSuccess: "Venda emitida com sucesso!",
				issueError: "Falha ao emitir Venda. Por favor, tente novamente.",
				canceling: "Cancelando Venda...",
				cancelSuccess: "Venda cancelada com sucesso!",
				cancelError: "Falha ao cancelar venda. Por favor, tente novamente.",
			},
			cancelDialog: {
				title: "Cancelar Venda",
				description:
					"Tem certeza de que deseja cancelar a venda {{invoiceNumber}}? Essa ação não pode ser desfeita.",
				invoiceInfoTitle: "Detalhes da venda",
				confirm: "Sim, cancelar venda",
				loading: "Cancelando venda...",
			},
		},
		payments: {
			title: "Pagamentos",
			description: "Visualizar e gerenciar pagamentos",
			noPayments: "Nenhum pagamento encontrado",
			recordPayment: "Registrar Pagamento",
			amount: "Valor",
			method: "Método",
			status: "Status",
			paidAt: "Pago em",
			invoice: "Venda",
			customer: "Cliente",
			customerName: "Nome do Cliente",
			reference: "Referência",
			notes: "Observações",
			walkInCustomer: "Cliente Avulso",
			actions: {
				view: "Ver Pagamento",
				cancel: "Cancelar Pagamento",
				refund: "Reembolsar",
			},
			statuses: {
				PENDING: "Pendente",
				PROCESSING: "Processando",
				SUCCEEDED: "Confirmado",
				PARTIALLY_REFUNDED: "Parcialmente Reembolsado",
				REFUNDED: "Reembolsado",
				CHARGEBACK_PENDING: "Contestação Pendente",
				CHARGEBACK_LOST: "Contestação Perdida",
				FAILED: "Falhou",
				CANCELED: "Cancelado",
			},
			methods: {
				CARD: "Cartão",
				PIX: "PIX",
				BOLETO: "Boleto",
				CASH: "Dinheiro",
				BANK_TRANSFER: "Transferência Bancária",
				OTHER: "Outro",
			},
			toasts: {
				creating: "Registrando pagamento...",
				createSuccess: "Pagamento registrado com sucesso!",
				createError:
					"Falha ao registrar pagamento. Por favor, tente novamente.",
				canceling: "Cancelando pagamento...",
				cancelSuccess: "Pagamento cancelado com sucesso!",
				cancelError: "Falha ao cancelar pagamento. Por favor, tente novamente.",
			},
		},
		refunds: {
			title: "Reembolsos",
			description: "Visualizar e gerenciar reembolsos",
			createRefund: "Criar Reembolso",
			amount: "Valor",
			reason: "Motivo",
			status: "Status",
			processedAt: "Processado em",
			statuses: {
				PENDING: "Pendente",
				PROCESSING: "Processando",
				SUCCEEDED: "Confirmado",
				FAILED: "Falhou",
			},
			toasts: {
				creating: "Processando reembolso...",
				createSuccess: "Reembolso processado com sucesso!",
				createError:
					"Falha ao processar reembolso. Por favor, tente novamente.",
			},
		},
		invoiceDetails: {
			title: "Detalhes da Venda",
			description: "Visualizar e gerenciar detalhes da venda",
			tabs: {
				overview: "Visão Geral",
				payments: "Pagamentos",
				refunds: "Reembolsos",
				disputes: "Disputas",
			},
			overview: {
				invoiceId: "ID da Venda",
				customer: "Cliente",
				dates: "Datas",
				issuedAt: "Emitida",
				dueDate: "Vencimento",
				paidAt: "Paga",
				summary: "Resumo",
				total: "Total",
				paid: "Pago",
				remaining: "Restante",
				lineItems: "Itens",
				description: "Descrição",
				quantity: "Qtd",
				unitPrice: "Preço Unit.",
				amount: "Valor",
				recentPayments: "Pagamentos Recentes",
				unknownMethod: "Desconhecido",
				notes: "Observações",
			},
			payments: {
				title: "Pagamentos",
				paidOf: "{{paid}} pago de {{total}}",
				recordPayment: "Registrar Pagamento",
				paymentsList: "Lista de Pagamentos",
				noPayments: "Nenhum pagamento registrado",
				date: "Data",
				method: "Método",
				status: "Status",
				reference: "Ref. Pagamento",
				refundedAmount: "Valor Reembolsado",
				amount: "Valor",
				actions: "Ações",
				unknownMethod: "Desconhecido",
				refund: "Reembolsar",
				remainingBalance: "Saldo Restante",
			},
			refunds: {
				title: "Reembolsos",
				description: "Visualizar reembolsos desta venda",
				refundsList: "Lista de Reembolsos",
				noRefunds: "Nenhum reembolso registrado",
				noRefundsHint: "Reembolsos podem ser criados na aba Pagamentos",
				date: "Data",
				paymentRef: "Ref. Pagamento",
				reason: "Motivo",
				status: "Status",
				amount: "Valor",
			},
			disputes: {
				title: "Disputas",
				description: "Visualizar disputas desta venda",
				disputesList: "Lista de Disputas",
				noDisputes: "Nenhuma disputa registrada",
				noDisputesHint:
					"Disputas são sincronizadas dos provedores de pagamento",
				date: "Data",
				type: "Tipo",
				reason: "Motivo",
				status: "Status",
				amount: "Valor",
			},
		},
		refund: {
			title: "Criar Reembolso",
			description: "Reembolsar pagamento de {{paymentAmount}}",
			refundType: "Tipo de Reembolso",
			fullRefund: "Reembolso total",
			invoiceLine: "Item da Venda (Devolução)",
			customAmount: "Valor Personalizado",
			selectLine: "Selecionar Item da Venda",
			selectLines:
				"Opcional: selecione itens apenas para adicioná-los como motivo do reembolso",
			selectLinePlaceholder: "Selecione um item...",
			quantity: "Quantidade a Reembolsar",
			amount: "Valor do Reembolso",
			reason: "Motivo do Reembolso *",
			reasonPlaceholder: "Digite o motivo deste reembolso...",
			autoReason: "Reembolso de: {{description}} x{{quantity}} (R${{amount}})",
			autoReasonMultiple: "Reembolso de: {{items}} (R${{amount}})",
			noLineItems: "Nenhum item disponível",
			summary: "Resumo do Reembolso",
			refundAmount: "Valor do Reembolso",
			exceedsMax: "Valor excede o máximo reembolsável",
			readyToProcess: "Pronto para processar",
			confirm: "Confirmar Reembolso",
		},
		refundStatus: {
			pending: "Pendente",
			succeeded: "Confirmado",
			failed: "Falhou",
		},
		recordPayment: {
			title: "Registrar Pagamento",
			description: "Registrar um pagamento para esta venda",
			total: "Total",
			paid: "Pago",
			outstanding: "Pendente",
			amount: "Valor do Pagamento",
			method: "Método de Pagamento",
			date: "Data do Pagamento",
			reference: "Referência Externa",
			referencePlaceholder: "ID da transação PIX, número do cheque, etc.",
			notes: "Observações",
			notesPlaceholder: "Observações adicionais sobre este pagamento...",
			summary: "Resumo do Pagamento",
			recordingAmount: "Registrando pagamento de {{amount}} via {{method}}",
			remainingAfter: "Saldo restante após pagamento",
			invoiceWillBe: "A venda será marcada como",
			exceedsOutstanding: "Valor não pode exceder o saldo pendente ({{max}})",
			readyToRecord: "Pronto para registrar",
			confirm: "Registrar Pagamento",
		},
		disputeStatus: {
			open: "Aberta",
			underReview: "Em Análise",
			won: "Ganha",
			lost: "Perdida",
		},
		providerAccounts: {
			title: "Formas de Pagamento",
			description: "Gerenciar contas de provedores de pagamento",
			noAccounts: "Nenhuma forma de pagamento configurada",
			addAccount: "Adicionar Forma de Pagamento",
			accountName: "Nome da Conta",
			provider: "Provedor",
			selectProvider: "Selecione um provedor",
			methodName: "Nome",
			methodNamePlaceholder: "Digite o nome da forma de pagamento",
			supportedMethods: "Métodos Suportados",
			isDefault: "Padrão",
			isActive: "Ativo",
			providers: {
				MANUAL: "Manual",
			},
			toasts: {
				creating: "Criando forma de pagamento...",
				createSuccess: "Forma de pagamento criada com sucesso!",
				createError:
					"Falha ao criar forma de pagamento. Por favor, tente novamente.",
				updating: "Atualizando forma de pagamento...",
				updateSuccess: "Forma de pagamento atualizada com sucesso!",
				updateError:
					"Falha ao atualizar forma de pagamento. Por favor, tente novamente.",
				deleting: "Excluindo forma de pagamento...",
				deleteSuccess: "Forma de pagamento excluída com sucesso!",
				deleteError:
					"Falha ao excluir forma de pagamento. Por favor, tente novamente.",
			},
		},
		lineItemTypes: {
			enrollment: "Matrícula",
			product: "Produto",
			service: "Serviço",
			discount: "Desconto",
			credit: "Crédito",
			fee: "Taxa",
		},
		currencies: {
			BRL: "Real Brasileiro (R$)",
			USD: "Dólar Americano ($)",
		},
		paymentMethods: {
			card: "Cartão",
			pix: "PIX",
			boleto: "Boleto",
			cash: "Dinheiro",
			bank_transfer: "Transferência Bancária",
			other: "Outro",
		},
		wizard: {
			title: "Nova Venda",
			description: "Crie uma nova venda e opcionalmente registre pagamentos",
			steps: {
				invoice: "Detalhes da Venda",
				payment: "Registrar Pagamentos",
			},
			actions: {
				createInvoice: "Finalizar Venda",
				proceedToPayment: "Continuar para pagamento",
			},
			invoice: {
				customer: "Cliente",
				selectCustomer: "Selecionar Cliente",
				selectCustomerDescription:
					"Pesquise e selecione um cliente para esta venda",
				clickToSelect: "Clique para selecionar",
				searchCustomerPlaceholder: "Pesquisar por nome, email ou ID...",
				typeToSearch: "Digite pelo menos 2 caracteres para pesquisar",
				noCustomersFound: "Nenhum cliente encontrado",
				currency: "Moeda",
				dueDate: "Data de Vencimento",
				lineItems: "Itens da Venda",
				lineItemsDescription: "Adicione produtos, serviços ou matrículas",
				addLineItem: "Adicionar Item",
				addFirstItem: "Adicionar Primeiro Item",
				addAnotherItem: "Adicionar Outro Item",
				noLineItems: "Nenhum item adicionado",
				noLineItemsHint:
					"Adicione itens para criar a venda. Clique no botão acima para começar.",
				item: "item",
				items: "itens",
				type: "Tipo",
				description: "Descrição",
				descriptionPlaceholder: "Digite a descrição...",
				quantity: "Qtd",
				unitAmount: "Preço Unitário",
				total: "Total",
				totalAmount: "Valor Total",
				notes: "Observações",
				notesPlaceholder: "Adicione observações para esta venda...",
				selectCustomerFirst: "Selecione um cliente primeiro",
				noEnrollmentsAvailable: "Sem matrículas pendentes",
				selectEnrollment: "Selecionar matrícula...",
				ends: "Termina",
				validation: {
					singleCurrencyTitle: "Todos os itens devem usar a mesma moeda",
					singleCurrencyMessage:
						"Esta venda contém itens em moedas diferentes. Ajuste ou remova os itens para que todos usem a mesma moeda.",
				},
			},
			payment: {
				invoiceTotal: "Total da Venda",
				totalPaid: "Total Recebido",
				outstanding: "Pendente",
				invoiceFor: "Venda para",
				noCustomer: "Avulsa",
				paymentProgress: "Progresso do pagamento",
				description:
					"Adicione pagamentos para registrar nesta venda. Esta etapa é opcional - você pode pular e registrar pagamentos depois.",
				addPayment: "Adicionar Pagamento",
				addAnotherPayment: "Adicionar Outro Pagamento",
				payFullAmount: "Receber Valor Total",
				payCustomAmount: "Receber Valor Personalizado",
				noPayments: "Nenhum pagamento adicionado",
				noPaymentsHint:
					"Você pode registrar o pagamento total agora ou pular esta etapa e registrar depois",
				paymentNumber: "Pagamento #{{number}}",
				paymentSingular: "pagamento",
				paymentPlural: "pagamentos",
				amount: "Valor",
				method: "Forma de Pagamento",
				date: "Data do Pagamento",
				reference: "Referência",
				referencePlaceholder: "ID da transação, número do recibo, etc.",
				notes: "Observações",
				notesPlaceholder: "Observações adicionais...",
				additionalOptions: "Opções adicionais",
				fullyPaid: "Pagamento completo",
			},
			confirmation: {
				title: "Revisar e Confirmar",
				description:
					"Revise os detalhes abaixo antes de finalizar. Clique em 'Finalizar Venda' para criar.",
				customer: "Cliente",
				invoiceSummary: "Itens da Venda",
				dueDate: "Data de Vencimento",
				paymentsSummary: "Pagamentos a Registrar",
				fullyPaid: "Esta venda será marcada como totalmente paga",
				partiallyPaid: "Saldo pendente: {{amount}}",
				noPendingPayment: "Nenhum pagamento será registrado",
			},
		},
	},
	customerPlans: {
		billingCycle: {
			monthly: "Mensal",
			quarterly: "Trimestral",
			semi_annual: "Semestral",
			annually: "Anual",
		},
		billingCyclePlan: {
			monthly: "Plano mensal",
			quarterly: "Plano trimestral",
			semi_annual: "Plano semestral",
			annually: "Plano anual",
		},
		management: {
			title: "Planos de Cliente",
			description: "Gerencie os planos de cliente da sua organização",
			createNew: "Criar Novo Plano",
			noPlans: "Nenhum Plano de Cliente",
			noPlansDescription: "Você ainda não criou nenhum plano de cliente",
			createFirst: "Criar Seu Primeiro Plano",
			delete: {
				title: "Excluir Plano de Cliente",
				description:
					"Tem certeza de que deseja excluir este plano de cliente? Esta ação não pode ser desfeita.",
			},
			table: {
				name: "Nome",
				description: "Descrição",
				price: "Preço",
				billingCycle: "Ciclo de Assinatura",
				features: "Serviços Oferecidos",
				establishments: "Unidades",
				allEstablishments: "Todas as Unidades",
				weeklySessionsLimit: "Sessões Semanais",
				status: "Status",
				actions: "Ações",
				totalAmount: "Valor Total",
				monthlyAverage: "Média Mensal",
			},
			form: {
				sections: {
					basicInfo: "Informações Básicas",
					pricing: "Preços e Assinaturas",
					features: "Serviços Oferecidos",
					establishments: "Unidades",
					status: "Status do Plano",
				},
				name: "Nome",
				namePlaceholder: "Ex: Premium Mensal, Plano Estudante",
				nameHint:
					"Escolha um nome claro e descritivo que os clientes reconheçam",
				nameMaxLength: "{{current}}/{{max}} caracteres",
				description: "Descrição",
				descriptionPlaceholder:
					"Descreva o que este plano inclui e para quem é destinado...",
				descriptionHint:
					"Uma boa descrição ajuda os clientes a entender o valor do plano",
				price: "Preço",
				pricePlaceholder: "0,00",
				priceHint: "Defina o preço para o ciclo de cobrança selecionado",
				currency: "Moeda",
				currencyPlaceholder: "Selecione a moeda",
				billingCycle: "Ciclo de Cobrança",
				billingCycleHint:
					"Com que frequência os clientes serão cobrados por este plano",
				billingCycleOptions: {
					MONTHLY: "Mensal",
					QUARTERLY: "Trimestral",
					SEMI_ANNUAL: "Semestral",
					ANNUALLY: "Anual",
				},
				features: "Serviços",
				featuresPlaceholder:
					"Ex: Acesso a todos os equipamentos, Consulta individual",
				featuresHint: "Liste os serviços e benefícios incluídos neste plano",
				addFeature: "Adicionar Serviço",
				removeFeature: "Remover",
				quickServicesTitle:
					"Serviços comuns: clique para adicionar rapidamente",
				quickServices: {
					pilates: "Pilates",
					yoga: "Yoga",
					meditation: "Meditação",
					functionalTraining: "Treinamento funcional",
					stretching: "Alongamento",
					physiotherapy: "Fisioterapia",
				},
				weeklySessionsLimit: "Limite de Sessões Semanais",
				weeklySessionsLimitPlaceholder: "Ex: 3",
				weeklySessionsLimitHint:
					"Opcional: Limite de sessões por semana (1-20). Deixe vazio para ilimitado",
				establishments: "Unidades",
				establishmentsOptional: "opcional",
				establishmentsPlaceholder: "Selecione unidades (opcional)",
				establishmentsSelected: "unidades selecionadas",
				clearEstablishments: "Limpar Todos",
				establishmentsHelp:
					"Deixe vazio para disponibilizar este plano em todas as unidades",
				selectedEstablishments: "Unidades Selecionadas",
				isActive: "Ativo",
				statusDescription:
					"Planos ativos são visíveis aos clientes e podem ser adquiridos",
				statusHint:
					"Planos inativos não estarão disponíveis para novas matrículas",
				create: "Criar Plano",
				update: "Atualizar Plano",
				cancel: "Cancelar",
				creating: "Criando...",
				updating: "Atualizando...",
				requiredFields: "* Campos obrigatórios",
				validation: {
					nameRequired: "Nome do plano é obrigatório",
					descriptionRequired: "Descrição do plano é obrigatória",
					priceRequired: "Preço válido é obrigatório",
					featuresRequired: "Pelo menos um serviço é obrigatório",
					weeklySessionsLimitInvalid:
						"Limite de sessões semanais deve estar entre 1 e 20",
				},
			},
			actions: {
				edit: "Editar",
				delete: "Excluir",
				activate: "Ativar",
				deactivate: "Desativar",
				confirmDelete:
					"Tem certeza de que deseja excluir este plano de cliente?",
				confirmDeleteDescription:
					"Esta ação não pode ser desfeita. Todos os dados associados a este plano serão permanentemente excluídos.",
				confirmDeleteWarning:
					"Nota: Planos de cliente com usuários inscritos não podem ser excluídos até que todas as matrículas relacionadas sejam removidas deste plano.",
			},
			status: {
				active: "Ativo",
				inactive: "Inativo",
			},
			messages: {
				createSuccess: "Plano de cliente criado com sucesso",
				createError: "Falha ao criar plano de cliente. Tente novamente.",
				updateSuccess: "Plano de cliente atualizado com sucesso",
				updateError: "Falha ao atualizar plano de cliente. Tente novamente.",
				deleteSuccess: "Plano de cliente excluído com sucesso",
				deleteError: "Falha ao excluir plano de cliente. Tente novamente.",
				loadError: "Falha ao carregar planos de cliente. Tente novamente.",
				featuresRequired: "Pelo menos um serviço é obrigatório",
			},
			toasts: {
				creating: "Criando plano de cliente...",
				createSuccess: "Plano de cliente criado com sucesso!",
				createError: "Falha ao criar plano de cliente. Tente novamente.",
				updating: "Atualizando plano de cliente...",
				updateSuccess: "Plano de cliente atualizado com sucesso!",
				updateError: "Falha ao atualizar plano de cliente. Tente novamente.",
				deleting: "Excluindo plano de cliente...",
				deleteSuccess: "Plano de cliente excluído com sucesso!",
				deleteError: "Falha ao excluir plano de cliente. Tente novamente.",
			},
		},
	},
	enrollments: {
		confirmation_modal: {
			title: "Confirmação de Matrícula",
		},
		conflictWarningModal: {
			title: "Conflitos de Horário Detectados",
			description:
				"O cliente já possui matrículas ativas com horários que conflitam com o novo horário que está sendo criado.",
			confirmHint:
				"Você pode continuar, mas o cliente terá horários sobrepostos.",
			confirm: "Continuar Mesmo Assim",
		},
		management: {
			title: "Gerenciamento de Matrículas",
			description: "Gerencie matrículas de clientes em horários e planos",
		},
		navigation: {
			title: "Detalhes da Matrícula",
			description: "Visualize e gerencie informações da matrícula",
			edit: "Editar Matrícula",
			unknownCustomer: "Cliente Desconhecido",
		},
		errors: {
			inlineModeNotAllowed:
				"Modo de criação inline não permitido para esta organização",
			scheduleConflictsFound: "Conflitos de horário encontrados: {{details}}",
			invalidPayloadKind: "Tipo de solicitação inválido: {{kind}}",
			permissionDenied: "Permissão negada: {{details}}",
			duplicateEnrollment:
				"Matrícula duplicada: Cliente já está matriculado neste horário",
			weeklyLimitExceeded:
				"Limite semanal excedido: {{current}} de {{limit}} sessões",
			scheduleInactive: "Horário inativo: {{details}}",
			scheduleNotFound: "Horário não encontrado: {{details}}",
			customerNotFound: "Cliente não encontrado: {{details}}",
			customerPlanNotFound: "Plano do cliente não encontrado: {{details}}",
			establishmentNotFound: "Unidade não encontrado: {{details}}",
			staffMemberNotFound: "Membro da equipe não encontrado: {{details}}",
			invalidDateRange: "Intervalo de datas inválido: {{details}}",
			capacityExceeded: "Capacidade excedida: {{details}}",
			validationFailed: "Falha na validação: {{details}}",
			databaseError: "Erro no banco de dados: {{details}}",
			networkError: "Erro de rede: {{details}}",
			unknownError: "Erro desconhecido: {{details}}",
		},
		list: {
			title: "Matrículas",
			empty: "Nenhuma matrícula encontrada",
		},
		table: {
			customer: "Cliente",
			plan: "Plano",
			schedule: "Horário",
			schedules: "Horários",
			status: "Status",
			startDate: "Data de Início",
			endDate: "Data de Fim",
			noEndDate: "Sem data de fim",
			actions: "Ações",
		},
		filters: {
			statusLabel: "Status",
			statusPlaceholder: "Filtrar por status",
			activeAndPending: "Ativas e Pendentes",
			allStatuses: "Todos os status",
			selectedStatuses: "{{count}} status selecionado(s)",
			expiringSoon: "Vencendo em Breve",
		},
		badges: {
			closeToExpire: "Próximo ao vencimento",
		},
		status: {
			pending: "Pendente",
			active: "Ativo",
			paused: "Pausado",
			canceled: "Cancelado",
			completed: "Concluído",
			expired: "Vencida",
		},
		delete: {
			title: "Excluir Matrícula",
			description:
				"Tem certeza que deseja excluir esta matrícula? Isso removerá o cliente de todas as sessões relacionadas ao horário.",
		},
		cancel: {
			title: "Cancelar Matrícula",
			description:
				"Tem certeza que deseja cancelar esta matrícula? O cliente será removido de todas as sessões futuras do horário.",
			confirm: "Cancelar Matrícula",
			onlyEnrollment: "Único",
			schedulesOnlyThisEnrollment:
				"{{count}} horário(s) possui(em) apenas esta matrícula",
			schedulesOnlyThisEnrollment_one:
				"Este horário possui apenas esta matrícula",
			schedulesOnlyThisEnrollment_other:
				"{{count}} horários possuem apenas esta matrícula",
			deleteSchedulesExplanation:
				"Você pode também excluir os horários que ficarão sem matrículas após o cancelamento.",
			alsoDeleteSchedules: "Excluir também os horários sem outras matrículas",
			alsoDeleteSchedules_one: "Excluir também o horário sem outras matrículas",
			alsoDeleteSchedules_other:
				"Excluir também os {{count}} horários sem outras matrículas",
		},
		actions: {
			create: "Criar Matrícula",
			proceedToPayment: "Prosseguir para Pagamento",
			payNow: "Pagar Agora",
			confirmDelete:
				"Tem certeza que deseja excluir esta matrícula? Isso removerá o cliente de todas as sessões relacionadas ao horário.",
			pause: "Pausar Matrícula",
			unpause: "Retomar Matrícula",
			renew: "Renovar Matrícula",
			extend: "Estender Matrícula",
		},
		renewal: {
			description: "{{planName}} - Período: {{startDate}} - {{endDate}}",
		},
		pause: {
			title: "Pausar Matrícula",
			description:
				"Pausar esta matrícula suspenderá temporariamente o cliente de participar das sessões agendadas. Você pode retomá-la a qualquer momento.",
			confirm: "Pausar Matrícula",
			reasonLabel: "Motivo (opcional)",
			reasonPlaceholder: "Digite um motivo para pausar...",
			pauseEndDateLabel: "Data de Retorno (opcional)",
			pauseEndDateHint: "Deixe vazio para pausa indefinida",
		},
		unpause: {
			title: "Retomar Matrícula",
			description:
				"Retomar esta matrícula restaurará o acesso do cliente às sessões agendadas.",
			confirm: "Retomar Matrícula",
			pausedSince: "Pausado Desde",
			daysPaused: "Dias Pausado",
			currentEndDate: "Data de Término Atual",
			newEndDate: "Nova Data de Término",
			daysAdded: "{{count}} dia(s) serão adicionados",
		},
		extend: {
			title: "Estender Matrícula",
			description:
				"Estenda a data de término da matrícula. Os horários e sessões relacionados serão atualizados automaticamente.",
			confirm: "Estender Matrícula",
			currentEndDate: "Data de Término Atual",
			newEndDateLabel: "Nova Data de Término",
			reasonLabel: "Motivo (opcional)",
			reasonPlaceholder: "Digite um motivo para estender...",
			quickPick: {
				oneMonth: "+1 mês",
				threeMonths: "+3 meses",
				oneCycle: "+1 ciclo",
			},
			errors: {
				required: "Selecione uma nova data de término.",
				mustBeAfterCurrent:
					"A nova data de término deve ser posterior à data atual.",
				noEndDate:
					"Esta matrícula não possui data de término e não pode ser estendida.",
			},
		},
		create: {
			title: "Criar Matrícula",
			description:
				"Matricular um cliente em um horário com um plano específico",
			success: "Matrícula criada com sucesso!",
		},
		stepper: {
			customer: "Cliente",
			plan: "Plano",
			schedule: "Horário",
			review: "Revisão",
		},
		edit: {
			title: "Editar Matrícula",
			description: "Atualizar detalhes e status da matrícula",
			schedulesDescription: "Horários atribuídos a esta matrícula",
			notesDescription: "Notas e observações adicionais",
			noSchedules: "Nenhum horário atribuído a esta matrícula",
			noNotes: "Nenhuma nota adicionada ainda",
			addNotes: "Adicionar notas",
			planFeatures: "Recursos do Plano",
			planFeaturesDescription: "Recursos incluídos no plano do cliente",
			customerPlanCannotBeChanged:
				"O plano do cliente não pode ser alterado após a criação da matrícula.",
			selectSchedules: "Selecione os horários para esta matrícula",
			noSchedulesAvailable: "Nenhum horário disponível para esta organização",
			noSchedulesSelected: "Nenhum horário selecionado",
			selectedSchedulesCount: "{{count}} horário(s) selecionado(s)",
			editSchedules: "Editar Horários",
			saveScheduleChanges: "Salvar Alterações",
			viewSchedule: "Ver Horário",
		},
		form: {
			title: "Detalhes da Matrícula",
			customer: "Cliente",
			selectCustomer: "Selecionar Cliente",
			customerPlan: "Plano do Cliente",
			selectCustomerPlan: "Selecionar Plano do Cliente",
			schedule: "Horário(s)",
			selectSchedule: "Selecionar Horário(s)",
			selectCustomerPlanFirst: "Selecione um plano do cliente primeiro",
			startDate: "Data de Início",
			startDateCannotBeChanged:
				"A data de início não pode ser alterada após a criação da matrícula",
			endDate: "Data de Fim",
			endDateAutoCalculated:
				"Data de fim calculada automaticamente baseada no ciclo de cobrança do plano",
			pausedAt: "Pausado Em",
			pausedDays: "Dias Pausado",
			lastResumedAt: "Último Retorno",
			pausedDaysValue: "{{count}} dia(s)",
			status: "Status",
			statusTerminal:
				"Esta matrícula está em um estado terminal e não pode ser alterada.",
			notes: "Observações",
			notesPlaceholder: "Adicione observações sobre esta matrícula...",
			weeklyLimitHelper:
				"Seu plano permite até {{limit}} sessões semanais. Os horários selecionados totalizam {{count}} por semana.",
			weeklyLimitExceeded:
				"Os horários selecionados excedem o limite semanal de {{limit}} sessões.",
		},
		inlineSchedule: {
			title: "Criar Novo Horário",
			addSchedule: "Adicionar Horário",
			optionalFields: "Configurações Opcionais",
			sections: {
				location: {
					title: "Unidade e Instrutor",
					description: "Selecione onde e quem irá ministrar a aula",
				},
				schedule: {
					title: "Horário",
					description: "Defina quando a aula irá ocorrer",
				},
				recurrence: {
					title: "Dias da Semana",
					description: "Selecione em quais dias esta aula se repete",
				},
			},
			validation: {
				title: "Validação de Horário",
				validate: "Validar Horário",
				hasConflicts: "Conflitos encontrados",
				noConflicts: "Sem conflitos",
				conflictsFound: "Conflitos de horário detectados:",
				conflictTypes: {
					time_overlap: "Sobreposição de horário detectada",
					same_time_slot: "Conflito no mesmo horário",
					capacity_exceeded: "Capacidade excedida",
					schedule_inactive: "Horário está inativo",
				},
			},
			scheduleSelector: {
				tabs: {
					existing: "Selecionar Existente",
					create: "Criar Novo",
				},
			},
		},
		customerSelection: {
			title: "Selecionar Cliente",
			description: "Busque e selecione um cliente para matricular",
			search: "Buscar Cliente",
			searchPlaceholder: "Busque por nome, email ou número do documento...",
			searchHint: "Digite pelo menos 2 caracteres para buscar",
			startTyping: "Comece a digitar para buscar clientes",
			noCustomersFound: "Nenhum cliente encontrado para sua busca",
		},
		validation: {
			customerRequired: "Cliente é obrigatório",
			customerPlanRequired: "Plano do cliente é obrigatório",
			scheduleRequired: "Horário é obrigatório",
			scheduleValidationRequired: "Horário deve ser validado antes do envio",
			startDateRequired: "Data de início é obrigatória",
			endDateMustBeAfterStartDate:
				"Data de fim deve ser posterior à data de início",
			statusRequired: "Status é obrigatório",
			formIncomplete:
				"Por favor, preencha todos os campos obrigatórios antes de enviar o formulário",
			formIncompleteWithFields:
				"Por favor, preencha os seguintes campos obrigatórios: {{fields}}",
			overlappingSchedules:
				"Os horários selecionados possuem períodos de tempo sobrepostos",
			overlappingSchedulesTitle: "Conflitos de Horário Detectados",
			overlappingSchedulesDescription:
				"Os seguintes horários possuem períodos de tempo sobrepostos nos mesmos dias. Por favor, ajuste sua seleção para evitar conflitos.",
			weeklySessionsLimitExceeded:
				"Os horários selecionados excedem o limite de sessões semanais ({{total}}/{{limit}})",
			weeklySessionsLimitTitle: "Limite de Sessões Semanais Excedido",
			weeklySessionsLimitDescription:
				"Você selecionou {{total}} sessões semanais, mas o plano '{{planName}}' permite apenas {{limit}} sessões por semana. Por favor, remova alguns horários para continuar.",
			weeklySessionsMismatchTitle:
				"Sessões Semanais Devem Permanecer as Mesmas",
			weeklySessionsMismatchDescription:
				"Você selecionou {{current}} sessões semanais, mas esta matrícula requer {{required}} sessões por semana. Por favor, ajuste sua seleção de horários para corresponder ao número original de sessões semanais.",
			fullScheduleTitle: "Horário com Capacidade Máxima",
			fullScheduleDescription:
				"Os seguintes horários selecionados já estão com capacidade máxima, mas você ainda pode fazer a matrícula.",
			weeklySessionsBreakdown: "Detalhamento das sessões:",
			sessionsPerWeek: "{{count}} sessão por semana",
			sessionsPerWeek_other: "{{count}} sessões por semana",
		},
		toasts: {
			creating: "Criando matrícula...",
			createSuccess: "Matrícula criada com sucesso!",
			createError: "Falha ao criar matrícula. Tente novamente.",
			createErrorDuplicate:
				"Este cliente já está matriculado no horário selecionado.",
			updating: "Atualizando matrícula...",
			updateSuccess: "Matrícula atualizada com sucesso!",
			updateError: "Falha ao atualizar matrícula. Tente novamente.",
			migrating: "Migrando matrículas...",
			migrateSuccess: "Matrículas migradas com sucesso!",
			migrateError: "Falha ao migrar matrículas. Tente novamente.",
			deleting: "Excluindo matrícula...",
			deleteSuccess: "Matrícula excluída com sucesso!",
			deleteError: "Falha ao excluir matrícula. Tente novamente.",
			pausing: "Pausando matrícula...",
			pauseSuccess: "Matrícula pausada com sucesso!",
			pauseError: "Falha ao pausar matrícula. Tente novamente.",
			unpausing: "Retomando matrícula...",
			unpauseSuccess: "Matrícula retomada com sucesso!",
			unpauseError: "Falha ao retomar matrícula. Tente novamente.",
			extending: "Estendendo matrícula...",
			extendSuccess: "Matrícula estendida com sucesso!",
			extendError: "Falha ao estender matrícula. Tente novamente.",
		},
		planHelper: {
			totalForPeriod: "Média: {{monthlyAmount}}/mês",
			weeklyLimit: "Máx {{limit}} sessões/semana",
		},

		sections: {
			customerAndPlan: "Cliente & Plano",
			customerAndPlanDescription:
				"Selecione o cliente e seu plano para esta matrícula",
			customerSelection: "Seleção de Cliente",
			customerSelectionDescription: "Selecione o cliente para esta matrícula",
			customerPlan: "Plano do Cliente",
			customerPlanDescription:
				"Selecione o plano do cliente para esta matrícula",
			customerPlanDescriptionReadOnly:
				"Plano atual do cliente (não pode ser alterado)",
			scheduleSelection: "Seleção de Horários",
			scheduleSelectionDescription: "Escolha os horários para esta matrícula",
			scheduleCreation: "Criação de Horário",
			scheduleCreationDescription: "Crie um novo horário para esta matrícula",
			schedules: "Horários Selecionados",
			dateAndDetails: "Data & Detalhes",
			dateAndDetailsDescription:
				"Defina o período da matrícula e informações adicionais",
			dateRange: "Período",
			selectedSchedules: "Horários selecionados",
			scheduleDescriptionCreate:
				"Selecione um ou mais horários. Você verá a seleção e um resumo abaixo.",
			scheduleDescriptionEdit: "Atualize o horário desta matrícula.",
			sessionsResume: "Total de sessões no período: {{total}}",
			sessionsResumeDescription:
				"Baseado nos horários selecionados e período de datas",
			weeklySummary: "Resumo Semanal de Horários",
			noSessions: "Nenhuma sessão",
		},
		helper: {
			selectCustomerFirst: "Selecione um cliente primeiro",
			selectCustomerFirstDescription:
				"Você precisa escolher um cliente antes de selecionar um plano.",
			selectCustomerPlanFirst: "Selecione um plano do cliente primeiro",
			selectCustomerPlanFirstDescription:
				"Você precisa selecionar um plano do cliente antes de escolher horários",
			planCannotBeChanged:
				"O plano do cliente não pode ser alterado após a criação da matrícula.",
		},
		noSchedulesFound: "Nenhum horário encontrado correspondente à sua busca",
		noSchedulesAvailable: "Nenhum horário disponível para o plano selecionado",
		noSchedulesForPlanEstablishments: {
			title: "Para as unidades do Plano Selecionado, não há horários criados.",
			description:
				"Não há horários disponíveis para as unidades associadas ao plano '{{planName}}'.",
		},
		scheduleNotAvailableForPlan:
			"Este horário não está disponível para as unidades do plano selecionado",
	},
	permissions: {
		categories: {
			organization: "Configurações da Organização",
			staff: "Gerenciamento de Equipe",
			establishments: "Unidades",
			customers: "Gerenciamento de Clientes",
			customerPlans: "Planos de Cliente",
			medical: "Registros Médicos",
			finance: "Finanças e Cobrança",
			reports: "Relatórios",
			schedules: "Horários",
			enrollments: "Matrículas",
			attendance: "Frequência",
			other: "Outras Permissões",
		},
	},
	dashboard: {
		title: "Painel",
		welcome: "Bem-vindo à {{organization}}",
		organization: {
			title: "Organização",
			description: "Informações da organização atual",
		},
		establishment: {
			title: "Unidade",
			description: "Informações da unidade atual",
		},
		roles: {
			title: "Suas Funções",
			description: "Suas funções nesta unidade",
		},
		quickActions: {
			customers: "Gerenciar perfis e informações de clientes",
			schedules: "Visualizar e gerenciar agendas de aulas",
			attendance: "Acompanhar frequência nas aulas",
			enrollment: "Gerenciar matrículas de clientes",
			mySchedules: {
				title: "Minhas Aulas",
				description: "Visualizar suas sessões e aulas atribuídas",
			},
			createEnrollment: {
				title: "Criar Matrícula",
				description: "Matricular um cliente em uma aula com um plano",
			},
			createInvoice: {
				title: "Nova Venda",
				description:
					"Criar uma nova venda e opcionalmente registrar pagamentos para um cliente",
			},
		},
		myOverview: {
			title: "Minha Visão Geral",
			myCustomers: {
				title: "Meus Clientes",
				subtitle: "Nas minhas aulas",
			},
			myEnrollments: {
				title: "Minhas Matrículas",
				subtitle: "Ativas nas minhas aulas",
			},
			myAttendance: {
				title: "Minhas Presenças",
				subtitle: "Total confirmadas",
			},
			myExpiringEnrollments: {
				title: "Vencendo em Breve",
				subtitle: "Próximos 7 dias",
			},
			myExpiredEnrollments: {
				title: "Vencidas",
				subtitle: "Nas minhas aulas",
			},
		},
		businessOverview: {
			title: "Visão Geral do Negócio",
			activeCustomers: {
				title: "Clientes Ativos",
				subtitle: "Total matriculados",
			},
			activePlans: {
				title: "Matrículas Ativas",
				subtitle: "Atualmente inscritos",
			},
		},
		todayActivity: {
			title: "Atividade de Hoje",
			todaysClasses: {
				title: "Aulas Hoje",
				subtitle: "Sessões agendadas",
			},
			weeklyClasses: {
				title: "Aulas Semanais",
				subtitle: "Total de sessões agendadas",
			},
		},
		upcomingEvents: {
			title: "Próximos Eventos",
			upcomingBirthdays: {
				title: "Aniversários Próximos",
				subtitle: "Próximos 7 dias",
			},
			plansExpiringSoon: {
				title: "Planos Vencendo em Breve",
				subtitle: "Próximos 30 dias",
			},
			plansExpiringIn7Days: {
				title: "Matrículas Vencendo",
				subtitle: "Próximos 7 dias",
			},
			plansExpiringIn15Days: {
				title: "Planos Vencendo (15 Dias)",
				subtitle: "Próximos 15 dias",
			},
			plansExpiredLast30Days: {
				title: "Matrículas Vencidas",
				subtitle: "Últimos 30 dias",
			},
		},
		birthdaysTable: {
			title: "Detalhes dos Próximos Aniversários",
			columns: {
				customerName: "Nome do Cliente",
				email: "Email",
				phone: "Telefone",
				date: "Data",
			},
		},
		birthdayModal: {
			title: "Detalhes do Aniversário",
			contactInfo: "Informações de Contato",
			noContactInfo: "Nenhuma informação de contato disponível",
		},
		birthday: {
			today: "Hoje!",
			celebratingToday: "Aniversariante do dia!",
		},
	},
	roles: {
		org_owner: "Proprietário",
		org_administrator: "Administrador",
		org_manager: "Gerente",
		org_medicalProfessional: "Instrutor",
		org_medical_professional: "Instrutor",
		org_accountant: "Contador",
		org_instructor: "Instrutor",
		org_receptionist: "Recepcionista",
		org_viewer: "Visualizador",
		org_instructor_calendar_only: "Instrutor (Somente Agenda)",
		org_no_access: "Sem Acesso",
	},
	establishmentRoles: {
		manager: "Gerente do Unidade",
		instructor: "Instrutor",
		receptionist: "Recepcionista",
		medicalStaff: "Equipe Médica",
		assistant: "Assistente",
		viewer: "Visualizador",
	},
	invitations: {
		// Gerenciamento de convites
		inviteStaffMember: "Convidar Membro da Equipe",
		inviteStaffDescription: "Envie um convite para se juntar à sua organização",
		staffInvitations: "Convites da Equipe",
		staffInvitationsDescription:
			"Gerencie convites pendentes e concluídos da equipe",
		emailAddress: "Endereço de Email",
		emailPlaceholder: "Digite o endereço de email",
		emailRequired: "Endereço de email é obrigatório",
		invalidEmail: "Por favor, digite um endereço de email válido",
		role: "Função",
		selectRole: "Selecione uma função",
		roleRequired: "Por favor, selecione uma função",
		sendInvitation: "Enviar Convite",
		sending: "Enviando...",
		resend: "Reenviar",
		revoke: "Revogar",
		confirmRevoke: "Tem certeza que deseja revogar este convite?",

		// Lista de convites
		email: "Email",
		invitedBy: "Convidado por",
		acceptedBy: "Aceito por {{name}} em {{date}}",
		filterByStatus: "Filtrar por status",
		noInvitations: "Nenhum convite encontrado",
		noInvitationsWithStatus: "Nenhum convite {{status}} encontrado",
		showingResults: "Mostrando {{count}} de {{total}} convites",
		loading: "Carregando convites...",

		// Status do convite
		status: {
			pending: "Pendente",
			accepted: "Aceito",
			expired: "Expirado",
			revoked: "Revogado",
		},

		// Página de aceitação de convite
		signInRequired: "Login Necessário",
		signInToAcceptInvitation: "Por favor, faça login para aceitar este convite",
		processingInvitation: "Processando Convite",
		pleaseWait: "Por favor, aguarde enquanto processamos seu convite...",
		invitationAccepted: "Convite Aceito!",
		welcomeToOrganization:
			"Bem-vindo à {{organizationName}}! Você foi designado com a função de {{role}}.",
		goToDashboard: "Ir para o Painel",
		invitationInvalid: "Convite Inválido",
		invitationError: "Erro no Convite",
		invitationNotFound: "Este link de convite não foi encontrado.",
		invitationDetails: "Detalhes do Convite:",
		invitationIntro:
			"Parabéns! Você foi convidado para participar desta organização. Confira os detalhes abaixo e aceite o convite para começar.",
		roleAssignment: "Função: {{role}}",
		validatingInvitation: "Validando convite...",
		acceptInvitation: "Aceitar convite",
		alreadyAccepted: "Este convite já foi aceito.",
		tokenExpired: "Este convite expirou.",
		tokenRevoked: "Este convite foi revogado por um administrador.",
		emailMismatchTitle: "Este convite é para um email diferente",
		emailMismatchDescription:
			"Você está logado como {{currentEmail}}, mas este convite é para {{expectedEmail}}.",
		emailMismatchInstructions:
			"Para aceitar este convite, saia da conta atual e entre com o email correto.",
		switchAccount: "Trocar conta",
	},
	userSettings: {
		title: "Configurações do Usuário",
		profile: "Perfil",
		profileDescription:
			"Gerencie suas informações pessoais e configurações da conta.",
		organizations: "Organizações",
		organizationsDescription: "Gerencie suas organizações e crie novas.",
		notifications: "Notificações",
		notificationsDescription:
			"Configure como você recebe notificações e atualizações.",
		toasts: {
			updating: "Atualizando perfil...",
			updateSuccess: "Perfil atualizado com sucesso",
			updateError: "Falha ao atualizar perfil",
		},
		validation: {
			firstNameRequired: "Nome é obrigatório",
			lastNameRequired: "Sobrenome é obrigatório",
		},
	},
	orgSettings: {
		title: "Configurações da Organização",
		description: "Gerencie as configurações e preferências da sua organização.",
		general: "Geral",
		generalDescription: "Configurações básicas e informações da organização.",
		import: "Importar",
		importDescription: "Importe dados de arquivos CSV para sua organização.",
		export: "Exportar",
		exportDescription:
			"Exporte os dados da sua organização para vários formatos.",
		importCustomers: "Importar Clientes",
		importCustomersDescription: "Importe dados de clientes de um arquivo CSV.",
		importStaff: "Importar Equipe",
		importStaffDescription: "Importe membros da equipe de um arquivo CSV.",
		importSchedules: "Importar Horários",
		importSchedulesDescription: "Importe dados de horários de um arquivo CSV.",
		staff: "Equipe",
		features: {
			title: "Configurações de Recursos",
			description:
				"Configure flags de recursos e configurações de comportamento da organização.",
			enrollment: {
				title: "Configurações de Matrícula",
				description:
					"Configure como a criação de matrículas funciona na sua organização.",
				scheduleSelection: {
					title: "Modo de Seleção de Horários",
					description:
						"Escolha como os usuários podem selecionar horários ao criar matrículas.",
					modes: {
						existing_only: "Apenas Horários Existentes",
						inline_only: "Apenas Criação de Horário Inline",
						inline_and_existing: "Ambos Existentes e Criação Inline",
					},
					modeDescriptions: {
						existing_only:
							"Usuários podem apenas selecionar horários existentes. Criação de horário inline não permitida.",
						inline_only:
							"Usuários podem apenas criar novos horários inline durante a matrícula. Seleção de horários existentes não permitida.",
						inline_and_existing:
							"Usuários podem tanto selecionar horários existentes quanto criar novos inline durante a matrícula.",
					},
				},
			},
			attendance: {
				title: "Configurações de Presença",
				description:
					"Configure como o calendário de presença exibe informações das sessões.",
				calendarSessionTitleViewMode: {
					title: "Título da Sessão no Calendário",
					description:
						"Escolha o que é exibido como título das sessões no calendário de presença.",
					modes: {
						instructor_name: "Nome do Instrutor",
						customer_names: "Nomes dos Clientes",
						schedule_name: "Nome da Agenda",
					},
					modeDescriptions: {
						instructor_name:
							"Exibir o nome do instrutor como título da sessão.",
						customer_names:
							"Exibir os nomes dos clientes matriculados como título da sessão.",
						schedule_name: "Exibir o nome da agenda como título da sessão.",
					},
				},
				colorLegend: {
					title: "Legenda de Cores das Sessões",
					description:
						"Personalize as cores usadas para identificar diferentes status de sessão no calendário.",
					statuses: {
						trial: "Sessão Experimental",
						canceled: "Sessão Cancelada",
						empty: "Sessão Vazia (Sem Participantes)",
						confirmed: "Sessão Confirmada",
						reposition: "Sessão de Reposição",
						expired_enrollment: "Matrícula Vencida",
					},
					resetToDefault: "Restaurar Padrões",
				},
				enrollmentStatusFilter: {
					title: "Filtro de Status de Matrícula",
					description:
						"Habilite a filtragem de sessões por status de matrícula no calendário de presença.",
					enabled: "Habilitar Filtro",
					enabledDescription:
						"Quando habilitado, os usuários podem filtrar sessões com base no status da matrícula.",
					defaultStatuses: "Status de Matrícula Padrão",
					defaultStatusesDescription:
						"Selecione quais status de matrícula devem ser exibidos por padrão quando o filtro estiver habilitado.",
					statuses: {
						PENDING: "Pendente",
						ACTIVE: "Ativa",
						PAUSED: "Pausada",
						CANCELED: "Cancelada",
						COMPLETED: "Concluída",
						EXPIRED: "Vencida",
					},
				},
			},
			schedule: {
				title: "Configurações de Agenda",
				description:
					"Configure como o gerenciamento de agendas funciona na sua organização.",
				overlapValidation: {
					title: "Validação de Sobreposição de Agendas da Equipe",
					description:
						"Controle se membros da equipe podem ser atribuídos a agendas sobrepostas.",
					modes: {
						block: "Bloquear Agendas Sobrepostas",
						allow: "Permitir Agendas Sobrepostas",
					},
					modeDescriptions: {
						block:
							"Impedir que membros da equipe sejam atribuídos a agendas que se sobrepõem no tempo. Isso garante que não haja conflitos de agendamento.",
						allow:
							"Permitir que membros da equipe sejam atribuídos a agendas sobrepostas. Use isso se sua organização lida com conflitos manualmente.",
					},
				},
			},
			toasts: {
				updating: "Atualizando configurações de recursos...",
				updateSuccess: "Configurações de recursos atualizadas com sucesso",
				updateError: "Falha ao atualizar configurações de recursos",
			},
		},
		clientPlans: {
			title: "Planos de Cliente",
		},
		language: {
			title: "Configurações de Idioma",
			description:
				"Defina o idioma padrão da sua organização. Este idioma será usado para notificações por e-mail, lembretes e outras comunicações enviadas aos seus clientes.",
			defaultLanguage: "Idioma Padrão",
			selectLanguage: "Selecione um idioma",
		},
		currency: {
			title: "Configurações de Moeda",
			description:
				"Defina a moeda padrão da sua organização. Esta moeda será usada por padrão para cobrança e operações financeiras.",
			defaultCurrency: "Moeda Padrão",
			selectCurrency: "Selecione uma moeda",
		},
		auditEvents: {
			title: "Eventos de Auditoria",
			description:
				"Visualize o histórico de alterações feitas em agendas, sessões, frequência e matrículas.",
			noEvents: "Nenhum evento de auditoria encontrado",
			noEventsDescription:
				"Não há eventos de auditoria correspondentes aos seus filtros.",
			filters: {
				entityType: "Tipo de Entidade",
				action: "Ação",
				allEntityTypes: "Todos os Tipos",
				allActions: "Todas as Ações",
			},
			entityTypes: {
				SCHEDULE: "Agenda",
				SCHEDULE_SESSION: "Sessão",
				SCHEDULE_SESSION_ATTENDANCE: "Frequência",
				ENROLLMENT: "Matrícula",
			},
			actions: {
				CREATED: "Criado",
				UPDATED: "Atualizado",
				DELETED: "Excluído",
				STATUS_CHANGED: "Status Alterado",
				RESTORED: "Restaurado",
				CANCELED: "Cancelado",
				REACTIVATED: "Reativado",
				BULK_CREATED: "Criação em Massa",
				BULK_DELETED: "Exclusão em Massa",
				BULK_UPDATED: "Atualização em Massa",
			},
			columns: {
				timestamp: "Data/Hora",
				entityType: "Tipo de Entidade",
				action: "Ação",
				user: "Usuário",
				changes: "Alterações",
				details: "Detalhes",
			},
			systemUser: "Sistema",
			viewDetails: "Ver Detalhes",
			detailsDialog: {
				title: "Detalhes do Evento",
				entityId: "ID da Entidade",
				reason: "Motivo",
				noReason: "Nenhum motivo informado",
				beforeState: "Antes",
				afterState: "Depois",
				changesSection: "Alterações",
				noChanges: "Nenhuma alteração registrada",
				close: "Fechar",
				loading: "Carregando detalhes...",
			},
		},
	},
	orgManagement: {
		title: "Gestão da Organização",
		back: "Voltar",
		financialAnalysis: {
			title: "Análise Financeira",
			subtitle: "Pagamentos recebidos ao longo do tempo",
			granularity: {
				week: "Semanal",
				month: "Mensal",
			},
			totalAllPeriods: "Total no período",
			totalCost: "Custo total",
			netResult: "Resultado líquido",
			netResultPositive: "Resultado líquido (positivo)",
			netResultNegative: "Resultado líquido (negativo)",
			currentPeriod: "Período atual",
			empty: "Nenhum pagamento recebido na janela selecionada.",
			loading: "Carregando análise financeira...",
			error: "Falha ao carregar a análise financeira.",
			tooltip: {
				totalInPeriod: "Total no período",
				totalCost: "Custo total:",
				netResult: "Resultado líquido:",
				payments: "Pagamentos:",
				avgTicket: "Ticket médio:",
				deltaVsPrev: "Δ vs anterior:",
				clickToView: "Clique na barra para ver as vendas →",
			},
			legend: {
				revenue: "Receita",
				cost: "Custo",
			},
			filters: {
				fromDate: "De",
				toDate: "Até",
				preset: "Intervalo rápido",
				preset3m: "Últimos 3 meses",
				preset6m: "Últimos 6 meses",
				preset12m: "Últimos 12 meses",
				presetYtd: "Esse ano",
				presetCustom: "Personalizado",
				invalidRange: "A data final deve ser posterior à data inicial.",
			},
			salesList: {
				title: "Vendas em {{period}}",
				clickHint: "Clique em uma barra do gráfico para ver as vendas.",
				columns: {
					paidAt: "Data",
					customer: "Cliente",
					amount: "Valor",
					paymentMethod: "Método",
				},
				walkIn: "Avulso",
				unknownCustomer: "—",
				empty: "Nenhuma venda registrada neste período.",
				loading: "Carregando vendas...",
				error: "Falha ao carregar as vendas.",
				pagination: {
					page: "Página {{page}} de {{totalPages}}",
					previous: "Anterior",
					next: "Próximo",
				},
				close: "Fechar",
			},
			costList: {
				title: "Custos em {{period}}",
				columns: {
					incurredAt: "Data",
					category: "Categoria",
					description: "Descrição",
					amount: "Valor",
					status: "Status",
				},
				empty: "Nenhuma despesa registrada neste período.",
				loading: "Carregando despesas...",
				error: "Falha ao carregar as despesas.",
				pagination: {
					page: "Página {{page}} de {{totalPages}}",
					previous: "Anterior",
					next: "Próximo",
				},
				close: "Fechar",
			},
		},
		costManagement: {
			title: "Gestão de Custos",
			subtitle: "Acompanhe despesas e custos recorrentes",
			subtitleVariants: {
				analysis: "Custos ao longo do tempo e por categoria",
				expenses: "Liste e concilie despesas individuais",
				recurring: "Gerencie despesas recorrentes agendadas",
				categories: "Organize despesas por categoria",
			},
			loading: "Carregando gestão de custos...",
			error: "Falha ao carregar gestão de custos.",
			empty: "Sem dados para esta visão.",
			nav: {
				analysis: "Análise",
				expenses: "Despesas",
				recurring: "Recorrentes",
				categories: "Categorias",
			},
			kpis: {
				currentPeriod: "Custo do período atual",
				totalWindow: "Total na janela",
				topCategory: "Principal categoria",
				expensesCount: "Total de despesas",
				pendingCount: "Despesas pendentes",
			},
			chart: {
				stackedTitle: "Custos ao longo do tempo",
				donutTitle: "Por categoria",
				donutCenterTotal: "Total",
				clickHint: "Clique em uma barra para detalhar.",
				emptyState: "Sem despesas na janela selecionada.",
				tooltip: {
					totalInPeriod: "Total no período",
					expenses: "Despesas:",
					avgExpense: "Despesa média:",
					clickToView: "Clique na barra para detalhar →",
				},
			},
			filters: {
				all: "Todos",
				status: "Status",
				category: "Categoria",
				fromDate: "De",
				toDate: "Até",
			},
			expenses: {
				searchLabel: "Buscar",
				searchPlaceholder: "Descrição ou fornecedor...",
				creditTag: "Crédito",
				noSearchResults: "Nenhuma despesa corresponde à sua busca.",
			},
			csv: {
				exportButton: "Exportar CSV",
				filename: "despesas.csv",
			},
			expense: {
				pageTitle: "Despesas",
				create: "+ Nova despesa",
				columns: {
					date: "Data",
					category: "Categoria",
					vendor: "Fornecedor",
					description: "Descrição",
					expected: "Esperado",
					actual: "Pago",
					status: "Status",
					method: "Método",
					actions: "Ações",
				},
				status: {
					pending: "Pendente",
					paid: "Pago",
					cancelled: "Cancelado",
				},
				paymentMethod: {
					cash: "Dinheiro",
					bankTransfer: "Transferência",
					card: "Cartão",
					pix: "PIX",
					other: "Outro",
				},
				form: {
					titleCreate: "Nova despesa",
					titleEdit: "Editar despesa",
					incurredAt: "Data da despesa",
					expectedAmount: "Valor esperado",
					actualAmount: "Valor real",
					category: "Categoria",
					description: "Descrição",
					vendor: "Fornecedor",
					paymentMethod: "Método",
					notes: "Notas",
					status: "Status",
					save: "Salvar",
					cancel: "Cancelar",
				},
				markPaid: {
					title: "Marcar como paga",
					actualAmountLabel: "Valor efetivamente pago",
					paidAtLabel: "Pago em",
					confirm: "Marcar pago",
				},
				delete: {
					confirm: "Cancelar esta despesa?",
					success: "Despesa cancelada",
					error: "Falha ao cancelar despesa",
				},
			},
			recurring: {
				pageTitle: "Despesas recorrentes",
				create: "+ Nova recorrente",
				archive: "Arquivar",
				summary30dLabel: "Comprometido nos próximos 30 dias",
				actions: {
					menu: "Abrir menu de ações",
					edit: "Editar",
				},
				columns: {
					description: "Descrição",
					category: "Categoria",
					vendor: "Fornecedor",
					amount: "Valor",
					frequency: "Frequência",
					nextOccurrence: "Próxima ocorrência",
					actions: "Ações",
				},
				frequency: {
					weekly: "Semanal",
					monthly: "Mensal",
					yearly: "Anual",
				},
				form: {
					titleCreate: "Nova despesa recorrente",
					titleEdit: "Editar despesa recorrente",
					description: "Descrição",
					vendor: "Fornecedor",
					expectedAmount: "Valor esperado",
					frequency: "Frequência",
					dayOfMonth: "Dia do mês",
					dayOfWeek: "Dia da semana (0=Dom)",
					monthOfYear: "Mês do ano",
					startDate: "Início",
					endDate: "Fim",
					paymentMethod: "Método",
					category: "Categoria",
					save: "Salvar",
					cancel: "Cancelar",
				},
			},
			category: {
				pageTitle: "Categorias de despesas",
				create: "+ Nova categoria",
				activeLabel: "Ativa",
				archivedLabel: "Arquivada",
				systemReadOnly:
					"O nome de categorias do sistema é gerenciado por idioma.",
				systemTooltip:
					"Gerenciada pelo sistema — nome e cor não podem ser editados.",
				systemKey: {
					RENT_UTILITIES: "Aluguel e Contas",
					PAYROLL: "Folha de pagamento",
					EQUIPMENT: "Equipamentos",
					MARKETING: "Marketing",
					SOFTWARE: "Software e SaaS",
					TAXES_FEES: "Impostos e Taxas",
					SUPPLIES: "Suprimentos",
					OTHER: "Outro",
				},
				columns: {
					name: "Nome",
					color: "Cor",
					status: "Status",
					actions: "Ações",
				},
				form: {
					titleCreate: "Nova categoria",
					titleEdit: "Editar categoria",
					name: "Nome",
					namePlaceholder: "Marketing, materiais, ...",
					color: "Cor",
					save: "Salvar",
					cancel: "Cancelar",
				},
				archive: {
					action: "Arquivar",
					confirm: "Arquivar esta categoria?",
					success: "Categoria arquivada",
					error: "Falha ao arquivar categoria",
				},
			},
			toasts: {
				expense: {
					create: {
						loading: "Criando despesa...",
						success: "Despesa criada",
						error: "Falha ao criar despesa",
					},
					update: {
						loading: "Atualizando despesa...",
						success: "Despesa atualizada",
						error: "Falha ao atualizar despesa",
					},
					markPaid: {
						loading: "Marcando como paga...",
						success: "Despesa marcada como paga",
						error: "Falha ao marcar como paga",
					},
					delete: {
						loading: "Cancelando despesa...",
						success: "Despesa cancelada",
						error: "Falha ao cancelar despesa",
					},
				},
				category: {
					create: {
						loading: "Criando categoria...",
						success: "Categoria criada",
						error: "Falha ao criar categoria",
					},
					update: {
						loading: "Atualizando categoria...",
						success: "Categoria atualizada",
						error: "Falha ao atualizar categoria",
					},
					archive: {
						loading: "Arquivando categoria...",
						success: "Categoria arquivada",
						error: "Falha ao arquivar categoria",
					},
				},
				recurring: {
					create: {
						loading: "Criando despesa recorrente...",
						success: "Despesa recorrente criada",
						error: "Falha ao criar despesa recorrente",
					},
					update: {
						loading: "Atualizando despesa recorrente...",
						success: "Despesa recorrente atualizada",
						error: "Falha ao atualizar despesa recorrente",
					},
					archive: {
						loading: "Arquivando despesa recorrente...",
						success: "Despesa recorrente arquivada",
						error: "Falha ao arquivar despesa recorrente",
					},
				},
			},
		},
		customerRiskAnalysis: {
			title: "Análise de Risco de Clientes",
			subtitle: "Clientes matriculados faltando às aulas",
			window: "Janela (Dias)",
			minCancellations: "Mín. de cancelamentos",
			columns: {
				customer: "Cliente",
				plan: "Plano",
				absences: "Ausências",
				scheduled: "Agendados",
				attendanceRate: "Taxa de presença",
				risk: "Risco",
			},
			riskLevels: {
				veryLow: "Muito Baixo",
				low: "Baixo",
				medium: "Médio",
				high: "Alto",
				veryHigh: "Muito Alto",
			},
			empty: "Nenhum cliente sinalizado como em risco no momento.",
			loading: "Carregando análise de risco de clientes...",
			error: "Falha ao carregar a análise de risco.",
		},
	},
	attendance: {
		title: "Agenda",
		description: "Gerencie a frequência das sessões e visualize agendas",
		viewAttendance: "Ver Agenda",
		viewSessionDetails: "Ver Detalhes",
		eventDetails: "Detalhes da Aula",
		noEventSessions: "Nenhuma aula encontrada",
		noAttendanceRecords:
			"Nenhum registro de frequência encontrado para esta aula",
		customers: "Clientes",
		views: {
			calendar: "Calendário",
			list: "Lista",
		},
		loading: {
			title: "Carregando Detalhes da Sessão",
			description: "Aguarde enquanto carregamos as informações da sessão...",
		},
		calendar: {
			weekView: "Visualização Semanal",
			monthView: "Visualização Mensal",
			noSessions: "Nenhuma Sessão",
			noSessionsDescription:
				"Nenhuma sessão encontrada para o período selecionado. Tente ajustar seus filtros ou criar novas sessões.",
		},
		list: {
			tableView: "Tabela",
			cardsView: "Cartões",
			noSessions: "Nenhuma Sessão",
			noSessionsDescription:
				"Nenhuma sessão encontrada para o período selecionado. Tente ajustar seus filtros ou criar novas sessões.",
			headers: {
				date: "Data",
				session: "Sessão",
				instructor: "Instrutor",
				time: "Horário",
				location: "Local",
				attendance: "Frequência",
				status: "Status",
			},
			enrolled: "matriculados",
		},
		stats: {
			totalSessions: "Total de Sessões",
			activeSessions: "Sessões Ativas",
			canceledSessions: "Sessões Canceladas",
			totalEnrollments: "Total de Matrículas",
			capacityUtilization: "Utilização da Capacidade",
		},
		actions: {
			createSession: "Criar Sessão",
		},
		error: {
			title: "Erro ao Carregar Sessões",
			generic: "Ocorreu um erro ao carregar as sessões. Tente novamente.",
			sessionNotFound:
				"Sessão não encontrada ou você não tem permissão para visualizá-la.",
		},
		sessionDetails: {
			title: "Detalhes da Sessão",
			details: "Informações da Sessão",
			instructor: "Instrutor",
			location: "Local",
			capacity: "Capacidade",
			notes: "Observações",
			attendanceList: "Lista de Frequência",
			noAttendance:
				"Nenhum registro de frequência encontrado para esta sessão.",
			viewSchedule: "Ver detalhes do Horário",
			cancelSession: {
				button: "Cancelar Sessão",
				title: "Cancelar Sessão",
				description:
					"Tem certeza que deseja cancelar esta sessão? Isso marcará a sessão como cancelada e os clientes serão notificados.",
				confirm: "Cancelar Sessão",
				canceling: "Cancelando...",
				success: "Sessão cancelada com sucesso",
				error: "Falha ao cancelar sessão",
			},
			reactivateSession: {
				button: "Reativar Sessão",
				title: "Reativar Sessão",
				description:
					"Tem certeza que deseja reativar esta sessão? Isso restaurará a sessão ao seu estado normal.",
				confirm: "Reativar Sessão",
				reactivating: "Reativando...",
				success: "Sessão reativada com sucesso",
				error: "Falha ao reativar sessão",
			},
			rescheduleSession: {
				button: "Reagendar",
				title: "Reagendar Sessão",
				description:
					"Selecione uma nova data e horário para esta sessão. A sessão original será cancelada e uma nova será criada.",
				newDate: "Nova Data",
				newStartTime: "Horário de Início",
				newEndTime: "Horário de Término",
				confirm: "Reagendar Sessão",
				rescheduling: "Reagendando...",
				success: "Sessão reagendada com sucesso",
				error: "Falha ao reagendar sessão",
				validation: "Por favor, selecione uma nova data",
				timeValidation: "Por favor, selecione os horários de início e término",
				timeOrderValidation:
					"O horário de término deve ser após o horário de início",
			},
			sessionCanceled: "Esta sessão foi cancelada",
		},
		filters: {
			button: "Filtros",
			title: "Filtrar Sessões",
			description: "Filtre sessões por data, funcionário, unidade e mais",
			startDate: "Data Inicial",
			endDate: "Data Final",
			staffMember: "Funcionário",
			selectStaffMember: "Selecionar funcionário",
			allStaffMembers: "Todos os Funcionários",
			establishment: "Unidade",
			selectEstablishment: "Selecionar unidade",
			allEstablishments: "Todas as Unidades",
			scheduleType: "Tipo de Agenda",
			selectScheduleType: "Selecionar tipo de agenda",
			allScheduleTypes: "Todos os Tipos de Agenda",
			groupSessions: "Sessões em Grupo",
			individualSessions: "Sessões Individuais",
			status: "Status",
			activeSessions: "Sessões Ativas",
			canceledSessions: "Sessões Canceladas",
			allSessions: "Todas as Sessões",
			apply: "Aplicar Filtros",
			reset: "Redefinir Filtros",
			// Legacy keys for backward compatibility
			instructor: "Instrutor",
			allInstructors: "Todos os Instrutores",
		},
		viewMode: {
			calendar: "Calendário",
			list: "Lista",
		},
		calendarView: {
			week: "Semana",
			weekShort: "S",
			month: "Mês",
			monthShort: "M",
			today: "Hoje",
			day: "Dia",
			dayShort: "D",
			list: "Lista",
		},
		listView: {
			table: "Tabela",
			cards: "Cartões",
		},
		instructorFilter: {
			title: "Filtrar por Instrutor",
			placeholder: "Selecionar instrutores...",
			selectAll: "Selecionar Todos",
			deselectAll: "Desmarcar Todos",
			showingAll: "Mostrando todos os instrutores",
			showingSelected: "Mostrando {{count}} de {{total}} instrutores",
			selectedCount: "{{count}} selecionados",
		},
		table: {
			dateTime: "Data e Hora",
			schedule: "Agenda",
			instructor: "Instrutor",
			location: "Local",
			enrolled: "Matriculados",
			customer: "Cliente",
			idType: "Tipo de Documento",
			idNumber: "Número do Documento",
			status: "Status",
		},
		status: {
			confirmed: "Confirmado",
			canceled: "Cancelado",
			trial: "Experimental",
			reposition: "Reposicão",
			full: "Lotado",
			almostFull: "Quase Lotado",
			available: "Disponível",
			inactive: "Inativo",
			paused: "Pausado",
			active: "Ativo",
			noParticipants: "Sem participantes",
		},
		statusUpdate: {
			success: "Status de presença atualizado com sucesso",
			error: "Falha ao atualizar status de presença",
		},
		addCustomer: {
			buttonLabel: "Adicionar Cliente",
			buttonLabelShort: "Adicionar",
			title: "Adicionar Cliente à Aula",
			description: "Adicione um cliente a esta aula para frequência única",
			searchCustomer: "Buscar Cliente",
			searchPlaceholder: "Buscar por nome ou número de documento",
			noCustomersFound: "Nenhum cliente encontrado com esse termo de busca",
			searchToFindCustomers: "Busque para encontrar clientes",
			selectedCustomers: "Clientes Selecionados",
			status: "Status",
			reason: "Motivo da Adição",
			selectReason: "Selecione um motivo",
			notes: "Observações",
			notesPlaceholder: "Adicione observações adicionais sobre esta frequência",
			addButton: "Adicionar à Aula",
			noIdProvided: "Sem documento informado",
			success:
				"{{count}} cliente(s) adicionado(s) com sucesso à sessão: {{customers}}",
			reasons: {
				reposition: "Reposição",
				trialClass: "Aula Experimental",
				specialEvent: "Evento Especial",
				other: "Outro",
			},
			errors: {
				customerRequired: "Por favor, selecione um cliente",
				reasonRequired: "Por favor, selecione um motivo",
				noCustomersSelected: "Por favor, selecione pelo menos um cliente",
				failed: "Falha ao adicionar clientes à sessão: {{error}}",
			},
		},
	},
	enrollment: {
		title: "Matrículas",
		description: "Gerencie as matrículas de clientes em agendas e planos",
		addEnrollment: "Adicionar Matrícula",
		addEnrollmentDescription:
			"Matricular um cliente em uma agenda com um plano",
		createEnrollment: "Criar Matrícula",
		createEnrollmentDescription: "Criar uma nova matrícula para um cliente",
		editEnrollment: "Editar Matrícula",
		editEnrollmentDescription: "Editar os detalhes da matrícula",
		deleteEnrollment: "Excluir Matrícula",
		deleteEnrollmentDescription:
			"Tem certeza que deseja excluir esta matrícula?",
		deleteConfirmation:
			"Isto excluirá permanentemente a matrícula de {{customer}} na agenda {{schedule}}.",
		noEnrollments: "Nenhuma matrícula encontrada",
		noCustomersFound: "Nenhum cliente encontrado",
		searchCustomer: "Buscar por nome ou número de documento",
		selectCustomer: "Selecione um cliente",
		selectedCustomer: "Cliente Selecionado",
		selectedCustomerPlan: "Plano Selecionado",
		selectSchedule: "Selecione uma agenda",
		accessDenied: "Você não tem permissão para acessar matrículas.",
		confirmationModalTitle: "Confirmação de Matrícula",
		details: {
			title: "Detalhes da Matrícula",
			description: "Visualizar informações abrangentes da matrícula",
			notFound: "Matrícula não encontrada",
			sections: {
				customerInfo: "Informações do Cliente",
				scheduleInfo: "Informações da Agenda",
				planInfo: "Informações do Plano",
				enrollmentInfo: "Informações da Matrícula",
			},
			fields: {
				customerName: "Nome do Cliente",
				customerId: "ID do Cliente",
				customerIdType: "Tipo de Documento",
				customerIdNumber: "Número do Documento",
				scheduleTitle: "Título da Agenda",
				scheduleTime: "Horário da Agenda",
				instructor: "Instrutor",
				planName: "Nome do Plano",
				planPrice: "Preço do Plano",
				billingCycle: "Ciclo de Cobrança",
				startDate: "Data de Início",
				endDate: "Data de Término",
				status: "Status",
				notes: "Observações",
			},
		},
		selectCustomerPlan: "Selecione um plano",
		fields: {
			customer: "Cliente",
			schedule: "Agenda",
			customerPlan: "Plano",
			status: "Status",
			notes: "Observações",
		},
		table: {
			customer: "Cliente",
			idType: "Tipo de Documento",
			idNumber: "Número do Documento",
			schedule: "Agenda",
			plan: "Plano",
			startDate: "Data de Início",
			endDate: "Data de Término",
			status: "Status",
		},
		status: {
			active: "Ativo",
			inactive: "Inativo",
			completed: "Concluído",
			cancelled: "Cancelado",
		},
		errors: {
			scheduleAtCapacity: "Esta agenda está com capacidade máxima",
		},
	},
	payments: {
		title: "Pagamentos",
		description: "Gerencie pagamentos e faturamento de clientes",
		addPayment: "Adicionar Pagamento",
		addPaymentDescription: "Criar um novo pagamento para um cliente",
		createPayment: "Criar Pagamento",
		editPayment: "Editar Pagamento",
		editPaymentDescription: "Atualizar detalhes do pagamento",
		deletePayment: "Excluir Pagamento",
		deletePaymentDescription: "Tem certeza que deseja excluir este pagamento?",
		deleteConfirmation:
			"Isto excluirá permanentemente o registro de pagamento.",
		noPaymentsFound: "Nenhum pagamento encontrado",
		searchPlaceholder: "Buscar por nome do cliente, plano ou valor",
		selectedCustomer: "Cliente Selecionado",
		selectedCustomerAndPlan: "Cliente e Plano Selecionados",
		noCustomersFound: "Nenhum cliente encontrado",
		noPlansFound: "Nenhum plano encontrado para este cliente",
		steps: {
			selectCustomer: "Passo 1: Selecionar Cliente",
			selectCustomerDescription:
				"Selecione um cliente que esteja matriculado em pelo menos um plano",
			selectPlan: "Passo 2: Selecionar Plano",
			selectPlanDescription:
				"Selecione um plano em que o cliente esteja matriculado",
			paymentDetails: "Passo 3: Detalhes do Pagamento",
			paymentDetailsDescription:
				"Insira os detalhes do pagamento e complete a transação",
		},
		fields: {
			customer: "Cliente",
			plan: "Plano",
			amount: "Valor",
			currency: "Moeda",
			paymentDate: "Data do Pagamento",
			paymentMethod: "Método de Pagamento",
			status: "Status",
			notes: "Observações",
		},
		placeholders: {
			selectCustomer: "Selecione um cliente",
			searchCustomer: "Buscar por cliente",
			selectPlan: "Selecione um plano",
			selectCurrency: "Selecione a moeda",
			selectPaymentMethod: "Selecione o método de pagamento",
			selectStatus: "Selecione o status",
			notes: "Adicione observações sobre este pagamento",
		},
		methods: {
			creditCard: "Cartão de Crédito",
			debitCard: "Cartão de Débito",
			cash: "Dinheiro",
			bankTransfer: "Transferência Bancária",
			pix: "PIX",
			other: "Outro",
		},
		statuses: {
			completed: "Concluído",
			pending: "Pendente",
			failed: "Falhou",
			refunded: "Reembolsado",
			cancelled: "Cancelado",
		},
		createSuccess: "Pagamento criado com sucesso!",
		updateSuccess: "Pagamento atualizado com sucesso!",
		deleteSuccess: "Pagamento excluído com sucesso!",
		createError: "Falha ao criar pagamento. Por favor, tente novamente.",
		updateError: "Falha ao atualizar pagamento. Por favor, tente novamente.",
		deleteError: "Falha ao excluir pagamento. Por favor, tente novamente.",
	},
	medicalRecords: {
		title: "Prontuários",
		description:
			"Gerenciamento abrangente de prontuários para todos os clientes",
		searchPlaceholder: "Buscar prontuários",
		addMedicalRecord: "Adicionar Registro",
		addMedicalRecordDescription:
			"Criar um novo registro médico para este cliente",
		addRecord: "Adicionar Registro",
		noRecords: "Nenhum registro médico encontrado",
		creating: "Criando registro médico...",
		updating: "Atualizando registro médico...",
		deleting: "Excluindo registro médico...",
		generatingSummary: "Gerando resumo com IA...",
		create: "Criar Registro",
		createSuccess: "Registro médico criado com sucesso!",
		updateSuccess: "Registro médico atualizado com sucesso!",
		deleteSuccess: "Registro médico excluído com sucesso!",
		generateSummarySuccess: "Resumo gerado com sucesso!",
		createError: "Falha ao criar registro médico. Por favor, tente novamente.",
		updateError:
			"Falha ao atualizar registro médico. Por favor, tente novamente.",
		deleteError:
			"Falha ao excluir registro médico. Por favor, tente novamente.",
		generateSummaryError:
			"Falha ao gerar resumo com IA. Por favor, tente novamente.",
		unsupportedRecordType:
			"Este tipo de registro não é suportado para visualização.",
		viewNotImplemented:
			"Modo de visualização ainda não implementado para este tipo de registro.",
		noOptionsSelected: "Nenhuma opção selecionada",
		noNotesAvailable: "Nenhuma anotação disponível",
		noDataAvailable: "Nenhum dado disponível",
		selectRecordType: "Selecionar tipo de registro",
		newRecord: {
			title: "Novo Prontuário",
			description: "Criar um novo prontuário para este cliente",
			selectType: "Tipo de Registro",
			selectTypeDescription: "Escolha o tipo de prontuário que deseja criar",
		},
		recordTypeLabels: {
			anamnesis: "Anamnese",
			physical_evaluation: "Avaliação Física",
			periodic_evaluation: "Avaliação Periódica",
			treatment: "Plano de Tratamento",
			other: "Outros",
		},
		titlePlaceholder: "Digite o título do registro",
		descriptionPlaceholder: "Digite a descrição do registro (opcional)",
		editMedicalRecord: "Editar Prontuário",
		viewMedicalRecord: "Visualizar Prontuário",
		noMedicalRecords: "Nenhum Registro Encontrado",
		noMedicalRecordsDescription:
			"Nenhum prontuário corresponde aos seus critérios de busca atuais.",
		createNew: "Criar Novo Registro",
		selectRecordTypeDescription: "Escolha o tipo de prontuário a ser criado",
		fields: {
			customer: "Cliente",
			customerName: "Nome do Cliente",
			date: "Data",
			recordType: "Tipo de Registro",
			title: "Título",
			description: "Descrição",
			summary: "Resumo",
		},
		recordTypes: {
			anamnesis: "Anamnese (Histórico do Paciente)",
			evaluation: "Avaliação",
			treatment: "Tratamento",
			assessment: "Avaliação",
			other: "Outro",
		},
		recordTypeDescriptions: {
			anamnesis:
				"Histórico abrangente do paciente incluindo antecedentes médicos, medicamentos atuais, características da dor e fatores de estilo de vida.",
			evaluation: "Registro geral de avaliação e análise.",
			treatment: "Notas de sessão de tratamento e intervenções.",
			assessment: "Avaliação clínica e achados.",
			other: "Outros tipos de prontuários.",
		},
		filters: {
			all: "Todos os Registros",
			byCustomer: "Por Cliente",
			byType: "Por Tipo",
			byDate: "Por Data",
		},
		actions: {
			viewDetails: "Ver Detalhes",
			editRecord: "Editar Registro",
			deleteRecord: "Excluir Registro",
		},
		// Resumo com IA
		aiSummary: {
			title: "Resumo com IA",
			generateButton: "Gerar Resumo com IA",
			generating: "Gerando...",
			showSummary: "Mostrar Resumo",
			hideSummary: "Ocultar Resumo",
			noSummary: "Nenhum resumo disponível",
			processing: "Processando",
			refresh: "Atualizar",
			refreshing: "Atualizando...",
		},

		// Exibição de Respostas do Formulário
		formAnswers: {
			title: "Respostas do Formulário",
			showDetails: "Ver Detalhes",
			hideDetails: "Ocultar Detalhes",
		},

		// Anamnese (Histórico do Paciente) - traduções específicas
		anamnesis: {
			title: "Anamnese (Histórico do Paciente)",
			description: "Histórico abrangente do paciente e avaliação subjetiva",

			// Títulos das seções
			presentingComplaint: "A. Queixa Principal",
			medicalSurgicalHistory: "B. Histórico Médico e Cirúrgico",
			lifestyleActivity: "C. Estilo de Vida e Atividade",
			goalsPreferences: "D. Objetivos e Preferências",

			// A. Queixa Principal
			mainReasonTitle: "Motivo principal do Atendimento",
			mainReason: {
				pain: "Dor",
				stiffness: "Rigidez",
				weakness: "Fraqueza",
				numbnessTingling: "Dormência/formigamento",
				swelling: "Inchaço",
				instability: "Instabilidade",
				balanceIssues: "Problemas de equilíbrio",
				postSurgicalRehab: "Reabilitação pós‑cirúrgica",
				sportsInjury: "Lesão esportiva",
				workAccident: "Acidente de trabalho",
				other: "Outro",
			},
			bodyRegionTitle: "Região do corpo envolvida (marque todas)",
			bodyRegion: {
				neck: "Pescoço",
				upperBack: "Parte superior das costas",
				lowBack: "Parte inferior das costas",
				jawTMJ: "Mandíbula/ATM",
				shoulderL: "Ombro E",
				shoulderR: "Ombro D",
				elbowL: "Cotovelo E",
				elbowR: "Cotovelo D",
				wristHandL: "Punho/Mão E",
				wristHandR: "Punho/Mão D",
				hipL: "Quadril E",
				hipR: "Quadril D",
				kneeL: "Joelho E",
				kneeR: "Joelho D",
				ankleFootL: "Tornozelo/Pé E",
				ankleFootR: "Tornozelo/Pé D",
				pelvicWomensHealth: "Pélvico / Saúde da mulher",
				other: "Outro",
			},
			onsetTitle: "Início",
			onset: {
				suddenTrauma: "Trauma súbito",
				gradualOveruse: "Gradual/sobrecarga",
				postOperative: "Pós‑operatório",
				recurringFlare: "Recidiva recorrente",
				chronicMoreThan6Months: "Crônico > 6 meses",
			},
			painQualityTitle: "Tipo de dor",
			painQuality: {
				sharp: "Aguda",
				dullAche: "Surda/dolorida",
				burning: "Queimação",
				throbbing: "Latejante",
				cramping: "Cãibra",
				pinsNeedles: "Formigamento",
			},
			worseWithTitle: "Piora com",
			worseWith: {
				movement: "Movimento",
				rest: "Repouso",
				sitting: "Sentado",
				standing: "Em pé",
				walkingRunning: "Caminhada/Corrida",
				lifting: "Levantamento",
				bendingTwisting: "Flexão/Torção",
				morning: "Manhã",
				eveningNight: "Tarde/Noite",
				coughSneeze: "Tosse/Espirro",
			},
			betterWithTitle: "Melhora com",
			betterWith: {
				rest: "Repouso",
				heat: "Calor",
				ice: "Gelo",
				medication: "Medicação",
				stretching: "Alongamento",
				exercise: "Exercício",
				massage: "Massagem",
				nothingHelps: "Nada ajuda",
			},
			redFlagSymptomsTitle: "Sinais de Alarme",
			redFlagSymptoms: {
				unexplainedWeightLoss: "Perda de peso inexplicada",
				feverNightSweats: "Febre/suores noturnos",
				nightPainUnrelievedByPosition: "Dor noturna não aliviada pela posição",
				bowelBladderChanges: "Alterações intestinais/vesicais",
				saddleNumbness: "Dormência em sela",
				progressiveWeakness: "Fraqueza progressiva",
				dizzinessFainting: "Tontura/desmaio",
				none: "Nenhum",
			},

			// B. Histórico Médico e Cirúrgico
			pastDiagnosesTitle: "Comorbidades",
			pastDiagnoses: {
				hypertension: "Hipertensão",
				heartDisease: "Doença cardíaca",
				strokeTIA: "AVC/AIT",
				asthmaCOPD: "Asma/DPOC",
				diabetesT1: "Diabetes T1",
				diabetesT2: "Diabetes T2",
				osteoporosis: "Osteoporose",
				osteoarthritis: "Osteoartrite",
				rheumatoidAutoimmune: "Reumatoide/autoimune",
				cancerPastPresent: "Câncer (passado/presente)",
				neurologicalDisorder: "Distúrbio neurológico",
				epilepsy: "Epilepsia",
				depressionAnxiety: "Depressão/Ansiedade",
				bloodClotDVT: "Coágulo sanguíneo/TVP",
				infectiousDisease: "Doença infecciosa (HIV/Hepatite)",
				none: "Nenhum",
			},
			surgeriesHospitalStaysTitle: "Cirurgias / internações hospitalares",
			surgeriesHospitalStays: {
				spine: "Coluna",
				jointReplacement: "Substituição articular",
				fractureFixation: "Fixação de fratura",
				arthroscopy: "Artroscopia",
				cardiac: "Cardíaca",
				abdominalPelvic: "Abdominal/Pélvica",
				cSection: "Cesariana",
				other: "Outro",
				none: "Nenhum",
			},
			currentRegularMedicationTitle: "Medicação em uso",
			currentRegularMedication: {
				painNSAIDs: "Dor/AINEs",
				steroids: "Esteroides",
				bloodThinners: "Anticoagulantes",
				bpMeds: "Medicamentos para pressão",
				cholesterolMeds: "Medicamentos para colesterol",
				diabetesMedsInsulin: "Medicamentos para diabetes/Insulina",
				osteoporosisMeds: "Medicamentos para osteoporose",
				antidepressants: "Antidepressivos",
				muscleRelaxants: "Relaxantes musculares",
				none: "Nenhum",
			},
			allergiesSensitivitiesTitle: "Alergias / sensibilidades",
			allergiesSensitivities: {
				latex: "Látex",
				adhesive: "Esparadrapo",
				nsaids: "AINEs",
				antibiotics: "Antibióticos",
				food: "Alimentos",
				iodineContrast: "Iodo/Contraste",
				noneKnown: "Nenhuma conhecida",
			},
			implantsDevicesTitle: "Implantes / dispositivos",
			implantsDevices: {
				pacemakerICD: "Marcapasso/CDI",
				metalHardware: "Hardware metálico",
				jointProsthesis: "Prótese articular",
				painPumpStimulator: "Bomba de dor/Estimulador",
				cochlearImplant: "Implante coclear",
				other: "Outro",
				none: "Nenhum",
			},
			womensHealthTitle: "Saúde da mulher (se aplicável)",
			womensHealth: {
				pregnant: "Grávida",
				lessThan6MonthsPostPartum: "< 6 meses pós‑parto",
				pelvicFloorIssues: "Problemas do assoalho pélvico",
				none: "Nenhum",
			},

			// C. Estilo de Vida e Atividade
			workDemandsTitle: "Aspectos biomecânicos do trabalho",
			workDemands: {
				mostlySitting: "Principalmente sentado",
				prolongedStanding: "Ficar em pé por períodos prolongados",
				heavyLifting: "Levantamento pesado",
				repetitiveTasks: "Tarefas repetitivas",
				shiftNightWork: "Trabalho em turnos/noturno",
				offWorkDueToInjury: "Afastado do trabalho devido à lesão",
			},
			physicalActivityLevelTitle: "Nível de atividade física",
			physicalActivityLevel: {
				none: "Sedentário",
				light1To2TimesWeek: "Leve (1–2 × sem)",
				moderate3To4TimesWeek: "Moderado (3–4 × sem)",
				vigorous5OrMoreTimesWeek: "Vigoroso (≥ 5 × sem)",
				competitiveSport: "Atleta Profissional",
			},
			regularExerciseTitle: "Exercício regular",
			regularExercise: {
				walking: "Caminhada",
				running: "Corrida",
				cycling: "Ciclismo",
				swimming: "Natação",
				gymWeights: "Academia/Pesos",
				teamSports: "Esportes em equipe",
				yogaPilates: "Yoga/Pilates",
				other: "Outro",
				none: "Nenhum",
			},
			lifestyleFactorsTitle: "Fatores de estilo de vida",
			lifestyleFactors: {
				currentSmoker: "Fumante atual",
				formerSmoker: "Ex-fumante",
				neverSmoked: "Nunca fumou",
				alcoholMoreThan14UnitsWeek: "Álcool > 14 unidades/sem",
				alcoholLessOrEqual14UnitsWeek: "Álcool ≤ 14 unidades/sem",
				caffeineMoreThan3CupsDay: "Cafeína > 3 xícaras/dia",
				poorSleepLessThan6Hours: "Sono ruim (< 6 h)",
				highStress: "Alto estresse",
			},
			sleepQualityTitle: "Qualidade do sono",
			sleepQuality: {
				good: "Boa",
				fairOccasionalWaking: "Razoável com despertar ocasional",
				poorFrequentWaking: "Ruim com despertar frequente",
				wakesDueToPain: "Acorda devido à dor",
			},
			dailyActivitiesLimitedTitle:
				"Atividades diárias limitadas pelo problema atual",
			dailyActivitiesLimited: {
				dressing: "Vestir-se",
				bathing: "Banhar-se",
				stairs: "Escadas",
				standingMoreThan30Min: "Ficar em pé > 30 min",
				sittingMoreThan30Min: "Sentar > 30 min",
				walkingMoreThan15Min: "Caminhar > 15 min",
				drivingMoreThan30Min: "Dirigir > 30 min",
				liftingMoreThan5Kg: "Levantar > 5 kg",
				reachingOverhead: "Alcançar acima da cabeça",
				gettingUpFromFloor: "Levantar-se do chão",
			},
			previousTreatmentsTriedTitle: "Tratamentos anteriores tentados",
			previousTreatmentsTried: {
				physiotherapy: "Fisioterapia",
				chiropractic: "Quiropraxia",
				osteopathy: "Osteopatia",
				massage: "Massagem",
				acupunctureDryNeedling: "Acupuntura/Agulhamento seco",
				injection: "Injeção",
				surgery: "Cirurgia",
				imagingOnly: "Apenas exames de imagem",
				none: "Nenhum",
			},

			// D. Objetivos e Preferências
			goalsForPhysiotherapyTitle: "Objetivos",
			goalsForPhysiotherapy: {
				decreasePain: "Diminuir a dor",
				improveMobility: "Melhorar a mobilidade",
				increaseStrength: "Aumentar a força",
				improveBalance: "Melhorar o equilíbrio",
				returnToSport: "Retornar ao esporte",
				returnToWork: "Retornar ao trabalho",
				preventRecurrence: "Prevenir recorrência",
				postureEducation: "Educação postural",
				other: "Outro",
			},
			treatmentMethodsInterestedInTitle:
				"Métodos de tratamento em que estou interessado / aberto a",
			treatmentMethodsInterestedIn: {
				manualTherapy: "Terapia manual",
				jointMobilisationManipulation: "Mobilização/manipulação articular",
				exerciseProgramme: "Programa de exercícios",
				dryNeedling: "Agulhamento seco",
				electrotherapyTENSUltrasound: "Eletroterapia (TENS/ultrassom)",
				tapingBracing: "Bandagem/Órtese",
				heatCold: "Calor/Frio",
				noPreference: "Sem preferência",
			},
			consentTitle: "Consentimento",
			consent: {
				understandAndConsentToTreatment:
					"Eu entendo e consinto com a avaliação e o tratamento proposto",
			},

			// Fonte de Indicação
			referralSourceSection: "Como Você Conheceu Nossa Clínica?",
			howDidYouHearAboutUsTitle: "Como você conheceu nossa clínica?",
			referralSource: {
				instagram: "Instagram",
				facebook: "Facebook",
				google: "Pesquisa no Google",
				googleMaps: "Google Maps",
				website: "Nosso Site",
				friendFamily: "Indicação de Amigo/Família",
				existingClient: "Indicação de Cliente Existente",
				healthcareProfessional: "Indicação de Profissional de Saúde",
				advertisement: "Propaganda (TV/Rádio/Impresso)",
				walkingBy: "Passando pela Clínica",
				onlineReview: "Avaliação/Comentário Online",
				other: "Outro",
			},
		},

		// Physical Evaluation
		physicalEvaluation: {
			bodyMeasurements: "Medidas Corporais",
			vitalSigns: "Sinais Vitais",
			autoCalculated: "Calculado automaticamente",
			vitalsAnthropometrics: "1 · Sinais Vitais e Antropometria",
			height: "Altura",
			weight: "Peso",
			bmi: "IMC",
			restingHeartRate: "Frequência cardíaca de repouso",
			bloodPressure: "Pressão arterial",

			posturalObservation: "2 · Observação Postural (em pé relaxado)",
			headNeck: "Cabeça/Pescoço",
			neutral: "Neutro",
			forwardHead: "Cabeça anteriorizada",
			sideBendR: "Inclinação lateral D",
			sideBendL: "Inclinação lateral E",
			shoulders: "Ombros",
			level: "Nivelados",
			elevatedR: "Elevado D",
			elevatedL: "Elevado E",
			rounded: "Arredondados",
			thoracicCurve: "Curvatura torácica",
			normal: "Normal",
			increasedKyphosis: "↑ Cifose",
			decreasedKyphosis: "↓ Cifose",
			lumbarCurve: "Curvatura lombar",
			increasedLordosis: "↑ Lordose",
			decreasedLordosis: "↓ Lordose",
			pelvis: "Pelve",
			anteriorTilt: "Inclinação anterior",
			posteriorTilt: "Inclinação posterior",
			lHike: "Elevação E",
			rHike: "Elevação D",
			kneeAlignment: "Alinhamento dos joelhos",
			genuValgum: "Geno valgo",
			genuVarum: "Geno varo",
			footAnkle: "Pé/Tornozelo",
			neutralArch: "Arco neutro",
			pesPlanus: "Pé plano",
			pesCavus: "Pé cavo",
			pronationR: "Pronação D",
			pronationL: "Pronação E",

			breathingCoreControl: "3 · Respiração e Controle do Core (foco Pilates)",
			breathingPattern: "Padrão respiratório",
			diaphragmatic: "Diafragmático (360°)",
			upperChestDominant: "Dominante torácico superior",
			paradoxical: "Paradoxal",
			coreEngagement: 'Ativação do core ("draw-up/zip")',
			ableToActivate: "Capaz de ativar",
			unablePoorAwareness: "Incapaz/baixa consciência",
			pelvicFloorCue: "Comando do assoalho pélvico",
			adequateContraction: "Contração adequada",
			weakAbsent: "Fraco/ausente",
			overActive: "Hiperativo",
			spinalImprintControl: "Controle de impressão espinhal (supino)",
			maintainsNeutral: "Mantém neutro",
			flattensExcessively: "Achata excessivamente",
			hyperLordotic: "Hiperlordótico",

			rangeOfMotion:
				"4 · Amplitude de Movimento (triagem rápida – goniômetro se limitado)",
			wnl: "DNL",
			mildDecrease: "↓ Leve",
			modDecrease: "↓ Mod",
			severeDecrease: "↓ Severa",
			cervical: "Cervical",
			thoracicRotation: "Rotação torácica",
			lumbarFlexExtend: "Flexão/extensão lombar",
			shoulderL: "Ombro (flex/abd) E",
			shoulderR: "Ombro (flex/abd) D",
			hipFlexL: "Flexão quadril E",
			hipFlexR: "Flexão quadril D",
			ankleDosiflexL: "Dorsiflexão tornozelo E",
			ankleDosiflexR: "Dorsiflexão tornozelo D",

			flexibilityTests: "5 · Testes de Flexibilidade",
			hamstrings: "Isquiotibiais (elevação da perna estendida)",
			hamstringsTight: "≤ 70° tenso",
			hamstringsNormal: "> 70° DNL",
			hipFlexors: "Flexores do quadril (teste de Thomas)",
			tight: "Tenso",
			quadriceps: "Quadríceps (teste de Ely)",
			pectoralisMinor: "Comprimento do peitoral menor",
			calf: "Panturrilha (gastro-sóleo)",

			muscleStrengthEndurance: "6 · Força/Resistência Muscular",
			manualMuscleTest: "Teste muscular manual - triagem rápida",
			allMajorGroups: "Todos os grupos principais ≥ 4/5",
			deficits: "Se déficits:",
			cervicalFlexors: "Flexores cervicais",
			scapularStabilisers: "Estabilizadores escapulares",
			core: "Core",
			gluteMax: "Glúteo máximo",
			gluteMed: "Glúteo médio",
			quads: "Quadríceps",
			coreEndurance: "Resistência do core (prancha)",
			less20s: "< 20 s",
			between20and60s: "20-60 s",
			more60s: "> 60 s",

			balanceNeuromotorControl: "7 · Equilíbrio e Controle Neuromotor",
			romberg: "Romberg 30 s",
			stable: "Estável",
			sways: "Oscila",
			tandemStance: "Posição tandem 30 s",
			singleLegStanceL: "Apoio unipodal 10 s E",
			singleLegStanceR: "Apoio unipodal 10 s D",
			yes: "Sim",
			no: "Não",
			yBalance: "Y-Balance / Star-Excursion",
			within10Percent: "Dentro de 10% bilateral",
			more10PercentAsymmetry: "> 10% assimetria",

			functionalMovementScreen: "8 · Triagem de Movimento Funcional",
			overheadSquat: "Agachamento overhead",
			pass: "Passou",
			heelsLift: "Calcanhares levantam",
			kneeValgus: "Valgo de joelho",
			forwardLean: "Inclinação anterior",
			lunge: "Afundo (frontal)",
			balanceLoss: "Perda de equilíbrio",
			trunkShift: "Desvio do tronco",
			stepDown: "Step-down",
			hipDrop: "Queda do quadril",
			kneeMedial: "Joelho medial",
			pain: "Dor",
			bridge: "Ponte (ativação glútea)",
			maintainsPelvisLevel: "Mantém pelve nivelada",
			pelvicDropR: "Queda pélvica D",
			pelvicDropL: "Queda pélvica E",

			cardiorespiratoryScreen: "9 · Triagem Cardiorrespiratória",
			stepTestRecovery:
				"Teste de step 3 min - recuperação FC para < 100 bpm em 1 min",
			dyspnoeaChestDiscomfort:
				"Qualquer dispneia indevida / desconforto torácico",

			specialTests: "10 · Testes Especiais (marcar positivos)",
			positiveTests: "Testes positivos",
			slrNerveTension: "Tensão neural SLR",
			spurlings: "Spurling",
			lachman: "Lachman",
			mcmurray: "McMurray",
			neerEmptyCan: "Neer/Empty-Can",
			faber: "FABER",
			trendelenburg: "Trendelenburg",
			other: "Outro",

			readinessGoals: "11 · Prontidão e Objetivos",
			exerciseReadiness: "Prontidão para exercício",
			clearedForFullPilatesMat: "Liberado para Pilates solo completo",
			clearedForApparatus: "Liberado para aparelhos",
			needModifiedProgram: "Necessita programa modificado",
			primaryGoals: "Objetivos principais",
			painRelief: "Alívio da dor",
			posture: "Postura",
			flexibility: "Flexibilidade",
			coreStability: "Estabilidade do core",
			sportSpecific: "Específico do esporte",
			stressManagement: "Gerenciamento do estresse",
		},

		// Periodic Evaluation
		periodicEvaluation: {
			// A. Detalhes da Visita
			visitDetails: "A. Detalhes da Visita",
			date: "Data",
			weeksSinceLastEval: "Semanas desde a última avaliação",
			week1: "1",
			week2: "2",
			week3: "3",
			weeks4to6: "4–6",
			moreThan6: "> 6",
			sessionsCompleted: "Sessões completadas neste ciclo",
			sessions1to5: "1–5",
			sessions6to10: "6–10",
			sessions11to15: "11–15",
			sessionsMore15: "> 15",

			// B. Status Subjetivo
			subjectiveStatus: "B. Status Subjetivo (relatado pelo paciente)",
			overallChange: "Mudança geral desde a última avaliação",
			muchBetter: "Muito melhor (≥ 75%)",
			better: "Melhor (25–74%)",
			noChange: "Sem mudança",
			worse: "Pior",
			averagePain: "Dor média (últimas 24 h)",
			painNone: "0 Nenhuma",
			painMild: "1–3 Leve",
			painModerate: "4–6 Moderada",
			painSevere: "7–10 Severa",
			symptomFrequency: "Frequência dos sintomas",
			rare: "Raro (< 1× sem)",
			intermittent: "Intermitente",
			constant: "Constante",
			newSymptoms: "Sintomas novos / expandidos",
			none: "Nenhum",
			newPainArea: "Nova área de dor",
			swelling: "Inchaço",
			numbnessTingling: "Dormência/formigamento",
			instability: "Instabilidade",
			other: "Outro",
			activitiesAchievable: "Atividades agora alcançáveis",
			adlsPainFree: "AVDs sem dor",
			fullWorkDuties: "Funções completas do trabalho",
			recreationalExercise: "Exercício recreativo",
			sportDrills: "Exercícios esportivos",
			fullSport: "Esporte completo",
			stillLimited: "Ainda limitado",

			// C. Aderência e Estilo de Vida
			adherenceLifestyle: "C. Aderência e Estilo de Vida",
			homeExerciseCompliance: "Aderência aos exercícios domiciliares",
			over80: "≥ 80%",
			between50and79: "50–79%",
			between1and49: "1–49%",
			zero: "0%",
			pilatesAttendance: "Frequência às aulas de Pilates",
			allScheduled: "Todas agendadas",
			missed1to2: "Perdeu 1–2",
			missedMore2: "Perdeu > 2",
			paused: "Pausado",
			sleepQuality: "Qualidade do sono",
			improved: "Melhorou",
			same: "Igual",
			worsened: "Piorou",
			stressLevel: "Nível de estresse",
			lower: "Menor",
			higher: "Maior",
			nutritionHydration: "Nutrição / hidratação adequada",
			yes: "Sim",
			needsWork: "Precisa melhorar",

			// D. Reavaliação Objetiva
			objectiveReassessment: "D. Reavaliação Objetiva",
			postureAlignment: "Alinhamento postural",
			cervicalROM: "ADM cervical",
			shoulderROM: "ADM do ombro",
			lumbarFlexExtend: "Flexão/extensão lombar",
			hipMobility: "Mobilidade do quadril",
			hamstringLength: "Comprimento dos isquiotibiais",
			coreEndurance: "Resistência do core (prancha)",
			gluteStrength: "Força do glúteo",
			singleLegBalance: "Equilíbrio unipodal 10 s",
			functionalMovementScore: "Pontuação do movimento funcional",
			wnl: "DNL",

			// E. Proficiência em Pilates
			pilatesProficiency: "E. Proficiência em Pilates",
			matworkLevel: "Nível de solo alcançado",
			fundamentals: "Fundamentos",
			beginnerFlow: "Fluxo iniciante",
			intermediate: "Intermediário",
			advanced: "Avançado",
			reformerSkill: "Reformer",
			cadillacSkill: "Cadillac",
			chairSkill: "Chair",
			beginner: "Inic",
			breathing: "Respiração",
			centering: "Centralização",
			control: "Controle",
			good: "Bom",
			fair: "Regular",
			poor: "Ruim",

			// F. Resumo de Medidas de Resultado
			outcomeMeasures: "F. Resumo de Medidas de Resultado",
			disabilityFunctionScore: "Pontuação de incapacidade / função",
			better20Plus: "≥ 20% melhor",
			better10to19: "10–19% melhor",
			functionalScale: "Escala Funcional Específica do Paciente",
			goalsMet: "Objetivos alcançados",
			partiallyMet: "Parcialmente alcançados",
			notMet: "Não alcançados",

			// G. Verificação de Sinais de Alerta
			redFlagCheck:
				"G. Verificação de Sinais de Alerta (desde a última avaliação)",
			redFlags: "Sinais de alerta",
			nightPain: "Dor noturna",
			weightLoss: "Perda de peso inexplicada",
			feverChills: "Febre/calafrios",
			bowelBladder: "Mudanças intestinais/vesicais",
			neuroDeficit: "Déficit neurológico progressivo",

			// H. Eventos Adversos
			adverseEvents: "H. Eventos Adversos",
			adverseEventsTitle: "Eventos adversos",
			soreness: "Dor pós-sessão > 48 h",
			dizziness: "Tontura",
			skinReaction: "Reação cutânea",

			// I. Plano Futuro
			planForward: "I. Plano Futuro",
			treatmentFrequency: "Frequência do tratamento",
			maintain: "Manter",
			increase: "Aumentar",
			decrease: "Diminuir",
			discharge: "Alta na próxima visita",
			programAdjustments: "Ajustes do programa",
			progressLoad: "Progredir carga/complexidade",
			addApparatus: "Adicionar novo aparelho de Pilates",
			sportSpecific: "Introduzir exercícios específicos do esporte",
			workConditioning: "Condicionamento para o trabalho",
			maintenance: "Mudar para manutenção/bem-estar",
			referralsNeeded: "Encaminhamentos necessários",
			physician: "Médico",
			imaging: "Exames de imagem",
			specialist: "Especialista (ex: nutrição, saúde mental)",
			updatedGoals: "Objetivos atualizados definidos",
			continueExisting: "Continuar existentes",
		},

		// Treatment Plan
		treatmentPlan: {
			schedule: "Cronograma",
			additionalSettings: "Configurações Adicionais",
			// 1. Intervenções Planejadas
			interventionsPlanned: "1 · Intervenções Planejadas",

			// A. Terapia Manual
			manualTherapy: "A. Terapia Manual",
			softTissueRelease: "Liberação de tecidos moles",
			jointMobilisation: "Mobilização articular",
			manipulation: "Manipulação",
			myofascialRelease: "Liberação miofascial",

			// B. Exercício Terapêutico / Pilates
			therapeuticExercisePilates: "B. Exercício Terapêutico / Pilates",
			rangeOfMotionDrills: "Exercícios de amplitude de movimento",
			stretching: "Alongamento",
			strengthening: "Fortalecimento",
			neuromuscularReEd: "Reeducação neuromuscular",
			pilatesMatFundamentals: "Fundamentos do Pilates solo",
			pilatesReformer: "Pilates reformer",
			pilatesChairCadillac: "Pilates chair / cadillac",
			sportSpecificConditioning: "Condicionamento específico do esporte",
			functionalMovementReTraining: "Retreinamento de movimento funcional",

			// C. Modalidades / Adjuvantes
			modalitiesAdjuncts: "C. Modalidades / Adjuvantes",
			heatCryotherapy: "Calor / Crioterapia",
			tensNmes: "TENS / NMES",
			ultrasound: "Ultrassom",
			dryNeedling: "Agulhamento seco",
			kTaping: "K‑Taping",
			traction: "Tração",
			bracingOrthosis: "Órtese / aparelho",

			// D. Educação e Autogerenciamento
			educationSelfManagement: "D. Educação e Autogerenciamento",
			postureErgonomics: "Postura / ergonomia",
			bodyMechanics: "Mecânica corporal",
			breathingRelaxation: "Respiração e relaxamento",
			homeExerciseProgram: "Programa de exercícios domiciliares (PED)",
			lifestyleSleepHydration: "Dicas de estilo de vida / sono / hidratação",

			// 2. Frequência e Duração
			frequencyDuration: "2 · Frequência e Duração",
			inClinicSessions: "Sessões na clínica",
			onePerWeek: "1 × sem",
			twoPerWeek: "2 × sem",
			threePerWeek: "3 × sem",
			cycleLength: "Duração do ciclo",
			threeWeeks: "3 sem",
			fourWeeks: "4 sem",
			sixWeeks: "6 sem",
			eightWeeks: "8 sem",
			hepDosage: "Dosagem do PED",
			daily: "Diário",
			fivePerWeek: "5 × sem",
			threePerWeekHep: "3 × sem",
			reEvaluationFrequency: "Próxima reavaliação",
			fourWeeksReEval: "4 semanas",
			sixWeeksReEval: "6 semanas",
			nextReEvaluationDate: "Data da próxima reavaliação",
			otherFrequency: "Outra frequência",
			otherFrequencyPlaceholder: "Especificar outra frequência",
			otherHepDosage: "Outra dosagem do PED",
			otherHepDosagePlaceholder: "Especificar outra dosagem do PED",

			// 3. Equipamentos / Encaminhamentos Necessários
			requiredEquipmentReferrals:
				"3 · Equipamentos / Encaminhamentos Necessários",
			equipmentReferralsTitle: "Equipamentos / Encaminhamentos",
			none: "Nenhum",
			braceSplint: "Órtese / tala",
			assistiveDevice: "Dispositivo auxiliar",
			imagingRequest: "Solicitação de exames de imagem",
			physicianFollowUp: "Acompanhamento médico",
			nutritionMentalHealthConsult: "Consulta nutricional / saúde mental",
			otherEquipment: "Outro equipamento",
			otherEquipmentPlaceholder: "Especificar outro equipamento",

			// 4. Observações
			observations: "4 · Observações",
			observationsPlaceholder: "Digite suas observações e anotações aqui...",
		},

		// Outros Registros
		other: {
			basicInformation: "Informações Básicas",
			findingsAndActions: "Achados e Ações",
			followUp: "Acompanhamento",
			category: "Categoria",
			categoryPlaceholder: "Digite a categoria",
			details: "Detalhes",
			detailsPlaceholder: "Digite informações detalhadas sobre este registro",
			relevantFindings: "Achados Relevantes",
			relevantFindingsPlaceholder:
				"Digite quaisquer achados ou observações relevantes",
			actionItems: "Itens de Ação",
			actionItemsPlaceholder: "Digite itens de ação ou próximos passos",
			followUpRequired: "Acompanhamento Necessário",
			followUpDate: "Data de Acompanhamento",
		},
	},
	events: {
		title: "Eventos",
		description: "Gerencie eventos automatizados e mensagens para seu estúdio",
		accessDenied: "Você não tem permissão para acessar eventos.",
		birthdayEvents: {
			title: "Eventos de Aniversário",
			description:
				"Gerencie celebrações de aniversário e mensagens automatizadas",
			upcomingTitle: "Próximos Aniversários",
			configurationTitle: "Configuração de Eventos de Aniversário",
			noUpcomingEvents: "Nenhum aniversário nos próximos 30 dias",
			customerName: "Cliente",
			birthday: "Aniversário",
			daysUntil: "Dias Restantes",
			age: "Idade",
			actions: "Ações",
			sendMessage: "Enviar Mensagem",
			markAsSent: "Marcar como Enviado",
			configuration: {
				enabled: "Ativar Mensagens de Aniversário",
				enabledDescription:
					"Enviar automaticamente mensagens de aniversário para clientes",
				timing: "Tempo da Mensagem",
				timingDescription: "Quando enviar mensagens de aniversário",
				daysBeforeLabel: "Dias antes do aniversário",
				onBirthdayLabel: "No aniversário",
				daysAfterLabel: "Dias após o aniversário",
				messageTemplate: "Modelo de Mensagem",
				messageTemplateDescription:
					"Personalize o modelo de mensagem de aniversário",
				defaultTemplate:
					"Feliz Aniversário {{customerName}}! 🎉 Desejamos um dia maravilhoso cheio de alegria e felicidade. Obrigado por fazer parte da nossa família Pilates!",
				channels: "Canais de Comunicação",
				channelsDescription: "Selecione como enviar mensagens de aniversário",
				email: "Email",
				whatsapp: "WhatsApp",
				sms: "SMS",
				saveConfiguration: "Salvar Configuração",
				configurationSaved:
					"Configuração de eventos de aniversário salva com sucesso",
				configurationError: "Falha ao salvar configuração. Tente novamente.",
			},
		},
		paymentReminders: {
			title: "Lembretes de Pagamento",
			description:
				"Gerencie lembretes de pagamento e notificações automatizadas",
			upcomingTitle: "Próximos Lembretes de Pagamento",
			configurationTitle: "Configuração de Lembretes de Pagamento",
			noUpcomingEvents: "Nenhum lembrete de pagamento próximo",
			customerName: "Cliente",
			planName: "Plano",
			dueDate: "Data de Vencimento",
			amount: "Valor",
			daysUntilDue: "Dias até Vencimento",
			actions: "Ações",
			sendReminder: "Enviar Lembrete",
			markAsSent: "Marcar como Enviado",
			configuration: {
				enabled: "Ativar Lembretes de Pagamento",
				enabledDescription:
					"Enviar automaticamente mensagens de lembrete de pagamento",
				timing: "Tempo do Lembrete",
				timingDescription: "Quando enviar lembretes de pagamento",
				daysBeforeLabel: "Dias antes do vencimento",
				onDueDateLabel: "Na data de vencimento",
				daysAfterLabel: "Dias após vencimento (em atraso)",
				messageTemplate: "Modelo de Mensagem",
				messageTemplateDescription:
					"Personalize o modelo de mensagem de lembrete de pagamento",
				defaultTemplate:
					"Olá {{customerName}}, este é um lembrete amigável de que seu pagamento do {{planName}} no valor de {{amount}} {{currency}} vence em {{dueDate}}. Por favor, efetue seu pagamento para continuar aproveitando nossos serviços.",
				overdueTemplate: "Modelo de Mensagem em Atraso",
				overdueTemplateDescription: "Mensagem para pagamentos em atraso",
				defaultOverdueTemplate:
					"Olá {{customerName}}, seu pagamento do {{planName}} no valor de {{amount}} {{currency}} venceu em {{dueDate}} e está em atraso. Por favor, efetue seu pagamento o mais rápido possível para evitar interrupção do serviço.",
				channels: "Canais de Comunicação",
				channelsDescription: "Selecione como enviar lembretes de pagamento",
				email: "Email",
				whatsapp: "WhatsApp",
				sms: "SMS",
				saveConfiguration: "Salvar Configuração",
				configurationSaved:
					"Configuração de lembretes de pagamento salva com sucesso",
				configurationError: "Falha ao salvar configuração. Tente novamente.",
			},
		},
	},
	notifications: {
		config: {
			toasts: {
				updating: "Atualizando configurações de notificação...",
				updateSuccess: "Configurações de notificação atualizadas com sucesso",
				updateError: "Falha ao atualizar configurações de notificação",
			},
		},
		exclusions: {
			toasts: {
				adding: "Adicionando exclusão...",
				addSuccess: "Cliente excluído das notificações",
				addError: "Falha ao excluir cliente",
				removing: "Removendo exclusão...",
				removeSuccess: "Cliente reativado para notificações",
				removeError: "Falha ao remover exclusão",
			},
		},
		channels: {
			title: "Canais de Notificação",
			description: "Escolha quais canais usar para enviar notificações",
			email: "Email",
			emailDescription: "Enviar notificações por email",
			sms: "SMS",
			smsDescription: "Enviar notificações por mensagem de texto",
			whatsapp: "WhatsApp",
			whatsappDescription: "Enviar notificações via WhatsApp",
			smsTemplate: "Modelo de SMS",
			smsTemplateDescription:
				"Personalize o conteúdo da mensagem SMS (máx. 160 caracteres)",
			smsBodyLabel: "Mensagem SMS",
			smsBodyPlaceholder: "Digite sua mensagem SMS aqui...",
			smsCharLimit: "Limite de caracteres: 160",
			whatsappTemplate: "Modelo de WhatsApp",
			whatsappTemplateDescription:
				"Personalize o conteúdo da mensagem do WhatsApp",
			whatsappBodyLabel: "Mensagem do WhatsApp",
			whatsappBodyPlaceholder: "Digite sua mensagem do WhatsApp aqui...",
			whatsappHint: "Mensagens do WhatsApp suportam emojis e formatação básica",
		},
		birthdayReminder: {
			title: "Configuração de Lembrete de Aniversário",
			description:
				"Configure emails automáticos de aniversário enviados aos seus clientes",
			enableTitle: "Notificações de Aniversário",
			enableDescription:
				"Ativar ou desativar notificações automáticas de aniversário por email",
			enableLabel: "Enviar emails de lembrete de aniversário",
			messageTitle: "Modelo de Email",
			messageDescription: "Personalize o conteúdo do email de aniversário",
			subjectLabel: "Assunto do Email",
			subjectPlaceholder: "Feliz Aniversário do Estúdio de Pilates!",
			bodyLabel: "Corpo do Email",
			bodyPlaceholder:
				"Feliz Aniversário {{customerName}}! Desejamos um dia maravilhoso cheio de alegria.",
			templateHint:
				"Use {{customerName}} para incluir o nome do cliente na mensagem",
			variablesButton: "Variáveis",
			variablesTitle: "Variáveis de Modelo Disponíveis",
			variablesDescription:
				"Clique no botão de copiar para copiar uma variável, depois cole-a no seu modelo.",
			useTemplateButton: "Usar Modelo",
			variables: {
				customerName: "Nome completo do cliente",
				customerFirstName: "Primeiro nome do cliente",
				customerLastName: "Sobrenome do cliente",
				organizationName: "Nome da sua organização",
			},
			exclusionsTitle: "Clientes Excluídos",
			exclusionsDescription:
				"Estes clientes não receberão notificações de aniversário",
			noExclusions:
				"Nenhum cliente está excluído das notificações de aniversário",
			reason: "Motivo",
			moreExclusions: "Mostrando 10 de {{total}} clientes excluídos",
			addExclusion: "Adicionar Cliente",
			addExclusionTitle: "Excluir Cliente das Notificações de Aniversário",
			addExclusionDescription:
				"Pesquise um cliente para excluir das notificações de aniversário.",
			searchCustomerPlaceholder: "Pesquisar por nome ou email...",
			searchMinChars: "Digite pelo menos 2 caracteres para pesquisar",
			noCustomersFound: "Nenhum cliente encontrado",
			alreadyExcluded: "Já excluído",
			reasonLabel: "Motivo (opcional)",
			reasonPlaceholder: "ex: Cliente solicitou não receber emails",
			reasonHint: "Forneça um motivo para excluir este cliente",
			addExclusionButton: "Excluir Cliente",
		},
		enrollmentExpiry: {
			title: "Configuração de Lembrete de Expiração de Matrícula",
			description:
				"Configure lembretes automáticos enviados antes das matrículas dos clientes expirarem",
			enableTitle: "Notificações de Expiração de Matrícula",
			enableDescription:
				"Ativar ou desativar emails automáticos de lembrete de expiração de matrícula",
			enableLabel: "Enviar emails de lembrete de expiração de matrícula",
			configTitle: "Configurações do Lembrete",
			configDescription: "Configure quando os lembretes devem ser enviados",
			notifyOnExpiryDayLabel: "Notificar no dia da expiração",
			notifyOnExpiryDayDescription:
				"Enviar um lembrete no dia em que a matrícula expira",
			notifyDaysBeforeLabel: "Notificar antes da expiração",
			notifyDaysBeforeDescription:
				"Enviar um lembrete um número especificado de dias antes da matrícula expirar",
			daysBeforeExpiryLabel: "Dias antes da expiração",
			daysBeforeExpiryHint: "dias antes da matrícula expirar",
			messageTitle: "Modelo de Email",
			messageDescription:
				"Personalize o conteúdo do email de lembrete de expiração de matrícula",
			subjectLabel: "Assunto do Email",
			subjectPlaceholder: "Sua matrícula está prestes a expirar",
			bodyLabel: "Corpo do Email",
			bodyPlaceholder:
				"Prezado(a) {{customerName}}, sua matrícula do plano {{planName}} expirará em {{expiryDate}}.",
			templateHint:
				"Use variáveis de modelo para personalizar a mensagem para cada cliente",
			useTemplateButton: "Usar Modelo",
			variablesButton: "Variáveis",
			variablesTitle: "Variáveis de Modelo Disponíveis",
			variablesDescription:
				"Clique no botão de copiar para copiar uma variável, depois cole-a no seu modelo.",
			variables: {
				customerName: "Nome completo do cliente",
				customerFirstName: "Primeiro nome do cliente",
				customerLastName: "Sobrenome do cliente",
				organizationName: "Nome da sua organização",
				planName: "Nome do plano do cliente",
				expiryDate: "Data de expiração da matrícula",
				daysRemaining: "Número de dias até a expiração",
			},
			exclusionsTitle: "Clientes Excluídos",
			exclusionsDescription:
				"Estes clientes não receberão lembretes de expiração de matrícula",
			noExclusions:
				"Nenhum cliente está excluído das notificações de expiração de matrícula",
			reason: "Motivo",
			moreExclusions: "Mostrando 10 de {{total}} clientes excluídos",
			addExclusion: "Adicionar Cliente",
			addExclusionTitle:
				"Excluir Cliente das Notificações de Expiração de Matrícula",
			addExclusionDescription:
				"Pesquise um cliente para excluir dos lembretes de expiração de matrícula.",
			searchCustomerPlaceholder: "Pesquisar por nome ou email...",
			searchMinChars: "Digite pelo menos 2 caracteres para pesquisar",
			noCustomersFound: "Nenhum cliente encontrado",
			alreadyExcluded: "Já excluído",
			reasonLabel: "Motivo (opcional)",
			reasonPlaceholder: "ex: Cliente possui renovação automática",
			reasonHint: "Forneça um motivo para excluir este cliente",
			addExclusionButton: "Excluir Cliente",
		},
	},
	selectOrganization: {
		title: "Selecionar Organização",
		subtitle: "Escolha uma organização para continuar",
		ownedTitle: "Suas Organizações",
		invitedTitle: "Organizações nas quais você foi convidado",
		emptyOwned: "Você ainda não é proprietário de nenhuma organização.",
		emptyInvited: "Você ainda não possui convites.",
		noOrganizations: "Nenhuma organização encontrada",
		noOrganizationsDescription:
			"Você ainda não tem acesso a nenhuma organização.",
		loading: "Carregando organizações...",
		error: "Falha ao carregar organizações",
		retry: "Tentar novamente",
		role: "Função",
		roles: "Funções",
		selectButton: "Selecionar",
		deleteButton: "Excluir organização",
		deleteDialog: {
			title: "Excluir organização",
			description:
				'Tem certeza de que deseja excluir a organização "{{organizationName}}"?',
			irreversibleWarning:
				"Esta operação não é reversível. Depois de excluída, esta organização não poderá ser recuperada.",
			dataLossWarning:
				"Todos os dados relacionados a esta organização (clientes, agendas, matrículas, pagamentos e mais) serão removidos.",
			confirmLabel:
				'Para confirmar, digite abaixo o nome da organização "{{organizationName}}".',
			confirmButton: "Excluir organização",
			deleting: "Excluindo organização...",
		},
	},
	landing: {
		hero: {
			badge: "Feito para Estúdios de Pilates",
			titlePart1: "Menos planilha,",
			titleHighlight: "mais Pilates",
			titlePart2: "no seu dia",
			subtitle:
				"Chega de controlar presença no papel, cobrar aluno por WhatsApp e perder horas com planilhas. O PilatesTime centraliza agendas, presenças, cobranças e relatórios em um só lugar.",
			startTrial: "Teste Grátis por 14 Dias",
			watchDemo: "Ver como Funciona",
			trustItem1: "14 dias grátis",
			trustItem2: "Cancele quando quiser",
			retention: "Retenção de Clientes",
			studios: "Estúdios Ativos",
			efficiency: "Eficiência",
			efficiencyDescription: "Horas economizadas por semana",
			retentionDescription: "Aumento da taxa de retenção",
		},
		stats: {
			studios: "Estúdios Ativos",
			clients: "Clientes Gerenciados",
			retention: "Retenção Média",
			rating: "Avaliação dos Clientes",
		},
		features: {
			badge: "Feito para seu Estúdio",
			title: "Tudo num só lugar. Sem improvisos.",
			subtitle:
				"Pare de alternar entre planilhas, apps de mensagem e cadernos. O PilatesTime reúne o que você precisa para operar seu estúdio com mais controle e menos trabalho manual.",
			clientProfiles: {
				title: "Perfis e Presença de Alunos",
				description:
					"Ficha completa de cada aluno com histórico de presença, planos e observações. Sem depender de caderno ou memória.",
			},
			calendar: {
				title: "Agenda Inteligente",
				description:
					"Monte a grade de aulas e sessões privadas com facilidade. Visualize horários disponíveis e evite conflitos de agenda.",
			},
			payments: {
				title: "Cobranças e Faturamento",
				description:
					"Gere cobranças, acompanhe pagamentos e controle inadimplência num painel centralizado.",
			},
			analytics: {
				title: "Relatórios e Indicadores",
				description:
					"Saiba quanto seu estúdio faturou, quantos alunos estão ativos e quais horários têm mais demanda.",
			},
			mobile: {
				title: "Acesse de Qualquer Lugar",
				description:
					"Use pelo celular, tablet ou computador. Consulte a agenda do estúdio mesmo fora do horário comercial.",
			},
			security: {
				title: "Dados Protegidos",
				description:
					"Informações dos seus alunos e financeiras são armazenadas com criptografia e práticas modernas de segurança.",
			},
		},
		howItWorks: {
			badge: "Rápido de Configurar",
			title: "Do cadastro à primeira aula em minutos",
			subtitle: "Sem instalação, sem treinamento demorado. Veja como começar:",
			steps: {
				signup: {
					title: "Crie sua Conta",
					description:
						"Cadastro rápido com seu email. Comece seu teste grátis na hora.",
				},
				configure: {
					title: "Monte sua Grade",
					description:
						"Adicione seus horários, aulas e planos de acordo com a rotina do seu estúdio.",
				},
				manage: {
					title: "Cadastre seus Alunos",
					description:
						"Importe sua base ou adicione alunos manualmente. Tudo organizado desde o primeiro dia.",
				},
				grow: {
					title: "Gerencie com Tranquilidade",
					description:
						"Acompanhe presenças, cobranças e o desempenho do estúdio no dia a dia.",
				},
			},
		},
		aiFeatures: {
			title: "Recursos Potencializados por IA",
			segmentation: {
				title: "Segmentação e Perfil de Clientes",
				description:
					"Agrupe automaticamente os clientes com base em padrões de presença, preferências e objetivos para criar campanhas de marketing direcionadas.",
			},
			churnRisk: {
				title: "Pontuação de Risco de Abandono",
				description:
					"Identifique clientes em risco de desistir antes que eles saiam, permitindo estratégias proativas de retenção.",
			},
			communication: {
				title: "Comunicação Personalizada",
				description:
					"Gere mensagens e feedback personalizados com base no histórico e nas preferências do cliente.",
			},
			workoutRec: {
				title: "Recomendações de Treino Baseadas em IA",
				description:
					"Sugira programas de exercícios personalizados com base no progresso, objetivos e limitações do cliente.",
			},
		},
		testimonials: {
			title: "O que Dizem os Proprietários de Estúdios",
			quote: "",
			author: "",
			position: "",
		},
		pricing: {
			title: "Preços Simples e Transparentes",
			starter: {
				name: "Iniciante",
				price: "R$249",
				features: [
					"Gerenciamento de Clientes",
					"Agendamento Básico",
					"Processamento de Pagamentos",
					"Suporte por Email",
				],
			},
			professional: {
				name: "Profissional",
				price: "R$499",
				features: [
					"Tudo do Iniciante",
					"Segmentação de Clientes por IA",
					"Previsão de Abandono",
					"Comunicação Personalizada",
					"Suporte Prioritário",
				],
			},
			studioPro: {
				name: "Estúdio Pro",
				price: "R$749",
				features: [
					"Tudo do Profissional",
					"Suporte Multi-Instrutor",
					"Análises Avançadas",
					"Marca Personalizada",
					"Gerente de Conta Dedicado",
				],
			},
			selectPlan: "Selecionar Plano",
			perMonth: "/mês",
		},
		faq: {
			title: "Perguntas Frequentes",
			subtitle:
				"Tudo o que você precisa saber para começar a usar o Pilates Time",
			questions: [
				{
					question: "Como os dados de IA permanecem privados?",
					answer:
						"Seus dados são criptografados tanto em trânsito quanto em repouso. Usamos práticas de segurança padrão do setor e nunca compartilhamos os dados de seus clientes com terceiros.",
				},
				{
					question: "Posso importar minha lista de clientes existente?",
					answer:
						"Sim! O Pilates Time suporta a importação de dados de clientes de arquivos CSV, Excel e vários sistemas de gerenciamento populares.",
				},
				{
					question: "Quais integrações são suportadas?",
					answer:
						"Integramos com Stripe para pagamentos, Zoom para aulas virtuais, Google Calendar para agendamento e muitos outros serviços populares.",
				},
			],
		},
		cta: {
			title: "Seu estúdio merece uma gestão à altura",
			subtitle:
				"Teste o PilatesTime por 14 dias. Configure em menos de 5 minutos.",
			button: "Começar Teste Gratuito",
			trustText: "14 dias grátis • Cancele quando quiser",
		},
		footerSections: {
			about: {
				title: "Pilates Time",
				description:
					"Gestão completa para estúdios de Pilates. Agendas, presenças, cobranças e relatórios — tudo num só lugar.",
			},
			product: {
				title: "Produto",
				pricing: "Preços",
			},
			company: {
				title: "Empresa",
				aboutUs: "Sobre Nós",
				contact: "Contato",
			},
			contact: {
				title: "Contato",
				whatsappNumber: "5500000000000",
			},
			why: {
				title: "Por que o PilatesTime",
				clientManagement: "Gestão de alunos",
				scheduling: "Agenda inteligente",
				reports: "Relatórios e indicadores",
			},
			trust: {
				ssl: "Criptografia SSL",
				lgpd: "Conforme a LGPD",
				uptime: "99,9% Disponibilidade",
			},
		},
		socialMedia: {
			instagram: "Instagram",
			facebook: "Facebook",
			linkedin: "LinkedIn",
		},
	},
	about: {
		meta: {
			title: "Sobre o PilatesTime",
		},
		hero: {
			badge: "Sobre o PilatesTime",
			title: "Gestão de estúdio feita por quem entende Pilates",
			subtitle:
				"Nascemos para resolver um problema simples: donos de estúdio não deveriam gastar mais tempo com planilha do que com seus alunos.",
		},
		problem: {
			badge: "O Desafio",
			title: "Gerir um estúdio é mais difícil do que parece",
			subtitle:
				"Quem vê de fora acha que é só montar o Reformer e dar aula. Na prática, o dia a dia envolve muito mais.",
			points: {
				fragmented: {
					title: "Agendas em vários lugares",
					description:
						"Caderneta, WhatsApp, planilha e post-it ao mesmo tempo. A informação fica espalhada e fácil de perder.",
				},
				billing: {
					title: "Cobranças manuais",
					description:
						"Lembrar quem pagou, quem atrasou e quem precisa de um lembrete. Toda semana, a mesma rotina.",
				},
				attendance: {
					title: "Controle de presença no papel",
					description:
						"Sem saber quantos alunos faltaram, desistiram ou precisam de atenção. Os dados se perdem.",
				},
				noData: {
					title: "Decisões no escuro",
					description:
						"Sem dados reais sobre faturamento, retenção ou horários mais procurados. Só achismo.",
				},
			},
			closing:
				"O resultado? Horas de trabalho administrativo que poderiam ser horas de aula, atendimento e crescimento.",
		},
		solution: {
			badge: "A Solução",
			title: "O que é o PilatesTime",
			subtitle:
				"Uma plataforma de gestão completa, feita para a rotina real de estúdios de Pilates. Não é um software genérico de academia adaptado. É uma ferramenta pensada desde o início para quem vive Pilates.",
			capabilities: {
				centralized: {
					title: "Organização centralizada",
					description:
						"Agendas, aulas, sessões privadas e horários num único painel.",
				},
				attendance: {
					title: "Presença sem papel",
					description:
						"Registro de presença digital com histórico completo por aluno.",
				},
				billing: {
					title: "Cobrança sem atrito",
					description:
						"Geração de cobranças, acompanhamento de pagamentos e controle de inadimplência.",
				},
				insights: {
					title: "Visão clara do negócio",
					description:
						"Relatórios de faturamento, retenção, ocupação e demanda por horário.",
				},
				anywhere: {
					title: "Acesso de qualquer lugar",
					description:
						"Funciona no celular, tablet ou computador, dentro ou fora do estúdio.",
				},
			},
		},
		differentiation: {
			badge: "Por que o PilatesTime",
			title: "O que nos torna diferentes",
			blocks: {
				pilatesSpecific: {
					title: "Feito para Pilates, não para academia",
					description:
						"Softwares genéricos de gestão fitness não entendem a dinâmica de um estúdio de Pilates — sessões privadas, turmas pequenas, aulas com equipamento específico. O PilatesTime foi construído para esse contexto.",
				},
				timeSavings: {
					title: "Menos trabalho administrativo, mais tempo para ensinar",
					description:
						"Cobrar aluno por mensagem, conferir presença no caderno e montar relatório na planilha consome horas toda semana. Com o PilatesTime, essas tarefas são feitas em poucos cliques.",
				},
				dataDriven: {
					title: "Dados reais para decisões reais",
					description:
						"Quantos alunos estão ativos? Qual horário tem mais demanda? Quanto o estúdio faturou este mês? Em vez de adivinhar, você consulta. Relatórios claros que ajudam a crescer com base em fatos.",
				},
			},
		},
		values: {
			badge: "Nossos Valores",
			title: "No que acreditamos",
			mission: {
				label: "Missão",
				text: "Simplificar a gestão de estúdios de Pilates para que profissionais foquem no que fazem de melhor: cuidar dos seus alunos.",
			},
			vision: {
				label: "Visão",
				text: "Ser a plataforma de referência para gestão de estúdios de Pilates no Brasil — reconhecida pela praticidade, confiabilidade e impacto real no dia a dia.",
			},
			items: {
				simplicity: {
					title: "Simplicidade prática",
					description:
						"Se não facilita a rotina do estúdio, não entra no produto.",
				},
				reliability: {
					title: "Confiabilidade",
					description:
						"Seus dados e os dados dos seus alunos são tratados com seriedade.",
				},
				closeness: {
					title: "Proximidade",
					description: "Suporte dedicado e próximo, não um chatbot genérico.",
				},
				evolution: {
					title: "Evolução contínua",
					description:
						"O produto cresce junto com as necessidades de quem usa.",
				},
			},
		},
		audience: {
			badge: "Para Quem",
			title: "Para quem é o PilatesTime",
			personas: {
				owners: {
					title: "Donos de estúdio",
					description:
						"Que precisam de visão financeira e operacional sem depender de planilhas.",
				},
				instructors: {
					title: "Instrutores que também administram",
					description:
						"Que fazem tudo — dão aula, cobram, agendam — e precisam de agilidade.",
				},
				frontDesk: {
					title: "Recepcionistas e secretárias",
					description:
						"Que gerenciam matrículas, presenças e pagamentos no dia a dia.",
				},
				growing: {
					title: "Estúdios em crescimento",
					description:
						"Que sentem que os processos manuais não acompanham mais o ritmo do negócio.",
				},
			},
		},
		cta: {
			title: "Comece a gerir seu estúdio com mais controle",
			subtitle:
				"Teste o PilatesTime por 14 dias. Configure em menos de 5 minutos.",
			button: "Começar Teste Gratuito",
			trustText: "14 dias grátis • Cancele quando quiser",
		},
	},
	help: {
		title: "Ajuda & Suporte",
		description:
			"Encontre respostas para suas perguntas e aprenda a usar o Pilates Time efetivamente",
		gettingStarted: "Primeiros Passos",
		userGuide: "Guia do Usuário",
		faq: "Perguntas Frequentes",
		submitTicket: "Enviar Solicitação",
		myTickets: "Minhas Solicitações",
		support: "Contatar Suporte",
		supportNav: "Contatar Suporte",
		tutorials: "Tutoriais em Vídeo",
		gettingStartedTitle: "Primeiros Passos",
		gettingStartedDescription:
			"Aprenda o básico sobre como usar o Pilates Time",
		welcome: "Bem-vindo ao Pilates Time",
		welcomeDescription:
			"Seu guia completo para gerenciar seu estúdio de Pilates com eficiência",
		userGuideTitle: "Guia do Usuário",
		userGuideDescription: "Instruções detalhadas para todos os recursos",
		faqTitle: "Perguntas Frequentes",
		faqDescription: "Perguntas e respostas comuns",
		tutorialsTitle: "Tutoriais em Vídeo",
		tutorialsDescription: "Guias em vídeo passo a passo",
		quickStartGuide: "Guia de Início Rápido",
		quickStartDescription:
			"Comece com esses recursos essenciais para configurar seu sistema de gerenciamento de estúdio de Pilates.",
		gettingStartedSteps: "Passos para Começar",
		reportsAnalyticsQuickStart: "Relatórios e Análises",
		customersDescription:
			"Aprenda como adicionar e gerenciar perfis de clientes",
		schedulesDescription: "Configure aulas e gerencie a agenda do seu estúdio",
		attendanceDescription: "Acompanhe a presença e gerencie sessões de aula",
		paymentsDescription: "Gerencie cobrança e processamento de pagamentos",
		settingsDescription: "Configure sua organização e unidades",
		reportsDescription: "Visualize insights e gere relatórios",
		step1Title: "Registre novos Unidades",
		step1Description:
			"Crie unidades para as localizações do estúdio da sua organização. Vá para Registro > Unidades no menu lateral, clique em 'Adicionar Unidade' e preencha os detalhes da localização incluindo nome, endereço e informações de contato.",
		step2Title: "Adicione membros da equipe",
		step2Description:
			"Convide instrutores e funcionários para se juntarem à sua organização. Navegue para Registro > Equipe, clique em 'Convidar Novo Membro da Equipe', digite o email e nome deles, selecione a função (Administrador, Gerente, Instrutor, etc.) e envie o convite.",
		step3Title: "Crie planos de clientes",
		step3Description:
			"Configure planos de preços e pacotes para suas aulas. Vá para Planos de Clientes na navegação principal, clique em 'Criar Novo Plano', configure preços, ciclo de cobrança, recursos e acesso as unidade para definir o que os clientes podem comprar.",
		step4Title: "Crie horários",
		step4Description:
			"Configure os horários das suas aulas com instrutores, horários e capacidade. Navegue para Horários, clique em 'Criar Novo Horário', selecione a unidade, atribua membros da equipe, defina horários das aulas e configure padrões de recorrência.",
		step5Title: "Adicione clientes",
		step5Description:
			"Adicione perfis de clientes ao seu sistema. Vá para Clientes na navegação principal, clique em 'Adicionar Cliente' e preencha suas informações pessoais, detalhes de contato, endereço e quaisquer notas adicionais ou contatos de emergência.",
		step6Title: "Matricule clientes",
		step6Description:
			"Matricule clientes em horários usando seus planos comprados. Navegue para Matrículas, clique em 'Criar Matrícula', selecione o cliente, escolha o plano dele, selecione os horários e defina o período de matrícula para começar a acompanhar a presença.",
		userGuideOverview: "Visão Geral do Guia do Usuário",
		userGuideOverviewDescription:
			"Documentação completa para todos os recursos do Pilates Time",
		organizationSetup: "Configuração da Organização",
		organizationSetupDescription: "Configure sua organização e unidades",
		staffManagement: "Gerenciamento de Equipe",
		staffManagementDescription: "Gerencie instrutores e membros da equipe",

		// Staff Management Guide
		staffGuideOverviewTitle: "Visão Geral",
		staffGuideOverviewText:
			"O gerenciamento de equipe é essencial para organizar sua equipe e controlar o acesso às operações do seu estúdio de Pilates. Este sistema permite convidar membros da equipe, atribuir funções com permissões específicas e gerenciar seu acesso a diferentes unidades dentro de sua organização.",
		staffGuideKeyFeatures: "Recursos Principais",
		staffGuideKeyFeature1:
			"Controle de acesso baseado em funções com permissões organizacionais",
		staffGuideKeyFeature2:
			"Sistema de convite por email com datas de expiração",
		staffGuideKeyFeature3: "Gerenciamento de acesso por unidade",
		staffGuideKeyFeature4:
			"Rastreamento de status da equipe em tempo real (Ativo/Pendente)",

		staffGuideAccessingTitle: "Acessando o Gerenciamento de Equipe",
		staffGuideAccessingText: "Para acessar a seção de gerenciamento de equipe:",
		staffGuideAccessingStep1: "Navegue até o painel da sua organização",
		staffGuideAccessingStep2:
			'Clique em "Equipe" na seção Registro do menu lateral',
		staffGuideAccessingStep3:
			"Você verá a lista de equipe com membros ativos e convites pendentes",
		staffGuidePermissionTitle: "Requisitos de Permissão",
		staffGuidePermissionText:
			'Você precisa das permissões "MANAGE_STAFF" ou "INVITE_STAFF" para acessar os recursos de gerenciamento de equipe. Entre em contato com o administrador da organização se não vir essas opções.',
		staffGuideAccessingImagePlaceholder:
			"Placeholder de imagem: Captura de tela do painel da organização mostrando o item de menu Equipe na navegação lateral",

		staffGuideRolesTitle: "Entendendo Funções e Permissões",
		staffGuideRolesText:
			"O sistema usa funções organizacionais que determinam quais recursos os membros da equipe podem acessar:",
		staffGuideRolesAvailableTitle: "Funções Organizacionais Disponíveis",
		staffGuideRoleOwnerTitle: "Proprietário",
		staffGuideRoleOwnerText:
			"Acesso completo a todos os recursos e configurações da organização. Não pode ser removido ou ter função alterada.",
		staffGuideRoleAdministratorTitle: "Administrador",
		staffGuideRoleAdministratorText:
			"Gerenciar configurações da organização, equipe e todos os recursos. Acesso quase completo.",
		staffGuideRoleManagerTitle: "Gerente",
		staffGuideRoleManagerText:
			"Gerenciar operações diárias, equipe e a maioria dos recursos. Acesso administrativo limitado.",
		staffGuideRoleInstructorTitle: "Instrutor",
		staffGuideRoleInstructorText:
			"Acesso a registros médicos e recursos relacionados. Pode gerenciar informações de saúde dos clientes.",
		staffGuideRoleAccountantTitle: "Contador",
		staffGuideRoleAccountantText:
			"Acesso a dados financeiros e gerenciamento de pagamentos. Limitado a recursos de faturamento.",
		staffGuideRoleViewerTitle: "Visualizador",
		staffGuideRoleViewerText:
			"Acesso somente leitura aos dados da organização. Não pode fazer alterações ou gerenciar outros funcionários.",
		staffGuideRolePermissionsMatrixTitle: "Matriz de Permissões de Função",
		staffGuideRolePermissionsMatrixText:
			'Clique em "Ver Permissões" no diálogo de convite de equipe para ver uma matriz detalhada do que cada função pode acessar e gerenciar dentro da organização.',
		staffGuideRolesImagePlaceholder:
			"Placeholder de imagem: Captura de tela da matriz de permissões de função mostrando diferentes funções e suas capacidades",

		staffGuideListTitle: "Visão Geral da Lista de Equipe",
		staffGuideListText:
			"A lista de equipe exibe todos os membros da equipe e convites pendentes em uma tabela abrangente:",
		staffGuideListColumnsTitle: "Colunas da Tabela",
		staffGuideListColumn1Title: "Membro da Equipe",
		staffGuideListColumn1Text:
			"Mostra foto do perfil, nome e endereço de email",
		staffGuideListColumn2Title: "Função",
		staffGuideListColumn2Text: "Função organizacional com ícone e rótulo",
		staffGuideListColumn3Title: "Status",
		staffGuideListColumn3Text:
			"Ativo (verde) para membros que ingressaram, Pendente (amarelo) para convites",
		staffGuideListColumn4Title: "Ingressou em / Expira",
		staffGuideListColumn4Text:
			"Data de ingresso para membros ativos, data de expiração para convites pendentes",
		staffGuideListIndicatorsTitle: "Indicadores Visuais",
		staffGuideListIndicator1:
			"Ponto verde: Membros da equipe ativos que ingressaram",
		staffGuideListIndicator2:
			"Ícone de relógio amarelo: Convites pendentes aguardando aceitação",
		staffGuideListIndicator3:
			"Linhas destacadas: Convites pendentes têm um fundo amarelo sutil",
		staffGuideListIndicator4:
			"Fotos de perfil: Mostram avatares dos membros ou ícones de usuário padrão",
		staffGuideListImagePlaceholder:
			"Placeholder de imagem: Captura de tela da lista de equipe mostrando membros ativos e convites pendentes",

		staffGuideInvitingTitle: "Convidando Novos Membros da Equipe",
		staffGuideInvitingText:
			"Adicionar novos membros da equipe é feito através de um sistema de convite por email:",
		staffGuideInvitingStep1Title: "Passo 1: Abrir o Diálogo de Convite",
		staffGuideInvitingStep1Text1:
			'Clique no botão "Convidar Novo Membro da Equipe" (ícone +) na página de gerenciamento de equipe',
		staffGuideInvitingStep1Text2:
			"O diálogo de convite abrirá com duas seções principais",
		staffGuideInvitingStep2Title: "Passo 2: Preencher Informações de Contato",
		staffGuideInvitingRequiredFieldsTitle: "Campos Obrigatórios",
		staffGuideInvitingRequiredField1:
			"Endereço de Email: O email de trabalho da pessoa (obrigatório)",
		staffGuideInvitingRequiredField2:
			"Nome: Nome completo da pessoa (opcional mas recomendado)",
		staffGuideInvitingStep3Title: "Passo 3: Selecionar Função e Permissões",
		staffGuideInvitingRoleSelectionTitle: "Seleção de Função Organizacional",
		staffGuideInvitingRoleSelection1:
			"Escolha entre as funções organizacionais disponíveis (Administrador, Gerente, Instrutor, etc.)",
		staffGuideInvitingRoleSelection2:
			"Cada função mostra uma descrição de suas permissões",
		staffGuideInvitingRoleSelection3:
			'Clique em "Ver Permissões" para ver a matriz detalhada de permissões',
		staffGuideInvitingRoleSelection4:
			'A função padrão é "Visualizador" por segurança',
		staffGuideInvitingStep4Title: "Passo 4: Enviar o Convite",
		staffGuideInvitingStep4Text1: "Revise todas as informações para precisão",
		staffGuideInvitingStep4Text2:
			'Clique em "Enviar Convite" para enviar o convite por email',
		staffGuideInvitingStep4Text3:
			"A pessoa receberá um email com instruções para ingressar",
		staffGuideInvitingStep4Text4:
			'O convite aparecerá na lista de equipe com status "Pendente"',
		staffGuideInvitingDetailsTitle: "Detalhes do Convite",
		staffGuideInvitingDetail1:
			"Convites expiram após um período definido (verifique a data de expiração)",
		staffGuideInvitingDetail2:
			"Destinatários devem ter um endereço de email válido",
		staffGuideInvitingDetail3:
			"Eles precisarão criar uma conta se não tiverem uma",
		staffGuideInvitingDetail4:
			'Uma vez aceito, eles aparecerão como "Ativo" na lista de equipe',
		staffGuideInvitingImagePlaceholder:
			"Placeholder de imagem: Captura de tela do diálogo de convite de equipe mostrando todos os campos do formulário e seleção de função",

		staffGuideManagingTitle: "Gerenciando Equipe Existente",
		staffGuideManagingText:
			"Uma vez que os membros da equipe estão ativos, você pode gerenciar suas funções e acesso as unidades:",
		staffGuideManagingEditingTitle: "Editando Informações da Equipe",
		staffGuideManagingEditingStep1:
			"Clique no botão editar (ícone de lápis) ao lado de qualquer membro da equipe",
		staffGuideManagingEditingStep2:
			"Você será levado à página de edição detalhada do membro da equipe",
		staffGuideManagingEditingStep3:
			"A página mostra três seções principais: Informações, Função Organizacional e Acesso ao Unidade",
		staffGuideManagingActionsTitle: "Ações Disponíveis",
		staffGuideManagingAction1Title: "Alterar Função Organizacional",
		staffGuideManagingAction1Text:
			"Atualizar as permissões organizacionais e nível de acesso do membro da equipe",
		staffGuideManagingAction2Title: "Gerenciar Acesso ao Unidade",
		staffGuideManagingAction2Text:
			"Atribuir ou remover acesso a unidades específicas dentro da organização",
		staffGuideManagingAction3Title: "Ver Informações da Equipe",
		staffGuideManagingAction3Text:
			"Ver detalhes do perfil, data de ingresso e atribuições de função atuais",
		staffGuideManagingAction4Title: "Remover Membro da Equipe",
		staffGuideManagingAction4Text:
			"Remover permanentemente o membro da equipe da organização",
		staffGuideManagingNotesTitle: "Notas Importantes",
		staffGuideManagingNote1:
			"Proprietários da Organização não podem ser editados ou removidos",
		staffGuideManagingNote2:
			"Alterações de função entram em vigor imediatamente",
		staffGuideManagingNote3:
			"Remover equipe é permanente e não pode ser desfeito",
		staffGuideManagingNote4:
			"Membros da equipe perderão acesso a todos os dados da organização quando removidos",
		staffGuideManagingImagePlaceholder:
			"Placeholder de imagem: Captura de tela da página de edição de equipe mostrando gerenciamento de função e atribuições de unidade",

		staffGuidePendingTitle: "Gerenciando Convites Pendentes",
		staffGuidePendingText:
			"Convites pendentes aparecem na lista de equipe e podem ser gerenciados até expirarem ou serem aceitos:",
		staffGuidePendingStatusTitle: "Status do Convite",
		staffGuidePendingStatus1:
			"Convites pendentes mostram com um ícone de relógio amarelo e fundo destacado",
		staffGuidePendingStatus2:
			'A data de expiração é exibida na coluna "Ingressou em"',
		staffGuidePendingStatus3:
			"Nome ou email do convidado é mostrado na coluna Membro da Equipe",
		staffGuidePendingStatus4:
			"A função atribuída exibe qual função eles terão quando aceitarem",
		staffGuidePendingActionsTitle: "Ações Disponíveis",
		staffGuidePendingActionTitle: "Revogar Convite",
		staffGuidePendingActionText:
			"Cancelar um convite pendente antes de ser aceito. Clique no botão X na coluna Ações.",
		staffGuidePendingAcceptanceTitle:
			"O que Acontece Quando Convites São Aceitos",
		staffGuidePendingAcceptanceStep1:
			"A pessoa cria uma conta ou faz login com sua conta existente",
		staffGuidePendingAcceptanceStep2:
			"Eles são automaticamente adicionados à organização com a função atribuída",
		staffGuidePendingAcceptanceStep3:
			'Seu status muda de "Pendente" para "Ativo" na lista de equipe',
		staffGuidePendingAcceptanceStep4:
			"Eles ganham acesso aos recursos baseados em sua função atribuída",
		staffGuidePendingAcceptanceStep5: "O convite é removido da lista pendente",
		staffGuidePendingExpirationTitle: "Expiração do Convite",
		staffGuidePendingExpirationText:
			"Convites expiram automaticamente após um período definido. Convites expirados são automaticamente removidos do sistema e precisarão ser reenviados se a pessoa ainda precisar de acesso.",
		staffGuidePendingImagePlaceholder:
			"Placeholder de imagem: Captura de tela mostrando convites pendentes na lista de equipe com datas de expiração e opções de revogação",

		staffGuideEstablishmentTitle: "Gerenciamento de Acesso ao Unidade",
		staffGuideEstablishmentText:
			"Além das funções organizacionais, membros da equipe podem ser atribuídos a unidades específicas para acesso aos dados:",
		staffGuideEstablishmentUnderstandingTitle: "Entendendo o Acesso ao Unidade",
		staffGuideEstablishmentUnderstanding1:
			"Funções organizacionais determinam quais recursos a equipe pode acessar",
		staffGuideEstablishmentUnderstanding2:
			"Atribuições de unidade determinam quais dados da unidade eles podem ver",
		staffGuideEstablishmentUnderstanding3:
			"A equipe pode ser atribuída a múltiplos unidades",
		staffGuideEstablishmentUnderstanding4:
			"Sem acesso aa unidade, a equipe não pode ver dados de clientes ou cronogramas",
		staffGuideEstablishmentAssigningTitle: "Atribuindo Unidades",
		staffGuideEstablishmentAssigningStep1:
			"Vá para a página de edição do membro da equipe",
		staffGuideEstablishmentAssigningStep2:
			'Role até a seção "Acesso ao Unidade"',
		staffGuideEstablishmentAssigningStep3:
			'Selecione unidades do dropdown "Unidades Disponíveis"',
		staffGuideEstablishmentAssigningStep4:
			'Clique em "Atribuir Selecionados" para conceder acesso',
		staffGuideEstablishmentAssigningStep5:
			'As unidades aparecerão na lista "Atualmente Atribuído a"',
		staffGuideEstablishmentRemovingTitle: "Removendo Acesso ao Unidade",
		staffGuideEstablishmentRemoving1:
			'Clique no botão "Remover atribuição" ao lado de qualquer unidade atribuída',
		staffGuideEstablishmentRemoving2:
			"O membro da equipe perderá imediatamente o acesso aos dados dessa unidade",
		staffGuideEstablishmentRemoving3:
			"Esta ação é reversível - você pode reatribuí-los mais tarde",
		staffGuideEstablishmentBestPracticeTitle: "Melhor Prática",
		staffGuideEstablishmentBestPracticeText:
			"Atribua membros da equipe apenas as unidades onde eles realmente trabalham ou precisam de acesso. Isso segue o princípio do menor privilégio e ajuda a manter a segurança dos dados.",
		staffGuideEstablishmentImagePlaceholder:
			"Placeholder de imagem: Captura de tela do gerenciamento de acesso as unidade mostrando opções de atribuição e remoção",

		customerManagement: "Gerenciamento de Clientes",
		customerManagementDescription:
			"Gerencie perfis e relacionamentos de clientes",
		customerPlans: "Planos de Clientes",
		customerPlansDescription: "Crie e gerencie planos de preços",
		scheduleManagement: "Gerenciamento de Horários",
		scheduleManagementDescription: "Configure aulas e horários recorrentes",

		// Schedule Management Guide
		scheduleGuideOverviewTitle: "Visão Geral",
		scheduleGuideOverviewText:
			"O gerenciamento de horários é o núcleo das operações do seu estúdio de Pilates. Permite criar e gerenciar horários de aulas, configurar sessões recorrentes, controlar capacidade e atribuir instrutores. O sistema suporta tanto aulas em grupo quanto sessões individuais com horários flexíveis e padrões de recorrência.",
		scheduleGuideKeyFeatures: "Recursos Principais",
		scheduleGuideKeyFeature1:
			"Dois tipos de horário: Sessões em grupo com limites de capacidade e Sessões individuais",
		scheduleGuideKeyFeature2:
			"Recorrência flexível: Sessões únicas, Recorrência semanal ou Recorrência mensal",
		scheduleGuideKeyFeature3:
			"Atribuição de funcionários e agendamento específico por unidade",
		scheduleGuideKeyFeature4:
			"Gerenciamento abrangente de tempo com validação e prevenção de conflitos",

		scheduleGuideAccessingTitle: "Acessando o Gerenciamento de Horários",
		scheduleGuideAccessingText:
			"Para acessar a seção de gerenciamento de horários:",
		scheduleGuideAccessingStep1: "Navegue até o painel da sua organização",
		scheduleGuideAccessingStep2:
			'Clique em "Horários" no menu de navegação principal',
		scheduleGuideAccessingStep3:
			"Você verá uma lista abrangente de todos os horários com seus detalhes",
		scheduleGuidePermissionTitle: "Requisitos de Permissão",
		scheduleGuidePermissionText:
			'Você precisa da permissão "VIEW_SCHEDULES" para ver horários e "MANAGE_SCHEDULES" para criar, editar ou excluir horários. Essas permissões são específicas da unidade, então você só verá horários das unidades aos quais tem acesso.',
		scheduleGuideImagePlaceholder:
			"Placeholder de imagem: Captura de tela da página de gerenciamento de horários mostrando a navegação e lista de horários",

		scheduleGuideTypesTitle: "Entendendo os Tipos de Horário",
		scheduleGuideTypesText:
			"O sistema suporta dois tipos distintos de horários, cada um projetado para diferentes cenários de ensino:",
		scheduleGuideTypesOptionsTitle: "Opções de Tipo de Horário",
		scheduleGuideGroupTitle: "Sessões em Grupo",
		scheduleGuideGroupFeature1:
			"Controle de Capacidade: Defina o número máximo de participantes (1-50)",
		scheduleGuideGroupFeature2:
			"Gerenciamento de Aulas: Perfeito para aulas em grupo e workshops",
		scheduleGuideGroupFeature3:
			"Acompanhamento de Matrículas: Monitore quantas vagas estão preenchidas",
		scheduleGuideGroupFeature4:
			"Suporte a Lista de Espera: Gerencie excesso quando as aulas estão lotadas",
		scheduleGuideIndividualTitle: "Sessões Individuais",
		scheduleGuideIndividualFeature1:
			"Um-a-Um: Projetado para sessões de treinamento pessoal",
		scheduleGuideIndividualFeature2:
			"Sem Limite de Capacidade: Sempre disponível para um único cliente",
		scheduleGuideIndividualFeature3:
			"Serviço Personalizado: Atenção focada e programas customizados",
		scheduleGuideIndividualFeature4:
			"Agendamento Flexível: Mais fácil de reagendar ou modificar",
		scheduleGuideTypesImportantNote: "Nota Importante",
		scheduleGuideTypesImportantText:
			"O tipo de horário não pode ser alterado após a criação. Escolha cuidadosamente com base em como planeja usar o horário. Se precisar alterar o tipo, será necessário criar um novo horário e migrar as matrículas existentes.",
		scheduleGuideTypesImagePlaceholder:
			"Placeholder de imagem: Diagrama de comparação mostrando tipos de horário em grupo vs individual com seus recursos",

		scheduleGuideRecurrenceTitle: "Padrões de Recorrência",
		scheduleGuideRecurrenceText:
			"O sistema oferece opções flexíveis de recorrência para acomodar diferentes necessidades de agendamento:",
		scheduleGuideRecurrenceTypesTitle: "Tipos de Recorrência Disponíveis",
		scheduleGuideSingleTitle: "Sessão Única",
		scheduleGuideSingleFeature1:
			"Evento Único: Perfeito para workshops, eventos especiais ou aulas experimentais",
		scheduleGuideSingleFeature2:
			"Data Específica: Ocorre apenas na data de início selecionada",
		scheduleGuideSingleFeature3:
			"Sem Data Final: Campo de data final não é obrigatório",
		scheduleGuideSingleFeature4:
			"Horário Flexível: Pode ser agendado a qualquer momento",
		scheduleGuideWeeklyTitle: "Recorrência Semanal",
		scheduleGuideWeeklyFeature1:
			"Aulas Regulares: Ideal para horários de aulas contínuas",
		scheduleGuideWeeklyFeature2:
			"Seleção de Dias: Escolha dias específicos da semana (Segunda, Terça, etc.)",
		scheduleGuideWeeklyFeature3:
			"Intervalo de Datas: Defina datas de início e fim para o período recorrente",
		scheduleGuideWeeklyFeature4:
			"Múltiplos Dias: Pode ocorrer em vários dias por semana",
		scheduleGuideDaySelectionTitle: "Seleção de Dias da Semana",
		scheduleGuideDaySelectionText:
			"Para horários com recorrência semanal, você pode selecionar múltiplos dias da semana. O sistema criará sessões para cada dia selecionado dentro do intervalo de datas especificado.",
		scheduleGuideDaySelectionExample:
			"Exemplo: Um horário definido para Segunda, Quarta e Sexta de 1º de janeiro a 31 de março criará sessões toda Segunda, Quarta e Sexta durante esse período.",
		scheduleGuideEditingRestrictionsTitle: "Restrições de Edição",
		scheduleGuideEditingRestrictionsText:
			"O tipo de recorrência não pode ser alterado após a criação do horário. Ao editar horários com matrículas existentes, o número de dias selecionados deve permanecer o mesmo para preservar os limites de matrícula e prevenir conflitos.",
		scheduleGuideRecurrenceImagePlaceholder:
			"Placeholder de imagem: Visualização de calendário mostrando diferentes padrões de recorrência com horários de exemplo",

		scheduleGuideCreatingTitle: "Criando Novos Horários",
		scheduleGuideCreatingText:
			"Criar um novo horário envolve configurar múltiplas seções para garantir que todos os detalhes sejam configurados adequadamente:",
		scheduleGuideCreatingStep1Title: "Passo 1: Acessar o Formulário de Criação",
		scheduleGuideCreatingStep1Text1:
			'Clique no botão "Criar Novo Horário" (ícone +) na página de gerenciamento de horários',
		scheduleGuideCreatingStep1Text2:
			"Você será levado a um formulário abrangente com quatro seções principais",
		scheduleGuideCreatingStep1Text3:
			"Cada seção é claramente rotulada com ícones e descrições",
		scheduleGuideCreatingSection1Title: "Seção 1: Informações Básicas",
		scheduleGuideCreatingSection1Subtitle:
			"Configure os detalhes básicos do seu horário",
		scheduleGuideCreatingSection1Feature1:
			'Nome do Horário: Nome claro e descritivo (ex: "Pilates Matinal", "Aula de Mat Avançado")',
		scheduleGuideCreatingSection1Feature2:
			"Descrição: Descrição detalhada opcional do conteúdo e nível da aula",
		scheduleGuideCreatingSection1Feature3:
			"Tipo de Horário: Escolha entre Sessão em Grupo ou Sessão Individual",
		scheduleGuideCreatingSection2Title: "Seção 2: Local e Funcionários",
		scheduleGuideCreatingSection2Subtitle:
			"Selecione a unidade e funcionário para este horário",
		scheduleGuideCreatingSection2Feature1:
			"Unidade: Escolha qual local hospedará este horário",
		scheduleGuideCreatingSection2Feature2:
			"Funcionário: Atribua o instrutor ou funcionário responsável",
		scheduleGuideCreatingSection2Feature3:
			"Nota: Ambos os campos são obrigatórios e não podem ser alterados após a criação",
		scheduleGuideCreatingSection3Title: "Seção 3: Configurações do Horário",
		scheduleGuideCreatingSection3Subtitle:
			"Configure horário, capacidade e configurações de data",
		scheduleGuideCreatingSection3Feature1:
			"Capacidade: Para sessões em grupo, defina o máximo de participantes (1-50)",
		scheduleGuideCreatingSection3Feature2:
			"Horário de Início: Horário de início da sessão no formato HH:MM (ex: 09:00)",
		scheduleGuideCreatingSection3Feature3:
			"Horário de Término: Horário de término da sessão no formato HH:MM (ex: 10:00)",
		scheduleGuideCreatingSection3Feature4:
			"Data de Início: Quando o horário começa (não pode ser alterado após a criação)",
		scheduleGuideCreatingSection3Feature5:
			"Data de Término: Para horários recorrentes, quando o padrão termina",
		scheduleGuideCreatingSection4Title: "Seção 4: Recorrência e Configuração",
		scheduleGuideCreatingSection4Subtitle:
			"Configure padrão de recorrência e notas adicionais",
		scheduleGuideCreatingSection4Feature1:
			"Tipo de Recorrência: Sessão Única ou Semanal (não pode ser alterado após a criação)",
		scheduleGuideCreatingSection4Feature2:
			"Dias da Semana: Para horários semanais, selecione quais dias (Segunda, Terça, etc.)",
		scheduleGuideCreatingSection4Feature3:
			"Notas: Informações adicionais opcionais sobre o horário",
		scheduleGuideValidationTitle: "Validação do Formulário",
		scheduleGuideValidationSubtitle: "Regras de Validação",
		scheduleGuideValidationRule1:
			"Horário de término deve ser após o horário de início",
		scheduleGuideValidationRule2:
			"Data de término deve ser após a data de início (para horários recorrentes)",
		scheduleGuideValidationRule3:
			"Pelo menos um dia deve ser selecionado para horários com recorrência semanal",
		scheduleGuideValidationRule4:
			"Capacidade é obrigatória para sessões em grupo",
		scheduleGuideValidationRule5:
			"Todos os campos de horário devem estar no formato HH:MM válido",
		scheduleGuideCreatingImagePlaceholder:
			"Placeholder de imagem: Captura de tela do formulário de criação de horário mostrando todas as quatro seções",

		// Adding key sections for editing, deletion, and migration
		scheduleGuideEditingTitle: "Editando Horários",
		scheduleGuideEditingText:
			"A edição de horários oferece flexibilidade mantendo a integridade dos dados para matrículas existentes:",
		scheduleGuideDeletionTitle: "Exclusão de Horário",
		scheduleGuideDeletionText:
			"A exclusão de horário é uma ação permanente que requer consideração cuidadosa de seu impacto:",
		scheduleGuideDetailsTitle: "Detalhes do Horário e Abas",
		scheduleGuideDetailsText:
			"Quando você clica no botão editar em qualquer horário, é levado à página de detalhes do horário com abas abrangentes para gerenciar todos os aspectos do horário:",
		scheduleGuideMigrationTitle: "Sistema de Migração de Matrículas",
		scheduleGuideMigrationText:
			"O sistema de migração permite mover clientes matriculados de um horário para outro, essencial para lidar com mudanças de horário, fechamentos ou reorganização:",

		// Schedule List and Management
		scheduleGuideListTitle: "Lista e Gerenciamento de Horários",
		scheduleGuideListText:
			"A lista de horários fornece uma visão abrangente de todos os seus horários com informações detalhadas e opções de gerenciamento:",
		scheduleGuideListColumnsTitle: "Visão Geral das Colunas da Tabela",
		scheduleGuideListColumn1Title: "Nome e Descrição",
		scheduleGuideListColumn1Text:
			"Nome do horário com descrição opcional exibida abaixo",
		scheduleGuideListColumn2Title: "Tipo",
		scheduleGuideListColumn2Text:
			'Badge mostrando "Sessão em Grupo" ou "Sessão Individual"',
		scheduleGuideListColumn3Title: "Unidade",
		scheduleGuideListColumn3Text: "Local onde o horário acontece",
		scheduleGuideListColumn4Title: "Funcionário",
		scheduleGuideListColumn4Text: "Nome do instrutor ou funcionário atribuído",
		scheduleGuideListColumn5Title: "Horário",
		scheduleGuideListColumn5Text:
			'Intervalo de tempo formatado (ex: "09:00 - 10:00")',
		scheduleGuideListColumn6Title: "Recorrência",
		scheduleGuideListColumn6Text:
			"Tipo de recorrência com dias da semana selecionados exibidos abaixo",
		scheduleGuideListColumn7Title: "Capacidade",
		scheduleGuideListColumn7Text:
			'Máximo de participantes para sessões em grupo ou "Individual" para sessões pessoais',
		scheduleGuideListColumn8Title: "Status",
		scheduleGuideListColumn8Text:
			"Badge de status Ativo (verde) ou Inativo (cinza)",
		scheduleGuideListActionsTitle: "Ações Disponíveis",
		scheduleGuideListEditTitle: "Editar Horário",
		scheduleGuideListEditText:
			"Clique no botão editar (ícone de lápis) para modificar detalhes do horário. Note que alguns campos como tipo, unidade e tipo de recorrência não podem ser alterados após a criação.",
		scheduleGuideListDeleteTitle: "Excluir Horário",
		scheduleGuideListDeleteText:
			"Clique no botão excluir (ícone de lixeira) para remover permanentemente o horário. Um diálogo de confirmação mostrará os impactos potenciais antes da exclusão.",
		scheduleGuideListEmptyTitle: "Estado Vazio",
		scheduleGuideListEmptyText:
			'Quando não existem horários, o sistema exibe um estado vazio útil com um botão "Criar Seu Primeiro Horário" para começar rapidamente.',
		scheduleGuideListImagePlaceholder:
			"Placeholder de imagem: Captura de tela da lista de horários mostrando diferentes tipos de horários e suas informações",

		// Editing Schedules
		scheduleGuideEditingAccessTitle: "Acessando o Modo de Edição",
		scheduleGuideEditingAccessStep1:
			"Clique no botão editar (ícone de lápis) ao lado de qualquer horário na lista",
		scheduleGuideEditingAccessStep2:
			"Você será levado à página de detalhes do horário com edição como aba padrão",
		scheduleGuideEditingAccessStep3:
			"O formulário é pré-preenchido com as informações atuais do horário",
		scheduleGuideEditingAccessStep4:
			"Alguns campos podem estar desabilitados para proteger matrículas existentes",
		scheduleGuideEditingFieldsTitle: "Campos Editáveis vs. Protegidos",
		scheduleGuideEditingEditableTitle: "Campos Editáveis",
		scheduleGuideEditingEditableField1: "Nome e descrição do horário",
		scheduleGuideEditingEditableField2: "Atribuição de funcionário",
		scheduleGuideEditingEditableField3: "Capacidade (para sessões em grupo)",
		scheduleGuideEditingEditableField4: "Horários de início e término",
		scheduleGuideEditingEditableField5:
			"Data de término (pode ser reduzida com confirmação)",
		scheduleGuideEditingEditableField6: "Dias da semana (com restrições)",
		scheduleGuideEditingEditableField7: "Notas e informações adicionais",
		scheduleGuideEditingProtectedTitle: "Campos Protegidos",
		scheduleGuideEditingProtectedField1: "Tipo de horário (Grupo/Individual)",
		scheduleGuideEditingProtectedField2: "Local da unidade",
		scheduleGuideEditingProtectedField3: "Data de início",
		scheduleGuideEditingProtectedField4: "Tipo de recorrência (Única/Semanal)",
		scheduleGuideEditingProtectedText:
			"Esses campos não podem ser alterados após a criação do horário para manter a consistência dos dados.",
		scheduleGuideEditingConfirmationTitle: "Sistema de Confirmação de Mudanças",
		scheduleGuideEditingConfirmationText:
			"Ao editar horários com matrículas existentes, certas mudanças requerem confirmação:",
		scheduleGuideEditingTimeChangesTitle: "Mudanças de Horário e Dia",
		scheduleGuideEditingTimeChangesText:
			"Alterar horários de início/término ou dias da semana quando clientes estão matriculados aciona um modal de confirmação explicando o impacto nas matrículas existentes.",
		scheduleGuideEditingEndDateTitle: "Redução da Data de Término",
		scheduleGuideEditingEndDateText:
			"Reduzir a data de término mostra um aviso de que sessões futuras serão excluídas preservando dados de sessão existentes e registros de presença.",
		scheduleGuideEditingDayCountTitle: "Preservação da Contagem de Dias",
		scheduleGuideEditingDayCountText:
			"Para horários com matrículas, o número de dias selecionados deve permanecer o mesmo para preservar limites de matrícula e prevenir conflitos.",
		scheduleGuideEditingImagePlaceholder:
			"Placeholder de imagem: Captura de tela do formulário de edição de horário mostrando campos protegidos e diálogos de confirmação",

		// Schedule Deletion
		scheduleGuideDeletionProcessTitle: "Processo de Exclusão",
		scheduleGuideDeletionProcessStep1:
			"Clique no botão excluir (ícone de lixeira) ao lado do horário que deseja remover",
		scheduleGuideDeletionProcessStep2:
			"Um modal de confirmação aparecerá mostrando os detalhes do horário",
		scheduleGuideDeletionProcessStep3:
			"O modal exibe impactos potenciais e avisos",
		scheduleGuideDeletionProcessStep4:
			"Confirme a exclusão para remover permanentemente o horário",
		scheduleGuideDeletionImpactTitle: "Avaliação de Impacto",
		scheduleGuideDeletionImpactText:
			"O modal de confirmação de exclusão fornece informações detalhadas sobre o que será afetado:",
		scheduleGuideDeletionImpact1:
			"Número de matrículas existentes que serão removidas",
		scheduleGuideDeletionImpact2:
			"Número de sessões futuras que serão canceladas",
		scheduleGuideDeletionImpact3: "Registros de presença que serão preservados",
		scheduleGuideDeletionImpact4:
			"Implicações de pagamento para clientes afetados",
		scheduleGuideDeletionImportantTitle: "Considerações Importantes",
		scheduleGuideDeletionImportant1:
			"A exclusão de horário é permanente e não pode ser desfeita",
		scheduleGuideDeletionImportant2:
			"Todas as matrículas associadas serão removidas",
		scheduleGuideDeletionImportant3: "Sessões futuras serão canceladas",
		scheduleGuideDeletionImportant4:
			"Dados históricos de presença são preservados",
		scheduleGuideDeletionImportant5:
			"Considere desativar em vez de excluir para mudanças temporárias",
		scheduleGuideDeletionImagePlaceholder:
			"Placeholder de imagem: Captura de tela do modal de confirmação de exclusão de horário mostrando detalhes de impacto",

		// Schedule Details and Tabs
		scheduleGuideDetailsTabsTitle: "Visão Geral da Navegação por Abas",
		scheduleGuideDetailsTabsText:
			"A página de detalhes do horário apresenta uma interface com abas que fornece acesso a diferentes aspectos do gerenciamento de horários:",
		scheduleGuideDetailsEditTabTitle: "Aba Editar (Padrão)",
		scheduleGuideDetailsEditTabFeature1:
			"Modificar detalhes e configurações do horário",
		scheduleGuideDetailsEditTabFeature2:
			"Atualizar horário, capacidade e atribuições de funcionários",
		scheduleGuideDetailsEditTabFeature3: "Alterar descrições e notas",
		scheduleGuideDetailsEditTabFeature4:
			"Campos protegidos são claramente marcados",
		scheduleGuideDetailsSessionsTabTitle: "Aba Sessões",
		scheduleGuideDetailsSessionsTabFeature1:
			"Ver todas as sessões geradas para o horário",
		scheduleGuideDetailsSessionsTabFeature2:
			"Ver datas, horários e presença das sessões",
		scheduleGuideDetailsSessionsTabFeature3:
			"Acessar gerenciamento de presença para cada sessão",
		scheduleGuideDetailsSessionsTabFeature4:
			"Monitorar status e capacidade das sessões",
		scheduleGuideDetailsEnrollmentsTabTitle: "Aba Matrículas",
		scheduleGuideDetailsEnrollmentsTabFeature1:
			"Ver todos os clientes matriculados neste horário",
		scheduleGuideDetailsEnrollmentsTabFeature2:
			"Ver detalhes e status das matrículas",
		scheduleGuideDetailsEnrollmentsTabFeature3:
			"Monitorar capacidade e disponibilidade de matrículas",
		scheduleGuideDetailsEnrollmentsTabFeature4:
			"Acessar informações e histórico dos clientes",
		scheduleGuideDetailsMigrateTabTitle: "Aba Migrar Matrículas",
		scheduleGuideDetailsMigrateTabFeature1:
			"Mover clientes matriculados para outros horários",
		scheduleGuideDetailsMigrateTabFeature2:
			"Validar compatibilidade de migração",
		scheduleGuideDetailsMigrateTabFeature3:
			"Lidar com mudanças e fechamentos de horários",
		scheduleGuideDetailsMigrateTabFeature4:
			"Preservar histórico de matrículas dos clientes",
		scheduleGuideDetailsSessionsTitle: "Gerenciamento de Sessões",
		scheduleGuideDetailsSessionsText:
			"A aba Sessões fornece uma visão abrangente de todas as sessões individuais geradas do seu horário:",
		scheduleGuideDetailsSessionsInfoTitle: "Informações da Sessão Exibidas",
		scheduleGuideDetailsSessionsInfo1:
			"Data e Horário: Data da sessão com horários de início e término",
		scheduleGuideDetailsSessionsInfo2:
			"Nome da Sessão: Herdado do horário com descrição opcional",
		scheduleGuideDetailsSessionsInfo3:
			"Tipo: Indicador de sessão em Grupo ou Individual com informações de capacidade",
		scheduleGuideDetailsSessionsInfo4:
			"Status: Badges de status Ativo, Inativo ou Cancelado",
		scheduleGuideDetailsSessionsInfo5:
			"Presença: Contagem atual de matrículas vs. capacidade",
		scheduleGuideDetailsSessionsInfo6:
			"Ações: Link direto para gerenciamento de presença para cada sessão",
		scheduleGuideDetailsEnrollmentsTitle: "Visão Geral das Matrículas",
		scheduleGuideDetailsEnrollmentsText:
			"A aba Matrículas mostra todos os clientes atualmente matriculados no horário:",
		scheduleGuideDetailsEnrollmentsDetailsTitle: "Detalhes da Matrícula",
		scheduleGuideDetailsEnrollmentsDetail1:
			"Informações do Cliente: Nomes, detalhes de contato e status da matrícula",
		scheduleGuideDetailsEnrollmentsDetail2:
			"Datas de Matrícula: Datas de início e término para cada matrícula",
		scheduleGuideDetailsEnrollmentsDetail3:
			"Informações do Plano: Planos de clientes associados e detalhes de cobrança",
		scheduleGuideDetailsEnrollmentsDetail4:
			"Histórico de Presença: Links para registros de presença individuais dos clientes",
		scheduleGuideDetailsImagePlaceholder:
			"Placeholder de imagem: Captura de tela da página de detalhes do horário mostrando todas as quatro abas e seu conteúdo",

		// Migration System
		scheduleGuideMigrationWhenTitle: "Quando Usar Migração",
		scheduleGuideMigrationWhen1:
			"Fechamento de Horário: Mover clientes antes de excluir um horário",
		scheduleGuideMigrationWhen2:
			"Mudanças de Instrutor: Transferir clientes para o horário de um novo instrutor",
		scheduleGuideMigrationWhen3:
			"Mudanças de Horário: Mover clientes quando horários conflitam com sua disponibilidade",
		scheduleGuideMigrationWhen4:
			"Problemas de Capacidade: Redistribuir clientes ao reduzir capacidade do horário",
		scheduleGuideMigrationWhen5:
			"Mudanças de Local: Mover clientes para diferentes locais de unidade",
		scheduleGuideMigrationProcessTitle: "Visão Geral do Processo de Migração",
		scheduleGuideMigrationProcessStep1:
			'Acessar Migração: Clique na aba "Migrar Matrículas" nos detalhes do horário',
		scheduleGuideMigrationProcessStep2:
			"Revisar Origem: Ver informações do horário atual e clientes matriculados",
		scheduleGuideMigrationProcessStep3:
			"Definir Destino Padrão: Escolher um horário de destino padrão para todos os clientes",
		scheduleGuideMigrationProcessStep4:
			"Personalizar Destinos Individuais: Opcionalmente selecionar horários diferentes para clientes específicos",
		scheduleGuideMigrationProcessStep5:
			"Validar Migrações: Executar validação para verificar conflitos e compatibilidade",
		scheduleGuideMigrationProcessStep6:
			"Revisar Resultados: Resolver quaisquer erros ou avisos antes de prosseguir",
		scheduleGuideMigrationProcessStep7:
			"Executar Migração: Completar a transferência de todas as matrículas",
		scheduleGuideMigrationFeaturesTitle: "Recursos de Migração",
		scheduleGuideMigrationFeature1Title: "Seleção de Destino Padrão",
		scheduleGuideMigrationFeature1Text:
			"Definir um horário de destino padrão que se aplica a todos os clientes, com a opção de personalizar atribuições individuais.",
		scheduleGuideMigrationFeature2Title: "Personalização Individual",
		scheduleGuideMigrationFeature2Text:
			"Cada cliente pode ser atribuído a um horário de destino diferente baseado em suas necessidades ou preferências específicas.",
		scheduleGuideMigrationFeature3Title: "Sistema de Validação",
		scheduleGuideMigrationFeature3Text:
			"Verificações abrangentes de validação para conflitos de horário, limites de capacidade e problemas de compatibilidade.",
		scheduleGuideMigrationFeature4Title: "Processamento em Lote",
		scheduleGuideMigrationFeature4Text:
			"Todas as migrações são processadas juntas para garantir consistência e prevenir falhas parciais.",
		scheduleGuideMigrationValidationTitle: "Validação e Tratamento de Erros",
		scheduleGuideMigrationErrorTitle: "Condições de Erro (Deve Corrigir)",
		scheduleGuideMigrationError1:
			"Capacidade do horário de destino seria excedida",
		scheduleGuideMigrationError2:
			"Restrições do plano do cliente não permitem horário de destino",
		scheduleGuideMigrationError3:
			"Conflitos de horário com outras matrículas do cliente",
		scheduleGuideMigrationError4: "Horário de destino está inativo ou excluído",
		scheduleGuideMigrationWarningTitle: "Condições de Aviso (Pode Prosseguir)",
		scheduleGuideMigrationWarning1: "Instrutor diferente do horário original",
		scheduleGuideMigrationWarning2: "Local de unidade diferente",
		scheduleGuideMigrationWarning3: "Número diferente de sessões semanais",
		scheduleGuideMigrationWarning4:
			"Mudanças de horário que podem afetar a disponibilidade do cliente",
		scheduleGuideMigrationWorkflowTitle: "Fluxo de Trabalho de Migração",
		scheduleGuideMigrationWorkflowSubtitle: "Processo Passo a Passo",
		scheduleGuideMigrationWorkflowStep1:
			"Revisão da Origem: Ver detalhes do horário atual e clientes matriculados",
		scheduleGuideMigrationWorkflowStep2:
			"Seleção de Destino: Escolher horários de destino com exibição de informações detalhadas",
		scheduleGuideMigrationWorkflowStep3:
			"Validação: Executar verificações abrangentes para todas as migrações propostas",
		scheduleGuideMigrationWorkflowStep4:
			"Resolução de Erros: Corrigir quaisquer erros bloqueantes antes de prosseguir",
		scheduleGuideMigrationWorkflowStep5:
			"Confirmação: Revisar todas as mudanças e avisos",
		scheduleGuideMigrationWorkflowStep6:
			"Execução: Completar a migração com rollback automático em caso de falha",
		scheduleGuideMigrationImagePlaceholder:
			"Placeholder de imagem: Captura de tela da interface de migração mostrando horário de origem, seleção de destino e resultados de validação",

		enrollmentProcess: "Processo de Matrícula",
		enrollmentProcessDescription: "Matricule clientes em aulas e planos",
		attendanceTracking: "Acompanhamento de Presença",
		attendanceTrackingDescription: "Monitore e gerencie a presença nas aulas",
		paymentProcessing: "Processamento de Pagamentos",
		paymentProcessingDescription: "Gerencie cobrança e coleta de pagamentos",
		reportsAnalytics: "Relatórios e Análises",
		reportsAnalyticsDescription: "Gere insights e relatórios de negócios",
		systemSettings: "Configurações do Sistema",
		systemSettingsDescription: "Configure preferências da aplicação",
		supportTitle: "Contatar Suporte",
		supportDescription:
			"Obtenha ajuda da nossa equipe de suporte enviando uma solicitação de suporte",
		supportFormTitle: "Formulário de Solicitação de Suporte",
		supportFieldTitle: "Assunto",
		supportFieldDescription: "Descrição",
		supportPlaceholderTitle: "Breve descrição do seu problema ou pergunta",
		supportPlaceholderDescription:
			"Por favor, forneça informações detalhadas sobre seu problema, incluindo passos para reproduzir se aplicável",
		supportHintTitle:
			"Forneça um assunto claro e conciso para sua solicitação de suporte",
		supportHintDescription:
			"Inclua o máximo de detalhes possível para nos ajudar a atendê-lo rapidamente",
		supportCharacterCountTitle: "Assunto",
		supportCharacterCountDescription: "Descrição",
		supportSubmit: "Enviar Solicitação de Suporte",
		supportSubmitting: "Enviando...",
		supportSubmitSuccess:
			"Solicitação de suporte enviada com sucesso! Entraremos em contato em breve.",
		supportSubmitError:
			"Falha ao enviar solicitação de suporte. Tente novamente.",
		supportInfo: "Nossa equipe de suporte responderá sua solicitaçã em breve.",

		// Support form type field
		supportFieldType: "Tipo",
		supportPlaceholderType: "Selecione o tipo da sua solicitação",
		supportHintType: "Escolha a categoria que melhor descreve sua solicitação",
		supportTypeRequest: "Solicitação",
		supportTypeSuggestion: "Sugestão",
		supportTypeComplaint: "Reclamação",

		// Support ticket management
		commentSubmitting: "Adicionando comentário...",
		commentSubmitSuccess: "Comentário adicionado com sucesso!",
		commentSubmitError: "Falha ao adicionar comentário. Tente novamente.",
		ticketDeleting: "Excluindo ticket de suporte...",
		ticketDeleteSuccess: "Ticket de suporte excluído com sucesso!",
		ticketDeleteError: "Falha ao excluir ticket de suporte. Tente novamente.",

		// Ticket status actions
		ticketCanceling: "Cancelando ticket...",
		ticketCancelSuccess: "Ticket cancelado com sucesso!",
		ticketCancelError: "Falha ao cancelar ticket. Tente novamente.",
		ticketResolving: "Resolvendo ticket...",
		ticketResolveSuccess: "Ticket resolvido com sucesso!",
		ticketResolveError: "Falha ao resolver ticket. Tente novamente.",
		ticketReopening: "Reabrindo ticket...",
		ticketReopenSuccess: "Ticket reaberto com sucesso!",
		ticketReopenError: "Falha ao reabrir ticket. Tente novamente.",
		cancelTicket: "Cancelar Ticket",
		resolveTicket: "Marcar como Resolvido",
		reopenTicket: "Reabrir Ticket",
		cancelTicketConfirmTitle: "Cancelar Ticket de Suporte",
		cancelTicketConfirmDescription:
			"Tem certeza que deseja cancelar este ticket? Isso fechará o ticket sem resolução.",
		resolveTicketConfirmTitle: "Resolver Ticket de Suporte",
		resolveTicketConfirmDescription:
			"Tem certeza que deseja marcar este ticket como resolvido? Isso indica que seu problema foi resolvido.",

		// Support ticket statuses
		statusOpen: "Aberto",
		statusWaitingForUser: "Aguardando Usuário",
		statusWaitingForStaff: "Aguardando Suporte",
		statusResolved: "Resolvido",
		statusClosed: "Fechado",

		// Support tickets list
		myTicketsDescription: "Você tem {{count}} solicitações de suporte",
		noTickets: "Nenhuma Solicitação de Suporte",
		noTicketsDescription:
			"Você ainda não enviou nenhuma solicitação de suporte. Crie sua primeira solicitação para obter ajuda da nossa equipe de suporte.",

		// Support ticket details
		ticketDetails: "Detalhes da Solicitação",
		ticketInformation: "Informações da Solicitação",
		comments: "Comentários",
		noComments: "Nenhum comentário ainda",
		addComment: "Adicionar Comentário",
		commentPlaceholder: "Escreva seu comentário aqui...",
		you: "Você",
		supportTeam: "Equipe de Suporte",
		staff: "Equipe",

		// Attendance Tracking Page
		attendanceOverview: "Visão Geral",
		attendanceOverviewDescription:
			"O acompanhamento de presença é o centro de monitoramento e gerenciamento da presença em sessões em todo o seu estúdio. Ele fornece visualizações de calendário e lista de todas as sessões, opções abrangentes de filtragem e recursos detalhados de gerenciamento de sessões. O sistema permite acompanhar a presença dos clientes, gerenciar a capacidade das sessões e manter registros precisos para relatórios e cobrança.",
		attendanceKeyFeatures: "Recursos Principais",
		attendanceKeyFeature1:
			"Modos de visualização duplos: Calendário interativo e visualizações detalhadas em lista",
		attendanceKeyFeature2:
			"Filtragem avançada por instrutor, unidade, intervalo de datas e status",
		attendanceKeyFeature3:
			"Gerenciamento de presença em tempo real com múltiplas opções de status",
		attendanceKeyFeature4:
			"Monitoramento de capacidade de sessão e acompanhamento de matrículas",
		attendanceKeyFeature5:
			"Adição de clientes para aulas experimentais e reposições",

		attendanceAccessing: "Acessando o Acompanhamento de Presença",
		attendanceAccessingDescription:
			"Para acessar a seção de acompanhamento de presença:",
		attendanceAccessingStep1: "Navegue até o painel da sua organização",
		attendanceAccessingStep2:
			'Clique em "Presença" no menu de navegação principal',
		attendanceAccessingStep3:
			"Você verá a visão geral de presença com visualização de calendário como padrão",
		attendanceAccessingStep4:
			"Use o botão de alternância para alternar entre os modos calendário e lista",
		attendancePermissionRequirements: "Requisitos de Permissão",
		attendancePermissionDescription:
			'Você precisa da permissão "VIEW_ATTENDANCE" para ver dados de presença e "MANAGE_ATTENDANCE" para modificar registros de presença. Essas permissões são específicas da unidade, então você só verá sessões das unidades aos quais tem acesso.',
		attendanceImagePlaceholder1:
			"Placeholder de imagem: Captura de tela da página principal de acompanhamento de presença mostrando opções de visualização de calendário e lista",

		attendanceViewModes: "Modos de Visualização",
		attendanceViewModesDescription:
			"O sistema de acompanhamento de presença oferece dois modos de visualização distintos, cada um otimizado para diferentes casos de uso:",
		attendanceCalendarView: "Visualização de Calendário",
		attendanceCalendarViewTitle: "Interface de Calendário Interativo",
		attendanceCalendarFeature1:
			"Visualização Semanal: Cronograma semanal detalhado com horários e detalhes da sessão",
		attendanceCalendarFeature2:
			"Visualização Mensal: Visão geral mensal mostrando todas as sessões de relance",
		attendanceCalendarFeature3:
			"Sessões Codificadas por Cores: Cada instrutor tem uma cor única para fácil identificação",
		attendanceCalendarFeature4:
			"Informações da Sessão: Passe o mouse ou clique para ver detalhes da sessão, capacidade e presença",
		attendanceCalendarFeature5:
			"Controles de Navegação: Navegação fácil entre semanas/meses com botão hoje",

		attendanceListView: "Visualização em Lista",
		attendanceListViewTitle: "Listagens Detalhadas de Sessões",
		attendanceListFeature1:
			"Formato de Tabela: Tabela abrangente com colunas classificáveis",
		attendanceListFeature2:
			"Formato de Cartão: Layout visual de cartão com destaques da sessão",
		attendanceListFeature3:
			"Informações Detalhadas: Data, hora, instrutor, localização, capacidade e status",
		attendanceListFeature4:
			"Opções de Classificação: Classificar por data, nome da sessão, instrutor ou presença",
		attendanceListFeature5:
			"Paginação: Manuseio eficiente de listas grandes de sessões",

		attendanceViewModeSelection: "Seleção de Modo de Visualização",
		attendanceViewModeFeature1:
			"Botões de Alternância: Alternância fácil entre visualizações de calendário e lista",
		attendanceViewModeFeature2:
			"Seleção Persistente: Seu modo de visualização preferido é lembrado",
		attendanceViewModeFeature3:
			"Apropriado ao Contexto: Calendário para visão geral de agendamento, lista para gerenciamento detalhado",
		attendanceViewModeFeature4:
			"Design Responsivo: Ambas as visualizações se adaptam a diferentes tamanhos de tela",
		attendanceImagePlaceholder2:
			"Placeholder de imagem: Comparação lado a lado das interfaces de visualização de calendário e lista",

		attendanceFiltering: "Filtragem e Pesquisa",
		attendanceFilteringDescription:
			"Opções poderosas de filtragem ajudam você a encontrar sessões específicas e focar em dados relevantes:",
		attendanceInstructorFilter: "Filtro de Instrutor",
		attendanceInstructorFilterTitle: "Filtragem Multi-Seleção de Instrutor",
		attendanceInstructorFeature1:
			"Multi-Seleção: Selecione múltiplos instrutores simultaneamente",
		attendanceInstructorFeature2:
			"Indicadores de Cor: Cada instrutor tem uma cor única para identificação visual",
		attendanceInstructorFeature3:
			"Selecionar Todos/Desselecionar Todos: Opções rápidas para seleção em massa",
		attendanceInstructorFeature4:
			"Exibição de Contagem Selecionada: Mostra quantos instrutores estão atualmente selecionados",
		attendanceInstructorFeature5:
			"Filtragem em Tempo Real: Sessões são atualizadas imediatamente conforme você altera as seleções",

		attendanceAdvancedFilters: "Filtros Avançados",
		attendanceAdvancedFiltersTitle: "Opções Abrangentes de Filtro",
		attendanceAdvancedFeature1:
			"Intervalo de Datas: Filtrar sessões por datas de início e fim",
		attendanceAdvancedFeature2:
			"Unidade: Mostrar sessões apenas de localizações específicas",
		attendanceAdvancedFeature3:
			"Tipo de Cronograma: Filtrar por sessões em grupo ou sessões individuais",
		attendanceAdvancedFeature4:
			"Status da Sessão: Sessões ativas, canceladas ou todas as sessões",
		attendanceAdvancedFeature5:
			"Membro da Equipe: Filtrar por atribuições específicas de instrutor",

		attendanceFilterManagement: "Gerenciamento de Filtros",
		attendanceFilterFeature1:
			"Diálogo de Filtro: Modal dedicado para definir múltiplos filtros",
		attendanceFilterFeature2:
			"Contagem de Filtros Ativos: Indicador visual mostrando número de filtros ativos",
		attendanceFilterFeature3:
			"Redefinir Filtros: Opção rápida para limpar todos os filtros e retornar aos padrões",
		attendanceFilterFeature4:
			"Aplicar/Cancelar: Visualizar alterações de filtro antes de aplicá-las",
		attendanceImagePlaceholder3:
			"Placeholder de imagem: Captura de tela do diálogo de filtro mostrando todas as opções de filtro disponíveis",

		attendanceSessionDetails: "Detalhes e Gerenciamento de Sessões",
		attendanceSessionDetailsDescription:
			"Clicar em qualquer sessão abre a interface detalhada de gerenciamento de sessões onde você pode visualizar informações abrangentes da sessão e gerenciar a presença:",
		attendanceSessionInformation: "Exibição de Informações da Sessão",
		attendanceSessionInformationTitle: "Detalhes Abrangentes da Sessão",
		attendanceSessionInfoFeature1:
			"Data e Hora: Data da sessão com horários de início e fim formatados",
		attendanceSessionInfoFeature2:
			"Informações do Instrutor: Nome do membro da equipe com indicador codificado por cores",
		attendanceSessionInfoFeature3:
			"Detalhes da Localização: Nome da unidade e informações de localização",
		attendanceSessionInfoFeature4:
			"Informações de Capacidade: Matrícula atual vs. capacidade máxima",
		attendanceSessionInfoFeature5:
			"Descrição da Sessão: Detalhes adicionais sobre o conteúdo da sessão",
		attendanceSessionInfoFeature6:
			"Notas: Instruções especiais ou requisitos para a sessão",

		attendanceListManagement: "Gerenciamento de Lista de Presença",
		attendanceListManagementTitle: "Acompanhamento de Presença em Tempo Real",
		attendanceListManagementFeature1:
			"Lista de Clientes: Todos os clientes matriculados com seu status de presença",
		attendanceListManagementFeature2:
			"Gerenciamento de Status: Alterar status de presença com seletores dropdown",
		attendanceListManagementFeature3:
			"Atualizações em Tempo Real: Alterações são salvas imediatamente e refletidas em todo o sistema",
		attendanceListManagementFeature4:
			"Indicadores Visuais: Ícones de status codificados por cores para identificação rápida",
		attendanceListManagementFeature5:
			"Informações do Cliente: Nomes completos e detalhes de identificação",

		attendanceAddingCustomers: "Adicionando Clientes às Sessões",
		attendanceAddingCustomersTitle: "Adição de Clientes para Casos Especiais",
		attendanceAddingFeature1:
			"Botão Adicionar Cliente: Acesso rápido para adicionar clientes à sessão",
		attendanceAddingFeature2:
			"Pesquisa de Cliente: Pesquisar por nome ou número de documento para encontrar clientes",
		attendanceAddingFeature3:
			"Seleção Múltipla: Adicionar múltiplos clientes simultaneamente",
		attendanceAddingFeature4:
			"Atribuição de Status: Definir status inicial de presença para cada cliente adicionado",
		attendanceAddingFeature5:
			"Documentação de Motivo: Registrar por que clientes foram adicionados (experimental, reposição, etc.)",

		attendanceStatusIndicators: "Indicadores de Status da Sessão",
		attendanceCapacityStatus: "Status de Capacidade",
		attendanceCapacityAvailable: "Disponível: Sessão tem vagas abertas",
		attendanceCapacityAlmostFull:
			"Quase Lotada: Próximo da capacidade (80%+ preenchida)",
		attendanceCapacityFull: "Lotada: Na capacidade máxima",
		attendanceSessionStatus: "Status da Sessão",
		attendanceSessionActive: "Ativa: Sessão está funcionando normalmente",
		attendanceSessionCanceled: "Cancelada: Sessão foi cancelada",
		attendanceSessionInactive:
			"Inativa: Sessão está temporariamente desabilitada",
		attendanceImagePlaceholder4:
			"Placeholder de imagem: Captura de tela da página de detalhes da sessão mostrando informações da sessão e lista de presença",

		attendanceStatusManagement: "Gerenciamento de Status de Presença",
		attendanceStatusManagementDescription:
			"O sistema fornece múltiplas opções de status de presença para acompanhar com precisão diferentes tipos de participação do cliente:",
		attendanceAvailableStatuses: "Status de Presença Disponíveis",
		attendanceStatusConfirmed: "Confirmado",
		attendanceStatusConfirmedDescription:
			"Cliente compareceu à sessão conforme planejado. Este é o status padrão para presença regular.",
		attendanceStatusTrial: "Experimental",
		attendanceStatusTrialDescription:
			"Cliente compareceu como uma sessão experimental. Usado para clientes em potencial experimentando o estúdio antes da matrícula.",
		attendanceStatusReposition: "Reposição",
		attendanceStatusRepositionDescription:
			"Cliente compareceu a esta sessão como compensação por uma sessão perdida. Usado para mudanças de cronograma e aulas de reposição.",
		attendanceStatusCanceled: "Cancelado",
		attendanceStatusCanceledDescription:
			"Cliente não compareceu à sessão. Usado para faltas, cancelamentos ou ausências.",

		attendanceStatusChangeProcess: "Processo de Alteração de Status",
		attendanceStatusChangeStep1: "Navegue até a página de detalhes da sessão",
		attendanceStatusChangeStep2: "Localize o cliente na lista de presença",
		attendanceStatusChangeStep3:
			"Clique no dropdown de status ao lado do nome dele",
		attendanceStatusChangeStep4: "Selecione o novo status apropriado",
		attendanceStatusChangeStep5:
			"A alteração é salva automaticamente e imediatamente refletida",

		attendanceStatusChangeImplications: "Implicações da Alteração de Status",
		attendanceStatusImplication1:
			"Impacto na Cobrança: Diferentes status podem afetar a cobrança e processamento de pagamentos",
		attendanceStatusImplication2:
			"Relatórios: Alterações de status são refletidas em relatórios de presença e análises",
		attendanceStatusImplication3:
			"Gerenciamento de Capacidade: Presença cancelada pode liberar vagas para outros clientes",
		attendanceStatusImplication4:
			"Histórico do Cliente: Todas as alterações de status são rastreadas no histórico de presença do cliente",

		attendanceBulkStatusManagement: "Gerenciamento de Status em Massa",
		attendanceBulkStatusTitle: "Atualizações Eficientes de Status",
		attendanceBulkFeature1:
			"Atualizações Individuais: Alterar status para cada cliente individualmente",
		attendanceBulkFeature2:
			"Salvamento em Tempo Real: Alterações são salvas imediatamente sem envio de formulário",
		attendanceBulkFeature3:
			"Feedback Visual: Indicadores de carregamento durante atualizações de status",
		attendanceBulkFeature4:
			"Tratamento de Erros: Mensagens de erro claras se as alterações de status falharem",
		attendanceImagePlaceholder5:
			"Placeholder de imagem: Captura de tela mostrando as opções de dropdown de status de presença e indicadores de status codificados por cores",

		// Customer Management Page
		customerOverview: "Visão Geral",
		customerOverviewDescription:
			"O gerenciamento de clientes é a base das operações do seu estúdio de Pilates. Este sistema abrangente permite manter perfis detalhados de clientes, acompanhar seu progresso, gerenciar registros médicos e lidar com matrículas de forma eficiente.",
		customerKeyBenefits: "Principais Benefícios",
		customerBenefit1: "Gerenciamento centralizado de informações do cliente",
		customerBenefit2: "Acompanhamento abrangente do histórico médico",
		customerBenefit3: "Processos de matrícula simplificados",
		customerBenefit4: "Recursos avançados de pesquisa e filtragem",

		customerAccessing: "Acessando o Gerenciamento de Clientes",
		customerAccessingDescription:
			"Para acessar a seção de gerenciamento de clientes:",
		customerAccessingStep1: "Navegue até o painel da sua organização",
		customerAccessingStep2:
			'Clique em "Clientes" no menu de navegação principal',
		customerAccessingStep3:
			"Você verá a lista de clientes com opções de pesquisa e filtragem",
		customerImagePlaceholder1:
			"Placeholder de imagem: Captura de tela da navegação principal mostrando o item de menu Clientes",

		customerListOverview: "Visão Geral da Lista de Clientes",
		customerListDescription:
			"A lista de clientes fornece uma visão abrangente de todos os seus clientes com os seguintes recursos:",
		customerSearchFilter: "Pesquisa e Filtro",
		customerSearchFeature1:
			"Pesquisa em tempo real por nome, email ou telefone",
		customerSearchFeature2: "Pesquisa com atraso (500ms) para performance",
		customerSearchFeature3:
			"Resultados de pesquisa atualizados automaticamente",
		customerPagination: "Paginação",
		customerPaginationFeature1:
			"Tamanhos de página configuráveis (10, 25, 50, 100)",
		customerPaginationFeature2: "Navegação entre páginas",
		customerPaginationFeature3: "Exibição de contagem total",
		customerImagePlaceholder2:
			"Placeholder de imagem: Captura de tela da lista de clientes mostrando barra de pesquisa, paginação e tabela de clientes",

		customerAddingNew: "Adicionando Novos Clientes",
		customerAddingDescription:
			"Criar um novo perfil de cliente é direto e abrangente:",
		customerStep1: "Passo 1: Acessar o Formulário de Criação",
		customerStep1Detail1:
			'Clique no botão "Adicionar Cliente" (ícone +) na lista de clientes',
		customerStep1Detail2:
			"Você será redirecionado para o formulário de registro de cliente",
		customerStep2: "Passo 2: Preencher Informações Obrigatórias",
		customerBasicInfo: "Informações Básicas",
		customerBasicInfo1: "Nome (obrigatório)",
		customerBasicInfo2: "Sobrenome (obrigatório)",
		customerBasicInfo3: "Endereço de email",
		customerBasicInfo4: "Número de telefone",
		customerBasicInfo5: "Data de nascimento",
		customerBasicInfo6: "Gênero",
		customerIdentification: "Identificação",
		customerIdentification1: "Tipo de ID (CPF, RG, Passaporte, etc.)",
		customerIdentification2: "Número do ID",
		customerIdentification3: "Validação de CPF (ID fiscal brasileiro)",
		customerStep3: "Passo 3: Informações de Endereço",
		customerSmartAddressLookup: "Busca Inteligente de Endereço",
		customerSmartAddressDescription:
			"Digite um código postal brasileiro válido (CEP) e o sistema preencherá automaticamente os detalhes do endereço incluindo rua, bairro, cidade e estado.",
		customerAddressField1: "Código Postal (CEP) - aciona busca automática",
		customerAddressField2: "Endereço da Rua",
		customerAddressField3: "Número do Endereço",
		customerAddressField4: "Complemento (apartamento, suíte, etc.)",
		customerAddressField5: "Bairro",
		customerAddressField6: "Cidade e Estado (preenchido automaticamente)",
		customerStep4: "Passo 4: Informações Adicionais",
		customerAdditionalInfo1: "Nome e telefone do contato de emergência",
		customerAdditionalInfo2: "Notas (qualquer informação adicional)",
		customerAdditionalInfo3: "Status do cliente (Ativo/Inativo)",
		customerImagePlaceholder3:
			"Placeholder de imagem: Captura de tela do formulário de registro de cliente mostrando todas as seções",

		customerSearching: "Pesquisando e Encontrando Clientes",
		customerSearchingDescription:
			"A funcionalidade de pesquisa foi projetada para ajudá-lo a encontrar clientes rapidamente:",
		customerSearchCapabilities: "Capacidades de Pesquisa",
		customerSearchCapability1:
			"Pesquisa por Nome: Pesquisar por nome, sobrenome ou nome completo",
		customerSearchCapability2:
			"Pesquisa por Email: Encontrar clientes pelo endereço de email",
		customerSearchCapability3:
			"Pesquisa por Telefone: Pesquisar usando números de telefone",
		customerSearchCapability4:
			"Correspondência Parcial: Resultados aparecem conforme você digita",
		customerSearchCapability5:
			"Insensível a Maiúsculas: Pesquisa funciona independentemente da capitalização",
		customerSearchTips: "Dicas de Pesquisa",
		customerProTips: "Dicas Profissionais",
		customerSearchTip1: "Use nomes parciais para resultados mais amplos",
		customerSearchTip2: "Pesquisa redefine paginação para página 1",
		customerSearchTip3: "Limpe a pesquisa para ver todos os clientes",
		customerSearchTip4:
			"Pesquisa tem atraso de 500ms para melhorar performance",
		customerImagePlaceholder4:
			"Placeholder de imagem: Captura de tela mostrando a barra de pesquisa com exemplos de resultados de pesquisa",

		customerEditing: "Editando Informações do Cliente",
		customerEditingDescription:
			"As informações do cliente podem ser atualizadas a qualquer momento através da interface de edição:",
		customerAccessingEditMode: "Acessando o Modo de Edição",
		customerEditStep1:
			"Clique em qualquer linha de cliente na lista de clientes",
		customerEditStep2: "Você será levado à página de detalhes do cliente",
		customerEditStep3: "A página abre no modo de edição por padrão",
		customerEditStep4:
			"Todos os campos são editáveis e seguem as mesmas regras de validação da criação",
		customerEditFeatures: "Recursos de Edição",
		customerEditFeature1:
			"Todas as informações do cliente podem ser modificadas",
		customerEditFeature2:
			"Busca de endereço ainda funciona ao alterar códigos postais",
		customerEditFeature3:
			"Validação de formulário garante integridade dos dados",
		customerEditFeature4: "Alterações são salvas imediatamente após envio",
		customerEditFeature5: "Mensagens de sucesso/erro fornecem feedback",
		customerPermissionRequirements: "Requisitos de Permissão",
		customerPermissionDescription:
			'Você precisa da permissão "MANAGE_CUSTOMERS" para editar informações do cliente. Usuários com acesso somente leitura podem ver detalhes do cliente mas não podem fazer alterações.',
		customerImagePlaceholder5:
			"Placeholder de imagem: Captura de tela do formulário de edição de cliente com campos editáveis destacados",

		customerDetailsNavigation: "Detalhes e Navegação do Cliente",
		customerDetailsDescription:
			"A página de detalhes do cliente fornece informações abrangentes organizadas em abas:",
		customerAvailableTabs: "Abas Disponíveis",
		customerProfileTab: "Aba Perfil (Padrão)",
		customerProfileTabDescription:
			"Editar informações pessoais, detalhes de contato e endereço do cliente",
		customerMedicalRecordsTab: "Aba Registros Médicos",
		customerMedicalRecordsTabDescription:
			"Visualizar e gerenciar histórico médico abrangente e registros de saúde",
		customerEnrollmentsTab: "Aba Matrículas",
		customerEnrollmentsTabDescription:
			"Visualizar matrículas atuais e passadas em aulas e programas",
		customerPaymentsTab: "Aba Pagamentos",
		customerPaymentsTabDescription:
			"Acompanhar histórico de pagamentos e gerenciar informações de cobrança",
		customerImagePlaceholder6:
			"Placeholder de imagem: Captura de tela da página de detalhes do cliente mostrando navegação por abas",

		customerMedicalRecordsManagement: "Gerenciamento de Registros Médicos",
		customerMedicalRecordsDescription:
			"O gerenciamento abrangente de registros médicos ajuda você a manter informações detalhadas de saúde para cada cliente:",
		customerRecordTypesAvailable: "Tipos de Registros Disponíveis",
		customerAnamnesis: "Anamnese",
		customerAnamnesisDescription:
			"Histórico abrangente do paciente incluindo antecedentes médicos, medicamentos e fatores de estilo de vida",
		customerPhysicalEvaluation: "Avaliação Física",
		customerPhysicalEvaluationDescription:
			"Avaliações físicas iniciais e medições de linha de base",
		customerPeriodicEvaluation: "Avaliação Periódica",
		customerPeriodicEvaluationDescription:
			"Avaliações regulares de progresso e atualizações",
		customerTreatmentPlans: "Planos de Tratamento",
		customerTreatmentPlansDescription:
			"Protocolos de tratamento detalhados e estratégias de intervenção",
		customerAddingMedicalRecords: "Adicionando Registros Médicos",
		customerMedicalStep1: "Navegue até a aba Registros Médicos do cliente",
		customerMedicalStep2: 'Clique no botão "Adicionar Registro"',
		customerMedicalStep3: "Selecione o tipo de registro apropriado",
		customerMedicalStep4:
			"Preencha os detalhes do registro incluindo título e descrição",
		customerMedicalStep5:
			"Adicione informações médicas específicas baseadas no tipo de registro",
		customerMedicalStep6: "Salve o registro",
		customerViewingManagingRecords: "Visualizando e Gerenciando Registros",
		customerMedicalFeature1:
			"Visualizar informações detalhadas do registro em diálogos modais",
		customerMedicalFeature2:
			"Editar registros existentes para atualizar informações",
		customerMedicalFeature3:
			"Excluir registros quando não forem mais necessários",
		customerMedicalFeature4: "Registros são organizados cronologicamente",
		customerMedicalFeature5:
			"Capacidades de pesquisa e filtro para grandes conjuntos de registros",
		customerImagePlaceholder7:
			"Placeholder de imagem: Captura de tela da aba de registros médicos mostrando lista de registros e modal de adicionar registro",

		customerDeletion: "Exclusão de Cliente",
		customerDeletionDescription:
			"A exclusão de cliente é uma operação sensível que requer permissões adequadas e confirmação:",
		customerDeletionProcess: "Processo de Exclusão",
		customerDeletionStep1: "Localize o cliente na lista de clientes",
		customerDeletionStep2:
			"Clique no botão excluir (ícone de lixeira) na coluna Ações",
		customerDeletionStep3: "Confirme a exclusão no diálogo de confirmação",
		customerDeletionStep4: "O cliente será permanentemente removido do sistema",
		customerImportantConsiderations: "Considerações Importantes",
		customerDeletionWarning1:
			"A exclusão do cliente é permanente e não pode ser desfeita",
		customerDeletionWarning2:
			"Todos os dados associados (registros médicos, matrículas) serão removidos",
		customerDeletionWarning3: 'Requer permissão "MANAGE_CUSTOMERS"',
		customerDeletionWarning4:
			"Considere desativar em vez de excluir para retenção de dados",

		// Customer Plans Page
		customerPlansOverview: "Visão Geral",
		customerPlansOverviewDescription:
			"Os planos de clientes são a base da sua estratégia de preços. Eles definem quais serviços você oferece, quanto cobra e quais recursos os clientes têm acesso. Os planos podem ser personalizados com diferentes ciclos de cobrança, limites de sessões e restrições da unidade.",
		customerPlansKeyFeatures: "Principais Recursos",
		customerPlansFeature1:
			"Preços flexíveis com múltiplos ciclos de cobrança (Mensal, Trimestral, Semestral, Anual)",
		customerPlansFeature2:
			"Limites de sessões para controlar uso e gerenciar capacidade",
		customerPlansFeature3:
			"Planos específicos da unidade para negócios com múltiplas localizações",
		customerPlansFeature4:
			"Descrições ricas de recursos para comunicar valor aos clientes",

		customerPlansAccessing: "Acessando Planos de Clientes",
		customerPlansAccessingDescription:
			"Para acessar a seção de gerenciamento de planos de clientes:",
		customerPlansAccessingStep1: "Navegue até o painel da sua organização",
		customerPlansAccessingStep2:
			'Clique em "Planos de Clientes" no menu de navegação principal',
		customerPlansAccessingStep3:
			"Você verá uma lista de todos os seus planos existentes ou um estado vazio se nenhum existir",
		customerPlansPermissionRequirements: "Requisitos de Permissão",
		customerPlansPermissionDescription:
			'Você precisa da permissão "VIEW_CUSTOMER_PLANS" para ver planos e "MANAGE_CUSTOMER_PLANS" para criar, editar ou excluir planos. Entre em contato com o administrador da sua organização se não vir essas opções.',
		customerPlansImagePlaceholder1:
			"Placeholder de imagem: Captura de tela da página de planos de clientes mostrando a navegação e lista de planos",

		customerPlanStructure: "Estrutura e Componentes do Plano",
		customerPlanStructureDescription:
			"Cada plano de cliente consiste em vários componentes-chave que definem seu valor e restrições:",
		customerPlanBasicInfo: "Informações Básicas",
		customerPlanName: "Nome do Plano",
		customerPlanNameDescription:
			'Nome claro e descritivo que os clientes verão (ex: "Premium Mensal", "Plano Estudante")',
		customerPlanDescription: "Descrição",
		customerPlanDescriptionText:
			"Explicação detalhada do que o plano inclui e para quem foi projetado",
		customerPlanStatus: "Status",
		customerPlanStatusDescription:
			"Planos ativos estão disponíveis para novas matrículas; planos inativos ficam ocultos",
		customerPlanServicesOffered: "Serviços Oferecidos",
		customerPlanServicesDescription:
			"Lista de recursos e benefícios incluídos no plano",
		customerPlanPricingBilling: "Preços e Cobrança",
		customerPlanPriceCurrency: "Preço e Moeda",
		customerPlanPriceCurrencyDescription:
			"Defina o preço em Real Brasileiro (BRL) ou Dólar Americano (USD)",
		customerPlanBillingCycle: "Ciclo de Cobrança",
		customerPlanBillingCycleDescription:
			"Escolha entre cobrança Mensal, Trimestral, Semestral ou Anual",
		customerPlanMonthlyAverage: "Exibição de Média Mensal",
		customerPlanMonthlyAverageDescription:
			"Para planos não mensais, o sistema mostra automaticamente o equivalente mensal",
		customerPlanSessionLimits: "Limites de Sessões",
		customerPlanSessionLimitsDescription:
			"Limite semanal opcional de sessões (1-20 sessões) para controlar uso",
		customerPlanEstablishmentAccess: "Acesso a Unidades",
		customerPlanAllEstablishments:
			"Todas as Unidades: O plano pode ser usado em qualquer unidade da sua organização",
		customerPlanSpecificEstablishments:
			"Unidades Específicos: Restringir uso do plano a localizações selecionadas",
		customerPlanMultiLocationSupport:
			"Suporte Multi-localização: Perfeito para negócios com múltiplos estúdios",
		customerPlansImagePlaceholder2:
			"Placeholder de imagem: Diagrama mostrando os diferentes componentes de um plano de cliente",

		customerPlansCreating: "Criando Novos Planos de Clientes",
		customerPlansCreatingDescription:
			"Criar um novo plano de cliente envolve várias etapas para garantir que todos os detalhes sejam configurados adequadamente:",
		customerPlansStep1: "Passo 1: Abrir o Diálogo de Criação",
		customerPlansStep1Detail1:
			'Clique no botão "Criar Novo Plano" (ícone +) na página de planos de clientes',
		customerPlansStep1Detail2:
			"Um diálogo de formulário abrangente será aberto com múltiplas seções",
		customerPlansStep1Detail3:
			"O formulário é organizado em seções lógicas para fácil preenchimento",
		customerPlansStep2: "Passo 2: Seção de Informações Básicas",
		customerPlansRequiredFields: "Campos Obrigatórios",
		customerPlansNameField:
			'Nome do Plano: Escolha um nome claro e descritivo (ex: "Premium Mensal", "Desconto Estudante")',
		customerPlansDescriptionField:
			"Descrição: Forneça informações detalhadas sobre o que o plano inclui",
		customerPlansTip:
			"Dica: Use nomes descritivos que comuniquem claramente o valor e público-alvo do plano.",
		customerPlansStep3: "Passo 3: Seção de Preços e Cobrança",
		customerPlansPricingConfiguration: "Configuração de Preços",
		customerPlansPriceField:
			"Preço: Digite o preço do plano (suporta valores decimais para preços precisos)",
		customerPlansCurrencyField:
			"Moeda: Escolha entre Real Brasileiro (BRL) ou Dólar Americano (USD)",
		customerPlansBillingCycleField:
			"Ciclo de Cobrança: Selecione Mensal, Trimestral, Semestral ou Anual",
		customerPlansSessionsLimitField:
			"Limite Semanal de Sessões: Limite opcional entre 1-20 sessões por semana",
		customerPlansMonthlyAverageNote:
			"Média Mensal: Para planos não mensais, o sistema calcula e exibe automaticamente o equivalente mensal para ajudar os clientes a entender o valor.",
		customerPlansStep4: "Passo 4: Seção de Serviços Oferecidos",
		customerPlansFeatureManagement: "Gerenciamento de Recursos",
		customerPlansAddFeatures:
			'Adicionar Recursos: Clique em "Adicionar Recurso" para incluir novos serviços ou benefícios',
		customerPlansRemoveFeatures:
			"Remover Recursos: Use o botão X para remover recursos indesejados",
		customerPlansMinimumRequirement:
			"Requisito Mínimo: Pelo menos um recurso é obrigatório",
		customerPlansExamples:
			'Exemplos: "Consulta com personal trainer", "Acesso a equipamentos premium", "Orientação nutricional"',
		customerPlansStep5: "Passo 5: Seção de Unidades",
		customerPlansLocationAccess: "Controle de Acesso a Localizações",
		customerPlansAllEstablishmentsOption:
			"Todas as Unidades: Deixe vazio para permitir uso em todas as localizações",
		customerPlansSpecificEstablishmentsOption:
			"Unidades Específicos: Selecione localizações particulares onde o plano pode ser usado",
		customerPlansMultiSelect:
			"Multi-seleção: Escolha múltiplos unidades usando caixas de seleção",
		customerPlansClearSelection:
			'Limpar Seleção: Use "Limpar Unidades" para remover todas as seleções',
		customerPlansStep6: "Passo 6: Seção de Status do Plano",
		customerPlansActivationControl: "Controle de Ativação",
		customerPlansActivePlans:
			"Planos Ativos: Disponíveis para novas matrículas de clientes",
		customerPlansInactivePlans:
			"Planos Inativos: Ocultos dos clientes mas matrículas existentes continuam",
		customerPlansDefault: "Padrão: Novos planos são ativos por padrão",
		customerPlansStep7: "Passo 7: Salvar o Plano",
		customerPlansSaveStep1: "Revise todas as informações para precisão",
		customerPlansSaveStep2:
			"Certifique-se de que todos os campos obrigatórios estão preenchidos",
		customerPlansSaveStep3: 'Clique em "Criar" para salvar o plano',
		customerPlansSaveStep4:
			"O plano aparecerá na sua lista de planos imediatamente",
		customerPlansImagePlaceholder3:
			"Placeholder de imagem: Captura de tela do diálogo de criação de plano de cliente mostrando todas as seções do formulário",

		customerPlansManaging: "Gerenciando Planos Existentes",
		customerPlansManagingDescription:
			"A lista de planos de clientes fornece uma visão abrangente de todos os seus planos com capacidades de gerenciamento:",
		customerPlanListOverview: "Visão Geral da Lista de Planos",
		customerPlanTableColumns: "Colunas da Tabela",
		customerPlanNameColumn:
			"Nome: Nome do plano com ícone de cartão de crédito",
		customerPlanDescriptionColumn: "Descrição: Descrição completa do plano",
		customerPlanPriceColumn:
			"Preço: Preço formatado com média mensal para planos não mensais",
		customerPlanBillingCycleColumn:
			"Ciclo de Cobrança: Mensal, Trimestral, Semestral ou Anual",
		customerPlanAdditionalInfo: "Informações Adicionais",
		customerPlanServicesColumn:
			"Serviços Oferecidos: Badges de recursos com ícones de estrela",
		customerPlanEstablishmentsColumn:
			'Unidades: Badges de localização ou "Todas as Unidades"',
		customerPlanSessionsColumn:
			'Máximo de Sessões Semanais: Limite de sessões ou "—" se ilimitado',
		customerPlanStatusColumn: "Status: Badge ativo (verde) ou inativo (cinza)",
		customerPlanAvailableActions: "Ações Disponíveis",
		customerPlanEditAction: "Editar Plano",
		customerPlanEditDescription:
			"Clique no botão editar (ícone de lápis) para modificar qualquer aspecto do plano. O mesmo formulário usado para criação abre com valores atuais pré-preenchidos.",
		customerPlanDeleteAction: "Excluir Plano",
		customerPlanDeleteDescription:
			"Clique no botão excluir (ícone de lixeira) para remover permanentemente o plano. Um diálogo de confirmação garante que você não exclua planos acidentalmente.",
		customerPlanDeletionRestrictions: "Restrições de Exclusão",
		customerPlanDeletionRestrictionsDescription:
			"Planos de clientes com matrículas ativas não podem ser excluídos até que todas as matrículas relacionadas sejam removidas. Considere desativar o plano em vez de excluir para prevenir novas matrículas preservando as existentes.",
		customerPlansImagePlaceholder4:
			"Placeholder de imagem: Captura de tela da lista de planos de clientes mostrando diferentes tipos de planos e suas informações",

		customerPlansBillingCycles: "Ciclos de Cobrança e Estratégia de Preços",
		customerPlansBillingCyclesDescription:
			"Entender os ciclos de cobrança ajuda você a criar estratégias de preços eficazes que atraem diferentes segmentos de clientes:",
		customerPlansAvailableBillingCycles: "Ciclos de Cobrança Disponíveis",
		customerPlansMonthlyBilling: "Mensal",
		customerPlansMonthlyDescription:
			"Opção mais flexível para clientes. Menor compromisso, mais fácil de orçar mensalmente.",
		customerPlansQuarterlyBilling: "Trimestral (3 meses)",
		customerPlansQuarterlyDescription:
			"Bom equilíbrio entre compromisso e flexibilidade. Frequentemente usado com pequenos descontos.",
		customerPlansSemiAnnualBilling: "Semestral (6 meses)",
		customerPlansSemiAnnualDescription:
			"Compromisso de médio prazo. Adequado para clientes dedicados com descontos moderados.",
		customerPlansAnnualBilling: "Anual (12 meses)",
		customerPlansAnnualDescription:
			"Maior nível de compromisso. Melhor para clientes fiéis com descontos significativos.",
		customerPlansMonthlyAverageDisplay: "Exibição de Média Mensal",
		customerPlansMonthlyAverageFeature1:
			"Para planos não mensais, o sistema calcula automaticamente o equivalente mensal",
		customerPlansMonthlyAverageFeature2:
			"Ajuda os clientes a entender o custo mensal real de planos de longo prazo",
		customerPlansMonthlyAverageFeature3:
			"Exibido tanto no formulário de criação quanto na lista de planos",
		customerPlansMonthlyAverageFeature4:
			"Facilita a comparação de planos com diferentes ciclos de cobrança",
		customerPlansPricingStrategyTips: "Dicas de Estratégia de Preços",
		customerPlansPricingTip1:
			"Ofereça descontos para ciclos de cobrança mais longos para encorajar compromisso",
		customerPlansPricingTip2:
			"Use planos mensais para atrair clientes sensíveis ao preço",
		customerPlansPricingTip3: "Considere promoções sazonais com planos anuais",
		customerPlansPricingTip4:
			"Teste diferentes pontos de preço para encontrar taxas de conversão ótimas",
		customerPlansImagePlaceholder5:
			"Placeholder de imagem: Gráfico mostrando diferentes ciclos de cobrança e seus equivalentes mensais",

		customerPlansSessionLimits:
			"Limites de Sessões e Gerenciamento de Capacidade",
		customerPlansSessionLimitsDescription:
			"Limites semanais de sessões ajudam você a gerenciar a capacidade do estúdio e criar ofertas de serviços em camadas:",
		customerPlansUnderstandingSessionLimits: "Entendendo os Limites de Sessões",
		customerPlansOptionalFeature:
			"Recurso Opcional: Limites de sessões não são obrigatórios para todos os planos",
		customerPlansRange: "Faixa: Defina limites entre 1-20 sessões por semana",
		customerPlansEnforcement:
			"Aplicação: Sistema impede clientes de reservar além do seu limite",
		customerPlansFlexibility:
			"Flexibilidade: Limites são redefinidos semanalmente, permitindo padrões de uso consistentes",
		customerPlansStrategicUses: "Usos Estratégicos para Limites de Sessões",
		customerPlansCapacityManagement: "Gerenciamento de Capacidade",
		customerPlansCapacityDescription:
			"Controle a utilização do estúdio limitando usuários de alta frequência durante horários de pico",
		customerPlansTieredPricing: "Preços em Camadas",
		customerPlansTieredDescription:
			"Crie diferentes níveis de serviço (Básico: 2 sessões, Premium: 5 sessões, Elite: ilimitado)",
		customerPlansRevenueOptimization: "Otimização de Receita",
		customerPlansRevenueDescription:
			"Encoraje clientes a fazer upgrade para planos de nível superior para mais sessões",
		customerPlansFairAccess: "Acesso Justo",
		customerPlansFairAccessDescription:
			"Garanta que todos os clientes tenham acesso razoável aos horários de aula populares",
		customerPlansCommonStrategies: "Estratégias Comuns de Limite de Sessões",
		customerPlansExampleStructure: "Estrutura de Plano de Exemplo",
		customerPlansStarterPlan:
			"Plano Iniciante: 2 sessões/semana - Perfeito para iniciantes",
		customerPlansRegularPlan:
			"Plano Regular: 4 sessões/semana - Opção mais popular",
		customerPlansPremiumPlan:
			"Plano Premium: 8 sessões/semana - Para praticantes dedicados",
		customerPlansUnlimitedPlan:
			"Plano Ilimitado: Sem limite - Preço premium para acesso ilimitado",
		customerPlansImplementationConsiderations: "Considerações de Implementação",
		customerPlansMonitorUsage:
			"Monitore padrões de uso reais para definir limites realistas",
		customerPlansPeakHours:
			"Considere políticas de horários de pico vs. fora de pico",
		customerPlansCommunicateLimits:
			"Comunique limites claramente aos clientes durante a matrícula",
		customerPlansReviewAdjust:
			"Revise e ajuste limites baseado na capacidade e demanda do estúdio",
		customerPlansImagePlaceholder6:
			"Placeholder de imagem: Gráfico mostrando padrões de uso de sessões em diferentes tipos de planos",

		customerPlansMultiEstablishment: "Planos Multi-Unidade",
		customerPlansMultiEstablishmentDescription:
			"Para organizações com múltiplas localizações, planos específicos da unidade fornecem controle de acesso flexível:",
		customerPlansEstablishmentAccessOptions: "Opções de Acesso a Unidades",
		customerPlansAllEstablishmentsDefault: "Todas as Unidades (Padrão)",
		customerPlansAllEstablishmentsFeature1:
			"O plano pode ser usado em qualquer unidade da sua organização",
		customerPlansAllEstablishmentsFeature2:
			"Opção mais simples para a maioria dos negócios",
		customerPlansAllEstablishmentsFeature3: "Clientes têm máxima flexibilidade",
		customerPlansAllEstablishmentsFeature4:
			"Nenhuma configuração adicional necessária",
		customerPlansSpecificEstablishmentsTitle: "Unidades Específicos",
		customerPlansSpecificFeature1:
			"Restringir uso do plano a localizações selecionadas",
		customerPlansSpecificFeature2:
			"Perfeito para estratégias de preços específicas de localização",
		customerPlansSpecificFeature3:
			"Útil para camadas de localização premium vs. padrão",
		customerPlansSpecificFeature4:
			"Permite campanhas de marketing direcionadas",
		customerPlansUseCases: "Casos de Uso para Restrições de Unidade",
		customerPlansPremiumLocations: "Localizações Premium",
		customerPlansPremiumDescription:
			"Crie planos com preços mais altos para localizações premium com melhores comodidades",
		customerPlansGeographicPricing: "Preços Geográficos",
		customerPlansGeographicDescription:
			"Ajuste preços baseado nas condições do mercado local e competição",
		customerPlansCapacityManagementMulti: "Gerenciamento de Capacidade",
		customerPlansCapacityMultiDescription:
			"Direcione tráfego para localizações menos movimentadas com descontos específicos de localização",
		customerPlansSpecializedServices: "Serviços Especializados",
		customerPlansSpecializedDescription:
			"Ofereça equipamentos ou serviços especializados apenas em certas localizações",
		customerPlansManagingAssignments: "Gerenciando Atribuições de Unidades",
		customerPlansCheckboxInterface:
			"Use a interface de caixas de seleção para selecionar múltiplas unidades",
		customerPlansBadgesDisplay:
			"Unidades selecionados aparecem como badges abaixo do seletor",
		customerPlansRemoveIndividual:
			"Remova unidades individuais clicando no X em seu badge",
		customerPlansClearAll:
			'Use "Limpar Unidades" para remover todas as seleções e permitir todas as localizações',
		customerPlansBestPractices: "Melhores Práticas",
		customerPlansStartSimple:
			"Comece com planos de todos as unidades para simplicidade",
		customerPlansAddRestrictions:
			"Adicione restrições apenas quando houver uma necessidade clara de negócio",
		customerPlansCommunicateRestrictions:
			"Comunique restrições de localização claramente aos clientes",
		customerPlansOfferBoth:
			"Considere oferecer opções de planos tanto restritos quanto irrestritos",
		customerPlansImagePlaceholder7:
			"Placeholder de imagem: Mapa mostrando diferentes unidades com indicadores de acesso ao plano",

		// Enrollment Process Page
		enrollmentProcessOverview: "Visão Geral",
		enrollmentProcessOverviewDescription:
			"O processo de matrícula é o fluxo de trabalho principal para conectar clientes com os serviços do seu estúdio. Envolve selecionar um cliente, escolher um plano apropriado, selecionar horários e definir datas de matrícula. O sistema fornece validação abrangente, detecção de conflitos e fluxos de confirmação para garantir matrículas suaves.",
		enrollmentProcessKeyFeatures: "Principais Recursos",
		enrollmentProcessFeature1:
			"Suporte a matrícula multi-horário com criação em lote",
		enrollmentProcessFeature2:
			"Validação automática de compatibilidade de planos e filtragem de unidades",
		enrollmentProcessFeature3:
			"Detecção de sobreposição de horários e aplicação de limites de sessões semanais",
		enrollmentProcessFeature4:
			"Cálculo automático de data final baseado em ciclos de cobrança",
		enrollmentProcessFeature5:
			"Fluxo de confirmação abrangente com resumos detalhados",

		enrollmentProcessAccessing: "Acessando Gerenciamento de Matrículas",
		enrollmentProcessAccessingDescription:
			"Para acessar a seção de gerenciamento de matrículas:",
		enrollmentProcessAccessingStep1: "Navegue até o painel da sua organização",
		enrollmentProcessAccessingStep2:
			'Clique em "Matrículas" no menu de navegação principal',
		enrollmentProcessAccessingStep3:
			"Você verá uma lista abrangente de todas as matrículas com capacidades de busca e filtragem",
		enrollmentProcessAccessingStep4:
			'Use o botão "Criar Matrícula" para iniciar novas matrículas',
		enrollmentProcessPermissionRequirements: "Requisitos de Permissão",
		enrollmentProcessPermissionDescription:
			'Você precisa da permissão "MANAGE_ENROLLMENTS" para criar, editar ou excluir matrículas. Esta permissão é válida para toda a organização e permite gerenciar matrículas em todas as unidades aos quais você tem acesso.',
		enrollmentProcessImagePlaceholder1:
			"Placeholder de imagem: Captura de tela da página de gerenciamento de matrículas mostrando a lista e botão criar",

		enrollmentListManagement: "Gerenciamento da Lista de Matrículas",
		enrollmentListManagementDescription:
			"A lista de matrículas fornece uma visão abrangente de todas as matrículas de clientes com poderosas capacidades de busca e gerenciamento:",
		enrollmentListSearchFiltering: "Busca e Filtragem",
		enrollmentListRealTimeSearch:
			"Busca em Tempo Real: Busque por nome do cliente, email ou número de ID",
		enrollmentListDebouncedInput:
			"Entrada com Debounce: Atraso de 300ms previne chamadas excessivas à API",
		enrollmentListAutoPagination:
			"Reset Automático de Paginação: Retorna à primeira página quando a busca muda",
		enrollmentListLoadingIndicators:
			"Indicadores de Carregamento: Feedback visual durante operações de busca",
		enrollmentListTableInfo: "Exibição de Informações da Tabela",
		enrollmentListCustomerInfo: "Informações do Cliente",
		enrollmentListCustomerInfoDescription:
			"Nome completo, tipo de ID e número de ID para fácil identificação",
		enrollmentListPlanDetails: "Detalhes do Plano",
		enrollmentListPlanDetailsDescription:
			"Nome do plano, preços, ciclo de cobrança e médias mensais",
		enrollmentListScheduleInfo: "Informações do Horário",
		enrollmentListScheduleInfoDescription:
			"Nomes dos horários, tempos e padrões de recorrência",
		enrollmentListEnrollmentStatus: "Status da Matrícula",
		enrollmentListEnrollmentStatusDescription:
			"Status Ativo, Pausado, Cancelado ou Concluído com datas",
		enrollmentListAvailableActions: "Ações Disponíveis",
		enrollmentListEditAction: "Editar Matrícula",
		enrollmentListEditDescription:
			"Modificar detalhes da matrícula, alterar planos, atualizar horários ou ajustar datas",
		enrollmentListDeleteAction: "Excluir Matrícula",
		enrollmentListDeleteDescription:
			"Remover matrícula com diálogo de confirmação mostrando impacto nas sessões do horário",
		enrollmentListPaginationPerformance: "Paginação e Performance",
		enrollmentListConfigurablePageSize:
			"Tamanho de Página Configurável: Ajuste o número de matrículas por página",
		enrollmentListPaginationControls:
			"Controles de Paginação: Navegue através de listas grandes de matrículas",
		enrollmentListTotalCountDisplay:
			"Exibição de Contagem Total: Veja total de matrículas e informações da página atual",
		enrollmentListOptimizedLoading:
			"Carregamento Otimizado: Busca eficiente de dados com cache",
		enrollmentProcessImagePlaceholder2:
			"Placeholder de imagem: Captura de tela da lista de matrículas mostrando busca, colunas da tabela e botões de ação",

		enrollmentCreating: "Criando Novas Matrículas",
		enrollmentCreatingDescription:
			"O processo de criação de matrícula é dividido em quatro seções principais, cada uma com validação específica e recursos para garantir matrículas precisas e livres de conflitos:",
		enrollmentStep1: "Passo 1: Seleção do Cliente",
		enrollmentStep1Title: "Selecione o cliente para esta matrícula",
		enrollmentStep1Feature1:
			"Modal de Busca de Cliente: Busca avançada por nome, email ou número de ID",
		enrollmentStep1Feature2:
			"Resultados em Tempo Real: Resultados de busca instantâneos com detalhes abrangentes do cliente",
		enrollmentStep1Feature3:
			"Exibição de Informações do Cliente: Nome completo, detalhes de contato e identificação",
		enrollmentStep1Feature4:
			"Confirmação de Seleção: Exibição clara do cliente selecionado com opção de alteração",
		enrollmentStep2: "Passo 2: Seleção do Plano do Cliente",
		enrollmentStep2Title: "Escolha o plano apropriado para esta matrícula",
		enrollmentStep2Feature1:
			"Exibição de Informações do Plano: Nome, descrição, preços e ciclo de cobrança",
		enrollmentStep2Feature2:
			"Cálculo de Média Mensal: Cálculo automático para planos não mensais",
		enrollmentStep2Feature3:
			"Limites de Sessões Semanais: Exibição de limites de sessões quando aplicável",
		enrollmentStep2Feature4:
			"Filtragem de Unidades: Planos filtram horários disponíveis baseado em restrições da unidade",
		enrollmentStep3: "Passo 3: Seleção de Horários",
		enrollmentStep3Title: "Selecione um ou múltiplos horários para a matrícula",
		enrollmentStep3Feature1:
			"Suporte Multi-Horário: Selecione múltiplos horários no modo criar",
		enrollmentStep3Feature2:
			"Filtragem Baseada em Plano: Mostra apenas horários permitidos pelo plano selecionado",
		enrollmentStep3Feature3:
			"Informações do Horário: Nome, tempo, instrutor, unidade e capacidade",
		enrollmentStep3Feature4:
			"Detecção de Sobreposição: Validação em tempo real para conflitos de tempo de horário",
		enrollmentStep3Feature5:
			"Validação de Limite Semanal: Garante que o total de sessões não exceda os limites do plano",
		enrollmentStep4: "Passo 4: Data e Detalhes",
		enrollmentStep4Title:
			"Defina o período de matrícula e informações adicionais",
		enrollmentStep4Feature1:
			"Data de Início: Quando a matrícula começa (obrigatório)",
		enrollmentStep4Feature2:
			"Data Final Auto-calculada: Baseada no ciclo de cobrança do plano e data de início",
		enrollmentStep4Feature3:
			"Substituição Manual de Data Final: Opção para definir manualmente uma data final diferente",
		enrollmentStep4Feature4:
			"Seleção de Status: Ativo, Pausado, Cancelado ou Concluído",
		enrollmentStep4Feature5:
			"Campo de Notas: Informações adicionais sobre a matrícula",
		enrollmentProcessImagePlaceholder3:
			"Placeholder de imagem: Captura de tela do formulário de criação de matrícula mostrando todas as quatro seções",

		enrollmentValidation: "Validação e Detecção de Conflitos",
		enrollmentValidationDescription:
			"O sistema fornece validação abrangente para prevenir conflitos e garantir integridade da matrícula:",
		enrollmentScheduleOverlap: "Detecção de Sobreposição de Horários",
		enrollmentTimeConflictPrevention: "Prevenção de Conflitos de Tempo",
		enrollmentValidationFeature1:
			"Validação em Tempo Real: Verifica sobreposições de tempos de horário conforme você seleciona",
		enrollmentValidationFeature2:
			"Conflitos Específicos por Dia: Detecta conflitos em dias específicos da semana",
		enrollmentValidationFeature3:
			"Indicadores Visuais: Avisos claros quando conflitos são detectados",
		enrollmentValidationFeature4:
			"Prevenção de Envio: Bloqueia criação de matrícula quando conflitos existem",
		enrollmentWeeklyLimits: "Limites de Sessões Semanais",
		enrollmentPlanLimitEnforcement: "Aplicação de Limite do Plano",
		enrollmentLimitFeature1:
			"Cálculo Automático: Conta total de sessões semanais dos horários selecionados",
		enrollmentLimitFeature2:
			"Verificação de Limite do Plano: Compara contra o limite de sessões semanais do plano do cliente",
		enrollmentLimitFeature3:
			"Feedback em Tempo Real: Mostra contagem atual vs. limite conforme você seleciona horários",
		enrollmentLimitFeature4:
			"Prevenção de Limite Excedido: Previne matrícula quando limites são excedidos",
		enrollmentPlanCompatibility: "Validação de Compatibilidade do Plano",
		enrollmentEstablishmentFiltering: "Filtragem de Unidades",
		enrollmentCompatibilityFeature1:
			"Filtragem Automática: Mostra apenas horários das unidades permitidos pelo plano",
		enrollmentCompatibilityFeature2:
			"Planos de Todas as Unidades: Planos sem restrições mostram todos os horários",
		enrollmentCompatibilityFeature3:
			"Planos Restritos: Planos com limites da unidade filtram opções de horário",
		enrollmentCompatibilityFeature4:
			"Atualizações Dinâmicas: Lista de horários atualiza quando seleção de plano muda",
		enrollmentFormValidation: "Regras de Validação do Formulário",
		enrollmentFormRule1:
			"Campos Obrigatórios: Cliente, plano, pelo menos um horário e data de início",
		enrollmentFormRule2:
			"Validação de Data: Data final deve ser posterior à data de início quando definida manualmente",
		enrollmentFormRule3:
			"Validação de Status: Seleção de status apropriada para estado da matrícula",
		enrollmentFormRule4:
			"Comprimento de Notas: Campo de notas opcional com limites razoáveis de caracteres",
		enrollmentProcessImagePlaceholder4:
			"Placeholder de imagem: Captura de tela mostrando erros de validação e avisos de conflito no formulário de matrícula",

		enrollmentConfirmation: "Confirmação e Envio",
		enrollmentConfirmationDescription:
			"Antes de finalizar matrículas, o sistema fornece um fluxo de confirmação abrangente:",
		enrollmentConfirmationModal: "Modal de Confirmação de Matrícula",
		enrollmentConfirmationModalDescription:
			"Para novas matrículas, um modal de confirmação detalhado aparece antes do envio final:",
		enrollmentConfirmationDetails: "Detalhes de Confirmação",
		enrollmentConfirmationFeature1:
			"Resumo do Cliente: Nome completo, informações de contato e identificação",
		enrollmentConfirmationFeature2:
			"Informações do Plano: Plano selecionado com detalhes de preços e ciclo de cobrança",
		enrollmentConfirmationFeature3:
			"Resumo de Horários: Todos os horários selecionados com tempos e unidades",
		enrollmentConfirmationFeature4:
			"Período de Datas: Datas de início e fim com cálculo de duração",
		enrollmentConfirmationFeature5:
			"Total de Sessões Semanais: Resumo da contagem de sessões semanais",
		enrollmentBulkCreation: "Criação de Matrícula em Lote",
		enrollmentBulkCreationDescription:
			"Quando múltiplos horários são selecionados, o sistema cria matrículas eficientemente:",
		enrollmentBulkFeature1:
			"Chamada Única de API: Todas as matrículas criadas em uma operação em lote",
		enrollmentBulkFeature2:
			"Operação Atômica: Ou todas as matrículas são bem-sucedidas ou nenhuma é criada",
		enrollmentBulkFeature3:
			"Dados Consistentes: Mesmo cliente, plano e período de datas para todos os horários",
		enrollmentBulkFeature4:
			"Tratamento de Erros: Mensagens de erro claras se alguma matrícula falhar",
		enrollmentSuccessError: "Tratamento de Sucesso e Erro",
		enrollmentSuccessFlow: "Fluxo de Sucesso",
		enrollmentSuccessFlowDescription:
			"Notificação toast de sucesso, redirecionamento automático para lista de matrículas e invalidação de cache para dados atualizados",
		enrollmentErrorHandling: "Tratamento de Erros",
		enrollmentErrorHandlingDescription:
			"Mensagens de erro detalhadas, preservação do estado do formulário e orientação para resolver problemas",
		enrollmentSubmitButton: "Estados do Botão de Envio",
		enrollmentDynamicButtonBehavior: "Comportamento Dinâmico do Botão",
		enrollmentButtonFeature1:
			"Estados Desabilitados: Quando erros de validação existem ou durante envio",
		enrollmentButtonFeature2:
			"Indicador de Carregamento: Animação de spinner durante chamadas de API",
		enrollmentButtonFeature3:
			'Mudanças de Texto: "Criar Matrícula" vs "Salvar" para modos criar vs editar',
		enrollmentButtonFeature4:
			"Prevenção de Conflitos: Desabilitado quando sobreposições de horário ou limites excedidos",
		enrollmentProcessImagePlaceholder5:
			"Placeholder de imagem: Captura de tela do modal de confirmação de matrícula mostrando todos os detalhes da matrícula",

		enrollmentEditing: "Editando Matrículas",
		enrollmentEditingDescription:
			"A edição de matrícula fornece flexibilidade mantendo integridade de dados e prevenindo conflitos:",
		enrollmentEditModeDifferences: "Diferenças do Modo de Edição",
		enrollmentEditableFields: "Campos Editáveis",
		enrollmentEditableField1: "Seleção de plano do cliente",
		enrollmentEditableField2: "Atribuição de horário (seleção única)",
		enrollmentEditableField3: "Datas de início e fim",
		enrollmentEditableField4: "Status da matrícula",
		enrollmentEditableField5: "Notas e informações adicionais",
		enrollmentEditLimitations: "Limitações do Modo de Edição",
		enrollmentEditLimitation1: "Cliente não pode ser alterado",
		enrollmentEditLimitation2: "Seleção de horário único apenas",
		enrollmentEditLimitation3: "Nenhum modal de confirmação necessário",
		enrollmentEditLimitation4: "Envio direto após validação",
		enrollmentStatusManagement: "Gerenciamento de Status",
		enrollmentAvailableStatusOptions: "Opções de Status Disponíveis",
		enrollmentStatusActive:
			"Ativo: Cliente está ativamente matriculado e frequentando",
		enrollmentStatusPaused: "Pausado: Suspensão temporária da matrícula",
		enrollmentStatusCanceled:
			"Cancelado: Matrícula terminada antes da conclusão",
		enrollmentStatusCompleted: "Concluído: Matrícula finalizada com sucesso",
		enrollmentDataPreservation: "Preservação de Dados",
		enrollmentDataFeature1:
			"Pré-preenchimento do Formulário: Todos os valores atuais carregados automaticamente",
		enrollmentDataFeature2:
			"Integridade de Relacionamentos: Mantém conexões com horários e planos",
		enrollmentDataFeature3:
			"Preservação de Histórico: Dados de matrícula anteriores permanecem intactos",
		enrollmentDataFeature4:
			"Consistência de Validação: Mesmas regras de validação da criação",
		enrollmentProcessImagePlaceholder6:
			"Placeholder de imagem: Captura de tela do formulário de edição de matrícula mostrando campos pré-preenchidos e opções de status",
	},
	import: {
		steps: {
			upload: "Upload",
			mapping: "Mapeamento",
			preview: "Visualizar",
			import: "Importar",
		},
		customers: {
			title: "Importar Clientes",
			description:
				"Importe dados de clientes de um arquivo CSV para sua organização.",
		},
		upload: {
			title: "Upload de Arquivo CSV",
			description:
				"Selecione um arquivo CSV contendo dados de clientes para importar.",
			dragDrop: "Arraste e solte seu arquivo CSV aqui",
			supportedFormats: "Formatos suportados: arquivos CSV até 10MB",
			selectFile: "Selecionar Arquivo",
			sampleTemplate: "Precisa de um modelo?",
			sampleTemplateDescription:
				"Baixe nosso modelo CSV de exemplo para ver o formato esperado.",
			downloadTemplate: "Baixar Modelo",
			requirements: "Requisitos do Arquivo",
			requirement1: "A primeira linha deve conter cabeçalhos de coluna",
			requirement2: "Campos obrigatórios: Nome, Sobrenome",
			requirement3: "Tamanho máximo do arquivo: 10MB",
			requirement4: "Formato suportado: CSV (.csv)",
			success: "Arquivo enviado com sucesso",
			fileUploaded: "{{fileName}} ({{fileSize}} KB) enviado com sucesso",
			uploadAnother: "Enviar Outro",
			processing: "Processando arquivo...",
			processingDescription: "Aguarde enquanto analisamos seu arquivo CSV.",
			errorTitle: "Erro no Upload",
			errors: {
				invalidFileType: "Por favor, selecione um arquivo CSV válido",
				fileTooLarge: "O tamanho do arquivo excede o limite de {{maxSize}}MB",
				parseError: "Falha ao analisar CSV: {{error}}",
				emptyFile: "O arquivo CSV está vazio ou não contém dados",
				noHeaders: "O arquivo CSV deve conter cabeçalhos de coluna",
				unknownError: "Erro desconhecido",
				failedToParse: "Falha ao analisar CSV",
			},
		},
		template: {
			requiredFields: "Campos obrigatórios",
			optionalFields: "Campos opcionais",
		},
		mapping: {
			title: "Mapear Colunas",
			description:
				"Mapeie as colunas do seu arquivo CSV para os campos de cliente.",
			instructions: "Instruções de Mapeamento de Colunas",
			instructionsDescription:
				"Combine cada coluna do seu arquivo CSV com o campo de cliente correspondente. Campos obrigatórios devem ser mapeados para continuar.",
			requiredFieldsMissing: "Campos Obrigatórios Ausentes",
			requiredFieldsDescription:
				"Os seguintes campos obrigatórios devem ser mapeados antes de continuar:",
			missingFields: "Campos ausentes",
			columnMapping: "Mapeamento de Colunas",
			csvColumn: "Coluna CSV",
			mapTo: "Mapear para Campo",
			selectField: "Selecione um campo...",
			skipColumn: "Pular esta coluna",
			fieldDescription: "Descrição",
			noFieldSelected: "Nenhum campo selecionado",
			sampleData: "Visualização de Dados de Exemplo",
			required: "Obrigatório",
			optional: "Opcional",
			used: "(usado)",
		},
		preview: {
			title: "Visualizar Importação",
			description:
				"Revise os dados antes de importar para garantir a precisão.",
			startImport: "Iniciar Importação",
			totalRows: "Total de Linhas",
			validRows: "Linhas Válidas",
			invalidRows: "Linhas Inválidas",
			warningRows: "Avisos",
			invalidRowsFound: "Linhas Inválidas Encontradas",
			skipInvalidRows: "Pular linhas inválidas durante a importação",
			skipInvalidDescription:
				"Apenas linhas válidas serão importadas. Linhas inválidas serão puladas.",
			includeInvalidDescription:
				"A importação falhará se alguma linha inválida for encontrada.",
			dataPreview: "Visualização de Dados",
			showLess: "Mostrar Menos",
			showAll: "Mostrar Tudo ({{count}} linhas)",
			row: "Linha",
			status: "Status",
			issues: "Problemas",
			noIssues: "Sem problemas",
			confirmImport: {
				title: "Confirmar Importação",
				description:
					"Por favor, revise os detalhes da importação antes de prosseguir.",
				summary: "Resumo da Importação",
				options: "Opções de Importação",
				warning: "A importação falhará com linhas inválidas",
				warningDescription:
					"Você escolheu incluir linhas inválidas. A importação falhará se algum erro for encontrado.",
				confirm: "Iniciar Importação",
			},
		},
		validation: {
			required: "Este campo é obrigatório",
			invalidEmail: "Formato de email inválido",
			invalidPhone: "Formato de telefone inválido",
			invalidDate: "Formato de data inválido (use AAAA-MM-DD)",
			invalidEnum: "Valor inválido. Opções válidas: {{validValues}}",
			invalidCPF: "Formato de CPF inválido",
		},
		processing: {
			title: "Importando Dados",
			description: "Aguarde enquanto importamos os dados dos seus clientes.",
			failed: "Importação Falhou",
			tryAgain: "Tentar Novamente",
			success: "Importação Concluída com Sucesso",
			partialSuccess: "Importação Concluída com Problemas",
			totalProcessed: "Total Processado",
			imported: "Importado com Sucesso",
			errors: "Erros",
			skipped: "Pulados/Duplicados",
			issues: "Problemas de Importação",
			copyErrors: "Copiar Erros",
			downloadReport: "Baixar Relatório",
			errorsList: "Erros ({{count}})",
			duplicatesList: "Duplicados ({{count}})",
			row: "Linha",
			errorMessage: "Erro",
			field: "Campo",
			value: "Valor",
			existingCustomer: "Cliente Existente",
			importAnother: "Importar Outro Arquivo",
			viewCustomers: "Ver Clientes",
			reportHeaders: {
				type: "Tipo",
				row: "Linha",
				issue: "Problema",
				data: "Dados",
			},
			reportTypes: {
				error: "Erro",
				duplicate: "Duplicado",
			},
			reportTitle: "Relatório de Erros de Importação",
			reportSeparator: "===================",
			errorTemplate: "Erro {{index}}: Linha {{row}} - {{error}}",
		},
	},
	platformBilling: {
		title: "Assinatura",
		description: "Gerencie o plano de assinatura e cobrança da sua organização",
		currentPlan: "Plano Atual",
		changePlanButton: "Alterar Plano",
		selectPlan: "Selecionar Plano",
		availablePlans: "Planos Disponíveis",
		usage: "Uso",
		history: "Histórico de Cobrança",
		noSubscription: "Sem assinatura ativa",
		noSubscriptionDescription:
			"Escolha um plano para desbloquear todos os recursos para sua organização",
		billingCycle: {
			monthly: "Mensal",
			yearly: "Anual",
			label: "Ciclo de Cobrança",
		},
		perMonth: "/mês",
		perYear: "/ano",
		yearlyDiscount: "Economize {{percent}}%",
		features: "Recursos",
		entitlements: {
			max_establishments: "Unidades",
			max_staff_members: "Membros da Equipe",
			max_customers: "Clientes",
			max_schedules_per_month: "Agendas por Mês",
			monthly_sms_limit: "SMS por Mês",
			medical_records: "Prontuários Médicos",
			email_notifications: "Notificações por E-mail",
			sms_notifications: "Notificações por SMS",
			customer_import: "Importação de Clientes",
			analytics_dashboard: "Painel de Análises",
			api_access: "Acesso à API",
			custom_branding: "Marca Personalizada",
			priority_support: "Suporte Prioritário",
			unlimited: "Ilimitado",
			included: "Incluído",
			notIncluded: "Não incluído",
		},
		status: {
			active: "Ativo",
			trialing: "Período de Teste",
			pastDue: "Pagamento Atrasado",
			canceled: "Cancelado",
			paused: "Pausado",
			unpaid: "Não Pago",
			incomplete: "Incompleto",
			expired: "Expirado",
		},
		subscription: {
			currentPeriod: "Período Atual",
			endsOn: "Termina Em",
			renewsOn: "Renova Em",
			daysRemaining: "Dias Restantes",
			days: "dias",
			trialEndsOn: "Período de teste termina em {{date}}",
			canceledAt: "Cancelado em {{date}}",
			willCancelOn: "Será cancelado em {{date}}",
		},
		checkout: {
			loading: "Preparando checkout...",
			success: "Redirecionando para o checkout...",
			error: "Falha ao iniciar checkout. Por favor, tente novamente.",
			upgradeNow: "Fazer Upgrade Agora",
			startTrial: "Iniciar Teste Gratuito",
			subscribe: "Assinar",
		},
		portal: {
			loading: "Abrindo portal de assinatura...",
			success: "Abrindo portal de assinatura...",
			error: "Falha ao abrir portal de assinatura. Por favor, tente novamente.",
			manage: "Gerenciar Assinatura",
			updatePayment: "Atualizar Forma de Pagamento",
			viewInvoices: "Ver Vendas",
		},
		usageCard: {
			title: "Uso",
			description: "Acompanhe seu uso atual nos recursos do plano",
			of: "de",
			used: "usado",
		},
		llmUsage: {
			title: "Uso de IA",
			description: "Uso de tokens de {{periodStart}} a {{periodEnd}}",
			tokensUsed: "Tokens Utilizados",
			tokens: "tokens",
			byTaskType: "Por Tipo de Tarefa",
			byProvider: "Por Provedor",
			noUsage: "Nenhum uso de IA neste período de cobrança",
			taskTypes: {
				ANAMNESIS_SUMMARY: "Resumo de Anamnese",
				SESSION_PLAN_SUGGESTION: "Sugestão de Plano de Sessão",
				CUSTOMER_WORKOUT_RECOMMENDATION: "Recomendação de Treino",
			},
			providers: {
				openai: "OpenAI",
				anthropic: "Anthropic",
				bedrock: "AWS Bedrock",
			},
		},
		historyTable: {
			event: "Evento",
			date: "Data",
			details: "Detalhes",
			noHistory: "Sem histórico de cobrança ainda",
			events: {
				created: "Assinatura Criada",
				upgraded: "Plano Atualizado",
				downgraded: "Plano Reduzido",
				canceled: "Assinatura Cancelada",
				renewed: "Assinatura Renovada",
				payment_failed: "Pagamento Falhou",
				payment_succeeded: "Pagamento Bem-sucedido",
				trial_started: "Período de Teste Iniciado",
				trial_ended: "Período de Teste Encerrado",
				reactivated: "Assinatura Reativada",
			},
		},
		planCard: {
			current: "Plano Atual",
			recommended: "Recomendado",
			mostPopular: "Mais Popular",
			trialAvailable: "{{days}} dias de teste grátis",
		},
		free: {
			name: "Gratuito",
			description: "Para indivíduos começando",
		},
		starter: {
			name: "Iniciante",
			description: "Para pequenos estúdios começando",
		},
		professional: {
			name: "Profissional",
			description: "Para estúdios em crescimento com mais necessidades",
		},
		enterprise: {
			name: "Empresarial",
			description: "Para grandes estúdios com necessidades personalizadas",
		},
	},

	browserCompatibility: {
		title: "Navegador Desatualizado Detectado",
		message:
			"Seu navegador pode não suportar todos os recursos desta aplicação. Por favor, atualize seu navegador para uma melhor experiência.",
	},
};

export default translations;
